import { OrderType, StopStatus, Temperature, TripStatus, VerifiedMethod } from "services/enums";
import { AssignedTrips } from "services/types";

export const donnieAndWalMartDemoLoad: AssignedTrips = {
    trips: [
        {
            id: 18566439,
            loadNumber: "DEMO",
            driverId: "29071",
            truckId: "3924",
            trailerId: "2945",
            dueOutCompany: "DOT FOODS - IL",
            dueOutCity: "Mount Sterling",
            dueOutState: "IL",
            dueOut: new Date("2021-03-13T13:00:00"),
            status: TripStatus.Ready,
            firstAppointmentCompany: "S & W WHOLESALE MEATS",
            firstAppointmentCity: "Hammond",
            firstAppointmentState: "LA",
            firstAppointmentTime: new Date("2021-03-15T05:00:00"),
            trailerType: null,
            trailerDcLocation: 1,
            isTtr: false,
            isDea: true,
            summary: {
                deliveryCount: 5,
                deliveryWeight: 32728,
                deliveryCube: 1276,
                deliveryPieces: 1942,
                deliveryLineItems: 401,
                pickupCount: 3,
                pickupWeight: 0,
                pickupCube: 0,
                pickupPieces: 0,
                pickupItems: 0,
                returnCount: 1,
                returnWeight: 0,
                returnCube: 0,
                returnPieces: 0,
                returnItems: 0
            },
            updated: new Date("2021-03-15T05:00:00")
        },
        {
            id: 21558631,
            loadNumber: "9564884",
            driverId: "42618",
            truckId: "4161",
            trailerId: "4456",
            dueOutCompany: "DOT FOODS - IL",
            dueOutCity: "Mount Sterling",
            dueOutState: "IL",
            dueOut: new Date("2023-11-28T08:00:00"),
            status: TripStatus.Ready,
            firstAppointmentCompany: "WALMART/GDC #6077",
            firstAppointmentCity: "Moberly",
            firstAppointmentState: "MO",
            firstAppointmentTime: new Date("2023-11-28T12:01:00"),
            trailerType: null,
            trailerDcLocation: 1,
            updated: new Date("2023-11-27T11:30:19.147"),
            isTtr: false,
            isDea: false,
            summary: {
                deliveryCount: 1,
                deliveryWeight: 29167,
                deliveryCube: 1353,
                deliveryPieces: 3422,
                deliveryLineItems: 60,
                pickupCount: 1,
                pickupWeight: 114,
                pickupCube: 3,
                pickupPieces: 3260,
                pickupItems: 13,
                returnCount: 0,
                returnWeight: 0,
                returnCube: 0,
                returnPieces: 0,
                returnItems: 0
            }
        }
    ],
    appointments: [
        {
            id: 9059,
            tripId: 18566439,
            companyId: "DC01",
            stopEvent: "LLD",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2022-05-01T05:00:00"),
            orderTemperatures: [],
            orderTypes: [],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 8696,
            tripId: 18566439,
            companyId: "02024100", //S & W WHOLESALE MEATS
            stopEvent: "LUL",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2022-05-01T12:30:00"),
            orderTemperatures: [
                "Frozen"
            ],
            orderTypes: [
                OrderType.SubjectToCount
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 18637,
                dryLineItems: 180,
                dryPieces: 1475,
                refrigeratedWeight: 3716,
                refrigeratedLineItems: 33,
                refrigeratedPieces: 249,
                frozenWeight: 10685,
                frozenLineItems: 128,
                frozenPieces: 725
            }
        },
        {
            id: 3320,
            tripId: 18566439,
            companyId: "23508301", //PFS/PACIFIC NW
            stopEvent: "LUL",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2022-05-01T17:00:00"),
            orderTemperatures: [
                "Dry",
                "Frozen",
                "Refrigerated"
            ],
            orderTypes: [
                OrderType.Regular
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 31087,
                dryLineItems: 101,
                dryPieces: 1423,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 9389,
            tripId: 18566439,
            companyId: "21243901", //S&L Produce
            stopEvent: "LUL",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2022-05-02T09:15:00"),
            orderTemperatures: [
                "Frozen"
            ],
            orderTypes: [
                OrderType.Regular
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 3376,
                dryLineItems: 89,
                dryPieces: 205,
                refrigeratedWeight: 786,
                refrigeratedLineItems: 12,
                refrigeratedPieces: 48,
                frozenWeight: 5120,
                frozenLineItems: 86,
                frozenPieces: 294
            }
        },
        {
            id: 9387,
            tripId: 18566439,
            companyId: "12592500", //FARM BOY FOOD SERVICE
            stopEvent: "LUL",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2022-05-02T13:45:00"),
            orderTemperatures: [
                "Frozen"
            ],
            orderTypes: [
                OrderType.Regular
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 10814,
                dryLineItems: 131,
                dryPieces: 673,
                refrigeratedWeight: 906,
                refrigeratedLineItems: 12,
                refrigeratedPieces: 67,
                frozenWeight: 5834,
                frozenLineItems: 69,
                frozenPieces: 413
            }
        },
        {
            id: 3321,
            tripId: 18566439,
            companyId: "61242301", //PACIFIC FOODS OF OR
            stopEvent: "LLD",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2022-05-02T17:30:00"),
            orderTemperatures: [],
            orderTypes: [
                OrderType.VendorPickup
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 9060,
            tripId: 18566439,
            companyId: "DC01",
            stopEvent: "LUL",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2022-05-02T20:00:00"),
            orderTemperatures: [],
            orderTypes: [],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2310919,
            tripId: 21558631,
            companyId: "DC01",
            stopEvent: "LLD",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2023-11-28T08:01:00"),
            orderTemperatures: [],
            orderTypes: [],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2310921,
            tripId: 21558631,
            companyId: "12064408",
            stopEvent: "LLD",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2023-11-28T16:00:00"),
            orderTemperatures: [
                "Dry"
            ],
            orderTypes: [
                OrderType.VendorPickup
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 26119,
                dryLineItems: 13,
                dryPieces: 3442,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2310920,
            tripId: 21558631,
            companyId: "DC01",
            stopEvent: "LUL",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2023-11-28T21:00:00"),
            orderTemperatures: [],
            orderTypes: [],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2310922,
            tripId: 21558631,
            companyId: "24016414",
            stopEvent: "LUL",
            stopStatus: StopStatus.Pending,
            appointmentTime: new Date("2023-11-28T12:01:00"),
            orderTemperatures: [
                "Refrigerated",
                "Frozen"
            ],
            orderTypes: [
                OrderType.Regular
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 299,
                dryLineItems: 2,
                dryPieces: 130,
                refrigeratedWeight: 16557,
                refrigeratedLineItems: 15,
                refrigeratedPieces: 1398,
                frozenWeight: 12310,
                frozenLineItems: 43,
                frozenPieces: 1894
            }
        },
        {
            id: 2307992,
            tripId: 21558719,
            companyId: "DC01",
            stopEvent: "LLD",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2023-11-26T18:02:00"),
            orderTemperatures: [],
            orderTypes: [],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2307994,
            tripId: 21558719,
            companyId: "14100002",
            stopEvent: "LLD",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2023-11-27T11:00:00"),
            orderTemperatures: [
                "Dry"
            ],
            orderTypes: [
                OrderType.VendorPickup
            ],
            trailerTemperatures: {
                nose: {
                    isSet: false,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: false,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: false,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 28407,
                dryLineItems: 13,
                dryPieces: 2276,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2307993,
            tripId: 21558719,
            companyId: "DC01",
            stopEvent: "LUL",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2023-11-27T19:04:00"),
            orderTemperatures: [],
            orderTypes: [],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                tail: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                },
                middle: {
                    isSet: true,
                    setValue: null,
                    actualValue: null
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 0,
                refrigeratedLineItems: 0,
                refrigeratedPieces: 0,
                frozenWeight: 0,
                frozenLineItems: 0,
                frozenPieces: 0
            }
        },
        {
            id: 2307995,
            tripId: 21558719,
            companyId: "14012101",
            stopEvent: "LUL",
            stopStatus: StopStatus.Complete,
            appointmentTime: new Date("2023-11-27T00:00:00"),
            orderTemperatures: [
                "Refrigerated",
                "Frozen"
            ],
            orderTypes: [
                OrderType.SubjectToCount
            ],
            trailerTemperatures: {
                nose: {
                    isSet: true,
                    setValue: 31,
                    actualValue: 31
                },
                tail: {
                    isSet: true,
                    setValue: 0,
                    actualValue: 2
                },
                middle: {
                    isSet: true,
                    setValue: 0,
                    actualValue: 3
                }
            },
            summary: {
                dryWeight: 0,
                dryLineItems: 0,
                dryPieces: 0,
                refrigeratedWeight: 9738,
                refrigeratedLineItems: 38,
                refrigeratedPieces: 1462,
                frozenWeight: 21023,
                frozenLineItems: 35,
                frozenPieces: 1266
            }
        }
    ],
    appointmentEquipment: [
        {
            id: 73842,
            stopId: 9392,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73852,
            stopId: 9392,
            equipmentTypeId: 2,
            quantityIn: 3,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73862,
            stopId: 9392,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73872,
            stopId: 9392,
            equipmentTypeId: 4,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73882,
            stopId: 9389,
            equipmentTypeId: 5,
            quantityIn: 7,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73842,
            stopId: 9389,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73852,
            stopId: 9389,
            equipmentTypeId: 2,
            quantityIn: 3,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73862,
            stopId: 9389,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73872,
            stopId: 9389,
            equipmentTypeId: 4,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73882,
            stopId: 9389,
            equipmentTypeId: 5,
            quantityIn: 7,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73840,
            stopId: 9387,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73850,
            stopId: 9387,
            equipmentTypeId: 2,
            quantityIn: 3,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73860,
            stopId: 9387,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73870,
            stopId: 9387,
            equipmentTypeId: 4,
            quantityIn: 17,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73880,
            stopId: 9387,
            equipmentTypeId: 5,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73838,
            stopId: 3320,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73848,
            stopId: 3320,
            equipmentTypeId: 2,
            quantityIn: 3,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73858,
            stopId: 3320,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73868,
            stopId: 3320,
            equipmentTypeId: 4,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73878,
            stopId: 3320,
            equipmentTypeId: 5,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73845,
            stopId: 8696,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73853,
            stopId: 8696,
            equipmentTypeId: 2,
            quantityIn: 3,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73866,
            stopId: 8696,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 73881,
            stopId: 8696,
            equipmentTypeId: 4,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14422974,
            stopId: 2307995,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: 1,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14422975,
            stopId: 2307995,
            equipmentTypeId: 2,
            quantityIn: 1,
            quantityOut: 1,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14422976,
            stopId: 2307995,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: 0,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14422977,
            stopId: 2307995,
            equipmentTypeId: 4,
            quantityIn: 20,
            quantityOut: 0,
            equipmentShortReasonId: 4,
            shortComment: null
        },
        {
            id: 14426694,
            stopId: 2310922,
            equipmentTypeId: 1,
            quantityIn: 1,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14426695,
            stopId: 2310922,
            equipmentTypeId: 2,
            quantityIn: 2,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14426696,
            stopId: 2310922,
            equipmentTypeId: 3,
            quantityIn: 0,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        },
        {
            id: 14426697,
            stopId: 2310922,
            equipmentTypeId: 4,
            quantityIn: 26,
            quantityOut: null,
            equipmentShortReasonId: null,
            shortComment: null
        }
    ],
    orders: [
        {
            id: 9457,
            orderNumber: "2873324",
            stopId: 9389,
            orderDate: new Date("2021-03-14T10:33:00"),
            deliveryDate: new Date("2021-03-14T00:00:00"),
            soldToId: "21243901",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "21243901",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 9458,
            orderNumber: "2884197",
            stopId: 9387,
            orderDate: new Date("2021-03-14T10:34:00"),
            deliveryDate: new Date("2021-03-15T00:00:00"),
            soldToId: "12592500",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "12592500",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 3955,
            orderNumber: "1245746",
            stopId: 3320,
            orderDate: new Date("2021-02-18T06:00:00"),
            deliveryDate: new Date("2021-02-19T00:00:00"),
            soldToId: "23508301",
            boughtFromId: "DC16",
            orderType: OrderType.Regular,
            temperature: Temperature.Refrigerated,
            consignee: "23508301",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 4000,
            orderNumber: "2345678",
            stopId: 3320,
            orderDate: new Date("2021-02-18T06:00:00"),
            deliveryDate: new Date("2021-02-19T00:00:00"),
            soldToId: "23508301",
            boughtFromId: "DC16",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "23508301",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 4001,
            orderNumber: "3456789",
            stopId: 3320,
            orderDate: new Date("2021-02-18T06:00:00"),
            deliveryDate: new Date("2021-02-19T00:00:00"),
            soldToId: "23508301",
            boughtFromId: "DC16",
            orderType: OrderType.Regular,
            temperature: Temperature.Dry,
            consignee: "23508301",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 3956,
            orderNumber: "167288-001",
            stopId: 3321,
            orderDate: new Date("2021-02-19T11:00:00"),
            deliveryDate: new Date("2021-02-19T00:00:00"),
            soldToId: "DC01",
            boughtFromId: "61242301",
            orderType: OrderType.VendorPickup,
            temperature: Temperature.Dry,
            consignee: "DC01    ",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "CONF PRE",
            totalPallets: 0,
            expectancyDate: new Date("2020-02-28T21:00:00"),
            signatureId: null
        },
        {
            id: 3957,
            orderNumber: "167289-001",
            stopId: 3321,
            orderDate: new Date("2021-02-19T11:00:00"),
            deliveryDate: new Date("2021-02-19T00:00:00"),
            soldToId: "DC01",
            boughtFromId: "61242301",
            orderType: OrderType.VendorPickup,
            temperature: Temperature.Dry,
            consignee: "DC01    ",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "CONF PRE",
            totalPallets: 0,
            expectancyDate: new Date("2020-02-28T21:00:00"),
            signatureId: null
        },
        {
            id: 8509,
            orderNumber: "2396520",
            stopId: 8696,
            orderDate: new Date("2021-03-14T10:56:28.003"),
            deliveryDate: new Date("2021-03-15T00:00:00"),
            soldToId: "02024100",
            boughtFromId: "DC19",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Frozen,
            consignee: "02024100",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2266252,
            orderNumber: "7110890",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266253,
            orderNumber: "7350064",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Frozen,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266254,
            orderNumber: "7376176",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266255,
            orderNumber: "7376178",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Frozen,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266256,
            orderNumber: "7376190",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Frozen,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266257,
            orderNumber: "7376200",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Frozen,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266258,
            orderNumber: "7376908",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266259,
            orderNumber: "7475548",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266260,
            orderNumber: "7475554",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2270590,
            orderNumber: "7523789",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:01:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270591,
            orderNumber: "7524734",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:02:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270592,
            orderNumber: "7525385",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:03:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270593,
            orderNumber: "7525515",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:04:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270594,
            orderNumber: "7525913",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:05:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Refrigerated,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270595,
            orderNumber: "7526007",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:06:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270596,
            orderNumber: "7526270",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:07:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.TemperatureSensitive,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270597,
            orderNumber: "7526290",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:08:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270598,
            orderNumber: "7526494",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:09:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270599,
            orderNumber: "7526740",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:10:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270600,
            orderNumber: "7528614",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:11:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270601,
            orderNumber: "7530224",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:12:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270602,
            orderNumber: "7532021",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:13:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Refrigerated,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270603,
            orderNumber: "7532085",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:14:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Refrigerated,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270604,
            orderNumber: "7532987",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:15:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270605,
            orderNumber: "7535555",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:16:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.TemperatureSensitive,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2266261,
            orderNumber: "7537323",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2270606,
            orderNumber: "7539238",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:17:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270607,
            orderNumber: "7539431",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:18:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270608,
            orderNumber: "7539948",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:19:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270609,
            orderNumber: "7540181",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:20:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270610,
            orderNumber: "7540245",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:21:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270611,
            orderNumber: "7545246",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:25:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270612,
            orderNumber: "7550569",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:22:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270613,
            orderNumber: "7550599",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:23:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270614,
            orderNumber: "7553874",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:24:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Refrigerated,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270615,
            orderNumber: "7560169",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:26:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2270616,
            orderNumber: "7561319",
            stopId: 2310922,
            orderDate: new Date("2023-11-28T08:27:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "24016400",
            boughtFromId: "DC01",
            orderType: OrderType.Regular,
            temperature: Temperature.Frozen,
            consignee: "24016414",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: null
        },
        {
            id: 2266262,
            orderNumber: "7562876",
            stopId: 2307995,
            orderDate: new Date("2023-11-26T18:02:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "14012100",
            boughtFromId: "DC01",
            orderType: OrderType.SubjectToCount,
            temperature: Temperature.Refrigerated,
            consignee: "14012101",
            totalWeight: 0,
            totalItems: 0,
            totalPieces: 0,
            totalCube: 0,
            releaseNumber: "",
            totalPallets: 0,
            expectancyDate: null,
            signatureId: 638778
        },
        {
            id: 2266263,
            orderNumber: "887098-001",
            stopId: 2307994,
            orderDate: new Date("2023-11-27T11:00:00"),
            deliveryDate: new Date("2023-11-27T00:00:00"),
            soldToId: "DC01",
            boughtFromId: "14100002",
            orderType: OrderType.VendorPickup,
            temperature: Temperature.Dry,
            consignee: "DC01    ",
            totalWeight: 28407.76,
            totalItems: 13,
            totalPieces: 2276,
            totalCube: 1019.1203,
            releaseNumber: "emcfm",
            totalPallets: 22,
            expectancyDate: new Date("2020-12-03T23:59:00"),
            signatureId: null
        },
        {
            id: 2270617,
            orderNumber: "891955-001",
            stopId: 2310921,
            orderDate: new Date("2023-11-28T16:00:00"),
            deliveryDate: new Date("2023-11-28T00:00:00"),
            soldToId: "DC01",
            boughtFromId: "12064408",
            orderType: OrderType.VendorPickup,
            temperature: Temperature.Dry,
            consignee: "DC01    ",
            totalWeight: 26119.19,
            totalItems: 13,
            totalPieces: 3260,
            totalCube: 855.2764,
            releaseNumber: "emsentslf",
            totalPallets: 21,
            expectancyDate: new Date("2020-12-03T23:59:00"),
            signatureId: null
        }
    ],
    orderLicensePlates: [
        {
            id: 38217,
            licensePlateId: 6844763708115800,
            orderId: 3955
        },
        {
            id: 38219,
            licensePlateId: 6844763708124819,
            orderId: 3955
        },
        {
            id: 10513,
            licensePlateId: 6844763681600607,
            orderId: 9457
        },
        {
            id: 38220,
            licensePlateId: 6844763708132890,
            orderId: 3955
        },
        {
            id: 10502,
            licensePlateId: 6844763681592643,
            orderId: 9457
        },
        {
            id: 10511,
            licensePlateId: 6844763681600485,
            orderId: 9457
        },
        {
            id: 10492,
            licensePlateId: 6844763675402972,
            orderId: 9457
        },
        {
            id: 10529,
            licensePlateId: 6844763681602748,
            orderId: 9457
        },
        {
            id: 10503,
            licensePlateId: 6844763681592711,
            orderId: 9458
        },
        {
            id: 10512,
            licensePlateId: 6844763681600539,
            orderId: 9458
        },
        {
            id: 10520,
            licensePlateId: 6844763681601666,
            orderId: 9458
        },
        {
            id: 10491,
            licensePlateId: 6844763675402958,
            orderId: 9458
        },
        {
            id: 10534,
            licensePlateId: 6844763681602885,
            orderId: 9458
        },
        {
            id: 10508,
            licensePlateId: 6844763681600102,
            orderId: 9458
        },
        {
            id: 139,
            licensePlateId: 6844763679618416,
            orderId: 3955
        },
        {
            id: 55559,
            licensePlateId: 6844763668584258,
            orderId: 4000
        },
        {
            id: 1,
            licensePlateId: 6844763674010130,
            orderId: 4001
        },
        {
            id: 4052,
            licensePlateId: 6844763625912421,
            orderId: 8509
        },
        {
            id: 4063,
            licensePlateId: 6844763681085350,
            orderId: 8509
        },
        {
            id: 4064,
            licensePlateId: 6844763681085978,
            orderId: 8509
        },
        {
            id: 4060,
            licensePlateId: 6844763681076037,
            orderId: 8509
        },
        {
            id: 4059,
            licensePlateId: 6844763681073838,
            orderId: 8509
        },
        {
            id: 4073,
            licensePlateId: 6844763681093058,
            orderId: 8509
        },
        {
            id: 4032,
            licensePlateId: 6844763411645779,
            orderId: 8509
        },
        {
            id: 4067,
            licensePlateId: 6844763681087415,
            orderId: 8509
        },
        {
            id: 4066,
            licensePlateId: 6844763681086555,
            orderId: 8509
        },
        {
            id: 4069,
            licensePlateId: 6844763681088931,
            orderId: 8509
        },
        {
            id: 4033,
            licensePlateId: 6844763411645786,
            orderId: 8509
        },
        {
            id: 4065,
            licensePlateId: 6844763681086296,
            orderId: 8509
        },
        {
            id: 4036,
            licensePlateId: 6844763580671470,
            orderId: 8509
        },
        {
            id: 4050,
            licensePlateId: 6844763580923401,
            orderId: 8509
        },
        {
            id: 4068,
            licensePlateId: 6844763681087712,
            orderId: 8509
        },
        {
            id: 4053,
            licensePlateId: 6844763654501726,
            orderId: 8509
        },
        {
            id: 4065,
            licensePlateId: 6844763681086296,
            orderId: 8509
        },
        {
            id: 4034,
            licensePlateId: 6844763411645793,
            orderId: 8509
        },
        {
            id: 12726251,
            licensePlateId: 6844763907920717,
            orderId: 2266261
        },
        {
            id: 12726252,
            licensePlateId: 6844763907920748,
            orderId: 2266262
        },
        {
            id: 12726253,
            licensePlateId: 6844763907920809,
            orderId: 2266261
        },
        {
            id: 12726254,
            licensePlateId: 6844764029108991,
            orderId: 2266257
        },
        {
            id: 12726255,
            licensePlateId: 6844764037668852,
            orderId: 2266255
        },
        {
            id: 12726256,
            licensePlateId: 6844764037668876,
            orderId: 2266255
        },
        {
            id: 12726257,
            licensePlateId: 6844764037668883,
            orderId: 2266255
        },
        {
            id: 12726258,
            licensePlateId: 6844764037668906,
            orderId: 2266255
        },
        {
            id: 12726259,
            licensePlateId: 6844764037668937,
            orderId: 2266255
        },
        {
            id: 12726260,
            licensePlateId: 6844764037668944,
            orderId: 2266255
        },
        {
            id: 12726261,
            licensePlateId: 6844764040447895,
            orderId: 2266257
        },
        {
            id: 12726262,
            licensePlateId: 6844764047049375,
            orderId: 2266255
        },
        {
            id: 12726263,
            licensePlateId: 6844764072205463,
            orderId: 2266256
        },
        {
            id: 12726264,
            licensePlateId: 6844764076644466,
            orderId: 2266256
        },
        {
            id: 12726265,
            licensePlateId: 6844764081172671,
            orderId: 2266254
        },
        {
            id: 12726266,
            licensePlateId: 6844764081172732,
            orderId: 2266262
        },
        {
            id: 12726267,
            licensePlateId: 6844764081172961,
            orderId: 2266259
        },
        {
            id: 12726268,
            licensePlateId: 6844764081173456,
            orderId: 2266258
        },
        {
            id: 12726269,
            licensePlateId: 6844764081173623,
            orderId: 2266252
        },
        {
            id: 12726270,
            licensePlateId: 6844764081176563,
            orderId: 2266262
        },
        {
            id: 12726271,
            licensePlateId: 6844764081178949,
            orderId: 2266261
        },
        {
            id: 12726272,
            licensePlateId: 6844764081178956,
            orderId: 2266260
        },
        {
            id: 12726273,
            licensePlateId: 6844764081182007,
            orderId: 2266259
        },
        {
            id: 12726274,
            licensePlateId: 6844764081183783,
            orderId: 2266262
        },
        {
            id: 12726275,
            licensePlateId: 6844764081190682,
            orderId: 2266262
        },
        {
            id: 12726276,
            licensePlateId: 6844764081194277,
            orderId: 2266262
        },
        {
            id: 12726277,
            licensePlateId: 6844764081198510,
            orderId: 2266256
        },
        {
            id: 12726278,
            licensePlateId: 6844764081198572,
            orderId: 2266257
        },
        {
            id: 12726279,
            licensePlateId: 6844764081198893,
            orderId: 2266256
        },
        {
            id: 12726280,
            licensePlateId: 6844764081199340,
            orderId: 2266255
        },
        {
            id: 12726281,
            licensePlateId: 6844764081200626,
            orderId: 2266257
        },
        {
            id: 12726282,
            licensePlateId: 6844764081200640,
            orderId: 2266256
        },
        {
            id: 12726283,
            licensePlateId: 6844764081201104,
            orderId: 2266255
        },
        {
            id: 12726284,
            licensePlateId: 6844764081201265,
            orderId: 2266257
        },
        {
            id: 12726285,
            licensePlateId: 6844764081202156,
            orderId: 2266256
        },
        {
            id: 12726286,
            licensePlateId: 6844764081203191,
            orderId: 2266256
        },
        {
            id: 12726287,
            licensePlateId: 6844764081203436,
            orderId: 2266257
        },
        {
            id: 12726288,
            licensePlateId: 6844764081203450,
            orderId: 2266257
        },
        {
            id: 12726289,
            licensePlateId: 6844764081203849,
            orderId: 2266256
        },
        {
            id: 12726290,
            licensePlateId: 6844764081203887,
            orderId: 2266253
        },
        {
            id: 12726291,
            licensePlateId: 6844764081205140,
            orderId: 2266253
        },
        {
            id: 12726292,
            licensePlateId: 6844764081207113,
            orderId: 2266256
        },
        {
            id: 12726293,
            licensePlateId: 6844764081220358,
            orderId: 2266257
        },
        {
            id: 12752856,
            licensePlateId: 6844763815599265,
            orderId: 2270614
        },
        {
            id: 12752857,
            licensePlateId: 6844763818732812,
            orderId: 2270614
        },
        {
            id: 12752858,
            licensePlateId: 6844763820401737,
            orderId: 2270614
        },
        {
            id: 12752859,
            licensePlateId: 6844763830676026,
            orderId: 2270614
        },
        {
            id: 12752860,
            licensePlateId: 6844763830765751,
            orderId: 2270614
        },
        {
            id: 12752861,
            licensePlateId: 6844763907938484,
            orderId: 2270614
        },
        {
            id: 12752862,
            licensePlateId: 6844764004438341,
            orderId: 2270609
        },
        {
            id: 12752863,
            licensePlateId: 6844764039529076,
            orderId: 2270606
        },
        {
            id: 12752864,
            licensePlateId: 6844764046195271,
            orderId: 2270609
        },
        {
            id: 12752865,
            licensePlateId: 6844764072056959,
            orderId: 2270609
        },
        {
            id: 12752866,
            licensePlateId: 6844764081408985,
            orderId: 2270603
        },
        {
            id: 12752867,
            licensePlateId: 6844764081409579,
            orderId: 2270602
        },
        {
            id: 12752868,
            licensePlateId: 6844764081419011,
            orderId: 2270603
        },
        {
            id: 12752869,
            licensePlateId: 6844764081419486,
            orderId: 2270594
        },
        {
            id: 12752870,
            licensePlateId: 6844764081420024,
            orderId: 2270602
        },
        {
            id: 12752871,
            licensePlateId: 6844764081433130,
            orderId: 2270605
        },
        {
            id: 12752872,
            licensePlateId: 6844764081433338,
            orderId: 2270596
        },
        {
            id: 12752873,
            licensePlateId: 6844764081444716,
            orderId: 2270599
        },
        {
            id: 12752874,
            licensePlateId: 6844764081444808,
            orderId: 2270595
        },
        {
            id: 12752875,
            licensePlateId: 6844764081445096,
            orderId: 2270606
        },
        {
            id: 12752876,
            licensePlateId: 6844764081445119,
            orderId: 2270610
        },
        {
            id: 12752877,
            licensePlateId: 6844764081445171,
            orderId: 2270611
        },
        {
            id: 12752878,
            licensePlateId: 6844764081445324,
            orderId: 2270615
        },
        {
            id: 12752879,
            licensePlateId: 6844764081446130,
            orderId: 2270613
        },
        {
            id: 12752880,
            licensePlateId: 6844764081446161,
            orderId: 2270613
        },
        {
            id: 12752881,
            licensePlateId: 6844764081446826,
            orderId: 2270611
        },
        {
            id: 12752882,
            licensePlateId: 6844764081446901,
            orderId: 2270606
        },
        {
            id: 12752883,
            licensePlateId: 6844764081447182,
            orderId: 2270592
        },
        {
            id: 12752884,
            licensePlateId: 6844764081447571,
            orderId: 2270612
        },
        {
            id: 12752885,
            licensePlateId: 6844764081447618,
            orderId: 2270612
        },
        {
            id: 12752886,
            licensePlateId: 6844764081447656,
            orderId: 2270616
        },
        {
            id: 12752887,
            licensePlateId: 6844764081448080,
            orderId: 2270609
        },
        {
            id: 12752888,
            licensePlateId: 6844764081448097,
            orderId: 2270590
        },
        {
            id: 12752889,
            licensePlateId: 6844764081448165,
            orderId: 2270601
        },
        {
            id: 12752890,
            licensePlateId: 6844764081449827,
            orderId: 2270593
        },
        {
            id: 12752891,
            licensePlateId: 6844764081451721,
            orderId: 2270613
        },
        {
            id: 12752892,
            licensePlateId: 6844764081452728,
            orderId: 2270591
        },
        {
            id: 12752893,
            licensePlateId: 6844764081456146,
            orderId: 2270597
        },
        {
            id: 12752894,
            licensePlateId: 6844764081456573,
            orderId: 2270609
        },
        {
            id: 12752895,
            licensePlateId: 6844764081457426,
            orderId: 2270607
        },
        {
            id: 12752896,
            licensePlateId: 6844764081457716,
            orderId: 2270600
        },
        {
            id: 12752897,
            licensePlateId: 6844764081458003,
            orderId: 2270608
        },
        {
            id: 12752898,
            licensePlateId: 6844764081458621,
            orderId: 2270598
        },
        {
            id: 12752899,
            licensePlateId: 6844764081460075,
            orderId: 2270612
        },
        {
            id: 12752900,
            licensePlateId: 6844764081463762,
            orderId: 2270604
        },
        {
            id: 12752901,
            licensePlateId: 6844764081480226,
            orderId: 2270616
        }
    ],
    orderItems: [
        {
            id: 664718,
            orderId: 3955,
            lineItemId: 462080,
            customerPoNumber: "8KCNIGWV",
            orderedQuantity: 15,
            shippedQuantity: 15,
            countedQuantity: 15,
            shippedWeight: 255.74,
            shippedCube: 10.64,
            customerItemId: "B01EIHCYMC",
            isSpecialOrder: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null,
            isTtr: null
        },
        {
            id: 555935,
            orderId: 9457,
            lineItemId: 446432,
            customerPoNumber: "XXXXX",
            orderedQuantity: 14,
            shippedQuantity: 14,
            countedQuantity: 14,
            shippedWeight: 70.42,
            shippedCube: 3.472,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555936,
            orderId: 9457,
            lineItemId: 673296,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 23.9,
            shippedCube: 1.5,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555941,
            orderId: 9457,
            lineItemId: 539576,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 51,
            shippedCube: 2.31,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555945,
            orderId: 9457,
            lineItemId: 567683,
            customerPoNumber: "XXXXX",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 20.25,
            shippedCube: 0.89,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555951,
            orderId: 9457,
            lineItemId: 564243,
            customerPoNumber: "XXXXX",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 20.25,
            shippedCube: 0.89,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555956,
            orderId: 9457,
            lineItemId: 341786,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 63.5,
            shippedCube: 2.314,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555961,
            orderId: 9457,
            lineItemId: 532420,
            customerPoNumber: "XXXXX",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 168,
            shippedCube: 6.888,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555963,
            orderId: 9457,
            lineItemId: 365935,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 84,
            shippedCube: 2.44,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555970,
            orderId: 9457,
            lineItemId: 375479,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 21.52,
            shippedCube: 0.92,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555972,
            orderId: 9457,
            lineItemId: 535692,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T17:22:21.967"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555980,
            orderId: 9457,
            lineItemId: 344086,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 11.2,
            shippedCube: 1.065,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555981,
            orderId: 9457,
            lineItemId: 360759,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 87,
            shippedCube: 3.84,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555982,
            orderId: 9457,
            lineItemId: 403570,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 4,
            shippedCube: 0.812,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555995,
            orderId: 9457,
            lineItemId: 590832,
            customerPoNumber: "XXXXX",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 55.29,
            shippedCube: 2.905,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555998,
            orderId: 9457,
            lineItemId: 562973,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 26,
            shippedCube: 1.128,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 556000,
            orderId: 9457,
            lineItemId: 659758,
            customerPoNumber: "XXXXX",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 37.6,
            shippedCube: 2.488,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 556009,
            orderId: 9457,
            lineItemId: 640775,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 8,
            shippedQuantity: 8,
            countedQuantity: 8,
            shippedWeight: 86,
            shippedCube: 3.6,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 556020,
            orderId: 9457,
            lineItemId: 589833,
            customerPoNumber: "DE03092021-2386164",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 21.758,
            shippedCube: 1.114,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555593,
            orderId: 9458,
            lineItemId: 404205,
            customerPoNumber: "109802",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 52.5,
            shippedCube: 2.65,
            customerItemId: "08731",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555597,
            orderId: 9458,
            lineItemId: 726908,
            customerPoNumber: "110001",
            orderedQuantity: 10,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "53898",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555602,
            orderId: 9458,
            lineItemId: 388181,
            customerPoNumber: "109802",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 69,
            shippedCube: 3.49,
            customerItemId: "19210",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555603,
            orderId: 9458,
            lineItemId: 449152,
            customerPoNumber: "DE03112021-2388865",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 6.45,
            shippedCube: 0.274,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555605,
            orderId: 9458,
            lineItemId: 631554,
            customerPoNumber: "110001",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 17.64,
            shippedCube: 1.4,
            customerItemId: "15360",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555629,
            orderId: 9458,
            lineItemId: 50866,
            customerPoNumber: "110001",
            orderedQuantity: 7,
            shippedQuantity: 7,
            countedQuantity: 7,
            shippedWeight: 219.1,
            shippedCube: 5.11,
            customerItemId: "15860",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555632,
            orderId: 9458,
            lineItemId: 411155,
            customerPoNumber: "110001",
            orderedQuantity: 5,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "28458",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555633,
            orderId: 9458,
            lineItemId: 565418,
            customerPoNumber: "110001",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 21,
            shippedCube: 2.37,
            customerItemId: "24563",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555642,
            orderId: 9458,
            lineItemId: 539552,
            customerPoNumber: "110001",
            orderedQuantity: 30,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "15685",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555643,
            orderId: 9458,
            lineItemId: 658633,
            customerPoNumber: "110001",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "19738",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555654,
            orderId: 9458,
            lineItemId: 446432,
            customerPoNumber: "109802",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 50.3,
            shippedCube: 2.48,
            customerItemId: "53285",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555663,
            orderId: 9458,
            lineItemId: 699888,
            customerPoNumber: "109802",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 159.1,
            shippedCube: 6.86,
            customerItemId: "1566A",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555667,
            orderId: 9458,
            lineItemId: 349041,
            customerPoNumber: "109802",
            orderedQuantity: 51,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "15710",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555672,
            orderId: 9458,
            lineItemId: 669250,
            customerPoNumber: "110001",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 107.5,
            shippedCube: 4.6,
            customerItemId: "28420",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555681,
            orderId: 9458,
            lineItemId: 532418,
            customerPoNumber: "110001",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 10.7,
            shippedCube: 0.4,
            customerItemId: "07740",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555683,
            orderId: 9458,
            lineItemId: 568341,
            customerPoNumber: "110001",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "16137",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555692,
            orderId: 9458,
            lineItemId: 426864,
            customerPoNumber: "110001",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 81.25,
            shippedCube: 2.745,
            customerItemId: "23433",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555695,
            orderId: 9458,
            lineItemId: 473473,
            customerPoNumber: "109802",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 107.57,
            shippedCube: 5.62,
            customerItemId: "05304",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555709,
            orderId: 9458,
            lineItemId: 580140,
            customerPoNumber: "109802",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 43.503,
            shippedCube: 2.385,
            customerItemId: "24338",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555715,
            orderId: 9458,
            lineItemId: 583625,
            customerPoNumber: "109802",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 65.75,
            shippedCube: 2.51,
            customerItemId: "19049",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555720,
            orderId: 9458,
            lineItemId: 366240,
            customerPoNumber: "109802",
            orderedQuantity: 30,
            shippedQuantity: 30,
            countedQuantity: 30,
            shippedWeight: 423.99,
            shippedCube: 13.8,
            customerItemId: "53460",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555729,
            orderId: 9458,
            lineItemId: 472543,
            customerPoNumber: "110001",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 65.5,
            shippedCube: 4.35,
            customerItemId: "28630",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555749,
            orderId: 9458,
            lineItemId: 344093,
            customerPoNumber: "109802",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 310,
            shippedCube: 7.465,
            customerItemId: "30610",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555751,
            orderId: 9458,
            lineItemId: 353834,
            customerPoNumber: "109802",
            orderedQuantity: 39,
            shippedQuantity: 39,
            countedQuantity: 39,
            shippedWeight: 614.016,
            shippedCube: 31.356,
            customerItemId: "15654",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555757,
            orderId: 9458,
            lineItemId: 341688,
            customerPoNumber: "110001",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 55,
            shippedCube: 2.02,
            customerItemId: "18272",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555758,
            orderId: 9458,
            lineItemId: 524271,
            customerPoNumber: "109802",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "19822",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555775,
            orderId: 9458,
            lineItemId: 568357,
            customerPoNumber: "109802",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 120,
            shippedCube: 6.12,
            customerItemId: "16354",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555777,
            orderId: 9458,
            lineItemId: 477093,
            customerPoNumber: "109802",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 66,
            shippedCube: 1.512,
            customerItemId: "5619B",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555788,
            orderId: 9458,
            lineItemId: 569155,
            customerPoNumber: "DE03112021-2389037",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 48.05,
            shippedCube: 2.912,
            customerItemId: "24778",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555792,
            orderId: 9458,
            lineItemId: 566573,
            customerPoNumber: "110001",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 126.6,
            shippedCube: 5.9,
            customerItemId: "15697",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555803,
            orderId: 9458,
            lineItemId: 546477,
            customerPoNumber: "110001",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 65.08,
            shippedCube: 3.556,
            customerItemId: "27094",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 555815,
            orderId: 9458,
            lineItemId: 707747,
            customerPoNumber: "DE03112021-2388865",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 8.95,
            shippedCube: 0.4606,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 664180,
            orderId: 3955,
            lineItemId: 462080,
            customerPoNumber: "8KCNIGWV",
            orderedQuantity: 18,
            shippedQuantity: 18,
            countedQuantity: 18,
            shippedWeight: 255.74,
            shippedCube: 10.64,
            customerItemId: "B01EIHCYMC",
            isSpecialOrder: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null,
            isTtr: null
        },
        {
            id: 664256,
            orderId: 3955,
            lineItemId: 462080,
            customerPoNumber: "8KCNIGWV",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 255.74,
            shippedCube: 10.64,
            customerItemId: "B01EIHCYMC",
            isSpecialOrder: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null,
            isTtr: null
        },
        {
            id: 3752726,
            orderId: 3955,
            lineItemId: 703775,
            customerPoNumber: "895528",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "550168",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 3752843,
            orderId: 3955,
            lineItemId: 703775,
            customerPoNumber: "895542",
            orderedQuantity: 4,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "550168",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 87873,
            orderId: 4001,
            lineItemId: 161090,
            customerPoNumber: "427-237410",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 150,
            shippedCube: 5.53,
            customerItemId: "161090",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 516688,
            orderId: 3955,
            lineItemId: 676596,
            customerPoNumber: "1906653M",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 147.96,
            shippedCube: 5.76,
            customerItemId: "3131044",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 18,
            hi: 4,
            slot: "0",
            palletSize: ""
        },
        {
            id: 516411,
            orderId: 4000,
            lineItemId: 448874,
            customerPoNumber: "1420413M",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 428.652,
            shippedCube: 57.6,
            customerItemId: "5317151",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "test",
            ti: 4,
            hi: 5,
            slot: "0",
            palletSize: ""
        },
        {
            id: 530288,
            orderId: 8509,
            lineItemId: 599476,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 53.4,
            shippedCube: 3.513,
            customerItemId: "12634",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530290,
            orderId: 8509,
            lineItemId: 640266,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "39201",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530293,
            orderId: 8509,
            lineItemId: 560667,
            customerPoNumber: "168290",
            orderedQuantity: 40,
            shippedQuantity: 40,
            countedQuantity: 40,
            shippedWeight: 448,
            shippedCube: 42.516,
            customerItemId: "72201",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530294,
            orderId: 8509,
            lineItemId: 556134,
            customerPoNumber: "SAMPLES FOR FRANK",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 31.67,
            shippedCube: 1.04,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530296,
            orderId: 8509,
            lineItemId: 560628,
            customerPoNumber: "167883L",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 64,
            shippedCube: 3.564,
            customerItemId: "60399",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null,
        },
        {
            id: 530298,
            orderId: 8509,
            lineItemId: 506641,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 79.2,
            shippedCube: 3.726,
            customerItemId: "71034",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null,
        },
        {
            id: 530300,
            orderId: 8509,
            lineItemId: 403604,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 73.8,
            shippedCube: 8.112,
            customerItemId: "10680",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530301,
            orderId: 8509,
            lineItemId: 532419,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 63,
            shippedCube: 2.583,
            customerItemId: "31005",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530303,
            orderId: 8509,
            lineItemId: 341808,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 10.6,
            shippedCube: 0.5484,
            customerItemId: "49168",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530304,
            orderId: 8509,
            lineItemId: 403421,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 85,
            shippedCube: 9.19,
            customerItemId: "10603",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530307,
            orderId: 8509,
            lineItemId: 646577,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 53.76,
            shippedCube: 2.868,
            customerItemId: "69196",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530309,
            orderId: 8509,
            lineItemId: 50834,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 31.6,
            shippedCube: 0.7,
            customerItemId: "13072",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530314,
            orderId: 8509,
            lineItemId: 504927,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 46.188,
            shippedCube: 1.534,
            customerItemId: "10321",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530317,
            orderId: 8509,
            lineItemId: 532421,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 210,
            shippedCube: 8.61,
            customerItemId: "31000",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530319,
            orderId: 8509,
            lineItemId: 505390,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 11.55,
            shippedCube: 0.489,
            customerItemId: "17715",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530320,
            orderId: 8509,
            lineItemId: 690726,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "73226",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530321,
            orderId: 8509,
            lineItemId: 607807,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "39789",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530326,
            orderId: 8509,
            lineItemId: 488126,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 61.32,
            shippedCube: 4.76,
            customerItemId: "46450",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530327,
            orderId: 8509,
            lineItemId: 32003,
            customerPoNumber: "168290",
            orderedQuantity: 97,
            shippedQuantity: 97,
            countedQuantity: 97,
            shippedWeight: 1067,
            shippedCube: 57.23,
            customerItemId: "50034",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530328,
            orderId: 8509,
            lineItemId: 548808,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 30.32,
            shippedCube: 1.364,
            customerItemId: "27225",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530329,
            orderId: 8509,
            lineItemId: 608389,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 65,
            shippedCube: 4.82,
            customerItemId: "10254",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530332,
            orderId: 8509,
            lineItemId: 399286,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "10384",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530333,
            orderId: 8509,
            lineItemId: 545240,
            customerPoNumber: "168290",
            orderedQuantity: 9,
            shippedQuantity: 9,
            countedQuantity: 9,
            shippedWeight: 261,
            shippedCube: 10.359,
            customerItemId: "45246",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530335,
            orderId: 8509,
            lineItemId: 584446,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 10.75,
            shippedCube: 0.945,
            customerItemId: "10477",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530336,
            orderId: 8509,
            lineItemId: 681106,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 35.6,
            shippedCube: 2.104,
            customerItemId: "59429",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530339,
            orderId: 8509,
            lineItemId: 563493,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 76.6,
            shippedCube: 11.16,
            customerItemId: "10402",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530340,
            orderId: 8509,
            lineItemId: 699386,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 10.25,
            shippedCube: 1.425,
            customerItemId: "10830",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530344,
            orderId: 8509,
            lineItemId: 366072,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 130.09,
            shippedCube: 5.48,
            customerItemId: "25017",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530345,
            orderId: 8509,
            lineItemId: 613441,
            customerPoNumber: "168290",
            orderedQuantity: 7,
            shippedQuantity: 7,
            countedQuantity: 7,
            shippedWeight: 101.437,
            shippedCube: 11.564,
            customerItemId: "55343",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530346,
            orderId: 8509,
            lineItemId: 409554,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 78.78,
            shippedCube: 3.48,
            customerItemId: "73201",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530349,
            orderId: 8509,
            lineItemId: 491822,
            customerPoNumber: "168290",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 115.7,
            shippedCube: 11.856,
            customerItemId: "46578",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530352,
            orderId: 8509,
            lineItemId: 471175,
            customerPoNumber: "167883L",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 302,
            shippedCube: 28,
            customerItemId: "10366",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530357,
            orderId: 8509,
            lineItemId: 360225,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 52.5,
            shippedCube: 2.436,
            customerItemId: "18068",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530360,
            orderId: 8509,
            lineItemId: 59025,
            customerPoNumber: "168290",
            orderedQuantity: 16,
            shippedQuantity: 16,
            countedQuantity: 16,
            shippedWeight: 130.72,
            shippedCube: 5.424,
            customerItemId: "19417",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530361,
            orderId: 8509,
            lineItemId: 353266,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 63.19,
            shippedCube: 2.015,
            customerItemId: "40540",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530364,
            orderId: 8509,
            lineItemId: 383997,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 27.315,
            shippedCube: 1.017,
            customerItemId: "46357",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530365,
            orderId: 8509,
            lineItemId: 528835,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 69,
            shippedCube: 8.118,
            customerItemId: "73013",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530366,
            orderId: 8509,
            lineItemId: 518519,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "17491",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530367,
            orderId: 8509,
            lineItemId: 523794,
            customerPoNumber: "168290",
            orderedQuantity: 18,
            shippedQuantity: 18,
            countedQuantity: 18,
            shippedWeight: 522,
            shippedCube: 20.88,
            customerItemId: "45243",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530368,
            orderId: 8509,
            lineItemId: 683637,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 81.16,
            shippedCube: 5.32,
            customerItemId: "51168",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530369,
            orderId: 8509,
            lineItemId: 539767,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 55,
            shippedCube: 2.96,
            customerItemId: "16116",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530371,
            orderId: 8509,
            lineItemId: 556132,
            customerPoNumber: "SAMPLES FOR FRANK",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 31.65,
            shippedCube: 1.139,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530375,
            orderId: 8509,
            lineItemId: 623334,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "10256",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530376,
            orderId: 8509,
            lineItemId: 664121,
            customerPoNumber: "168290",
            orderedQuantity: 9,
            shippedQuantity: 9,
            countedQuantity: 9,
            shippedWeight: 143.1,
            shippedCube: 5.787,
            customerItemId: "30001",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530379,
            orderId: 8509,
            lineItemId: 639179,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 24.84,
            shippedCube: 1.72,
            customerItemId: "39371",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530380,
            orderId: 8509,
            lineItemId: 478360,
            customerPoNumber: "SAMPLES FOR FRANK",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 13.28,
            shippedCube: 1.03,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530381,
            orderId: 8509,
            lineItemId: 710497,
            customerPoNumber: "168290",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 149.148,
            shippedCube: 12.696,
            customerItemId: "73078",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530384,
            orderId: 8509,
            lineItemId: 505216,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 50.5,
            shippedCube: 1.286,
            customerItemId: "48510",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530385,
            orderId: 8509,
            lineItemId: 487173,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 6.27,
            shippedCube: 0.255,
            customerItemId: "62133",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530387,
            orderId: 8509,
            lineItemId: 1794,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 33,
            shippedCube: 0.806,
            customerItemId: "10950",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530388,
            orderId: 8509,
            lineItemId: 601351,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 33.72,
            shippedCube: 1.596,
            customerItemId: "17566",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530390,
            orderId: 8509,
            lineItemId: 400591,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 136,
            shippedCube: 4.492,
            customerItemId: "69180",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530391,
            orderId: 8509,
            lineItemId: 727313,
            customerPoNumber: "167883L",
            orderedQuantity: 27,
            shippedQuantity: 27,
            countedQuantity: 27,
            shippedWeight: 294.3,
            shippedCube: 12.663,
            customerItemId: null,
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530392,
            orderId: 8509,
            lineItemId: 517208,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 19.248,
            shippedCube: 0.69,
            customerItemId: "60338",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530395,
            orderId: 8509,
            lineItemId: 654706,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 78,
            shippedCube: 3.18,
            customerItemId: "17244",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530398,
            orderId: 8509,
            lineItemId: 344467,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 43.9,
            shippedCube: 1.56,
            customerItemId: "46348",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530399,
            orderId: 8509,
            lineItemId: 639152,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 12.864,
            shippedCube: 1.173,
            customerItemId: "36782",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530400,
            orderId: 8509,
            lineItemId: 726300,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 5,
            shippedCube: 0.208,
            customerItemId: "76894",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530403,
            orderId: 8509,
            lineItemId: 406103,
            customerPoNumber: "SAMPLES FOR FRANK",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 16.3,
            shippedCube: 1.22,
            customerItemId: "72215",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530404,
            orderId: 8509,
            lineItemId: 560672,
            customerPoNumber: "168290",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 312,
            shippedCube: 14.2344,
            customerItemId: "73215",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530409,
            orderId: 8509,
            lineItemId: 664120,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 47.7,
            shippedCube: 1.929,
            customerItemId: "30002",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530411,
            orderId: 8509,
            lineItemId: 535170,
            customerPoNumber: "168290",
            orderedQuantity: 16,
            shippedQuantity: 16,
            countedQuantity: 16,
            shippedWeight: 88,
            shippedCube: 7.904,
            customerItemId: "46473",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530417,
            orderId: 8509,
            lineItemId: 366066,
            customerPoNumber: "168290",
            orderedQuantity: 18,
            shippedQuantity: 18,
            countedQuantity: 18,
            shippedWeight: 120.528,
            shippedCube: 6.39,
            customerItemId: "25016",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530419,
            orderId: 8509,
            lineItemId: 633143,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 170.85,
            shippedCube: 9.04,
            customerItemId: "48166",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530421,
            orderId: 8509,
            lineItemId: 409525,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 17.25,
            shippedCube: 0.81,
            customerItemId: "27199",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530426,
            orderId: 8509,
            lineItemId: 388251,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 57.25,
            shippedCube: 4.275,
            customerItemId: "17920",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530428,
            orderId: 8509,
            lineItemId: 354329,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 42.988,
            shippedCube: 2.412,
            customerItemId: "19295",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530429,
            orderId: 8509,
            lineItemId: 441281,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 107.38,
            shippedCube: 8.04,
            customerItemId: "16134",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530430,
            orderId: 8509,
            lineItemId: 358311,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 32.502,
            shippedCube: 1.512,
            customerItemId: "30925",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530435,
            orderId: 8509,
            lineItemId: 688827,
            customerPoNumber: "168290",
            orderedQuantity: 9,
            shippedQuantity: 9,
            countedQuantity: 9,
            shippedWeight: 186.642,
            shippedCube: 15.435,
            customerItemId: "59647",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530440,
            orderId: 8509,
            lineItemId: 532423,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 126,
            shippedCube: 5.166,
            customerItemId: "31002",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530441,
            orderId: 8509,
            lineItemId: 677326,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 21.8,
            shippedCube: 0.938,
            customerItemId: "30068",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530443,
            orderId: 8509,
            lineItemId: 633145,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 171.74,
            shippedCube: 9.07,
            customerItemId: "48162",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530445,
            orderId: 8509,
            lineItemId: 364430,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 51.3,
            shippedCube: 1.251,
            customerItemId: "27075",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530446,
            orderId: 8509,
            lineItemId: 685179,
            customerPoNumber: "SAMPLES FOR FRANK",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 11.06,
            shippedCube: 0.861,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530448,
            orderId: 8509,
            lineItemId: 448679,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 25.142,
            shippedCube: 3.2,
            customerItemId: "10272",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530449,
            orderId: 8509,
            lineItemId: 520437,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 21.272,
            shippedCube: 1.218,
            customerItemId: "16139",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530453,
            orderId: 8509,
            lineItemId: 468585,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 64.953,
            shippedCube: 2.232,
            customerItemId: "63004",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530460,
            orderId: 8509,
            lineItemId: 44144,
            customerPoNumber: "168290",
            orderedQuantity: 7,
            shippedQuantity: 7,
            countedQuantity: 7,
            shippedWeight: 105,
            shippedCube: 4.746,
            customerItemId: "18036",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530462,
            orderId: 8509,
            lineItemId: 467849,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 28.64,
            shippedCube: 0.814,
            customerItemId: "10513",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530463,
            orderId: 8509,
            lineItemId: 349041,
            customerPoNumber: "168290",
            orderedQuantity: 17,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "27124",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530466,
            orderId: 8509,
            lineItemId: 11991,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 14.897,
            shippedCube: 1.16,
            customerItemId: "46287",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530467,
            orderId: 8509,
            lineItemId: 671499,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "19409",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530474,
            orderId: 8509,
            lineItemId: 683636,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 20.29,
            shippedCube: 1.33,
            customerItemId: "51167",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530477,
            orderId: 8509,
            lineItemId: 411184,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 106.44,
            shippedCube: 3.43,
            customerItemId: "23295",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530479,
            orderId: 8509,
            lineItemId: 682140,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 14.1,
            shippedCube: 0.7596,
            customerItemId: "46947",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530484,
            orderId: 8509,
            lineItemId: 505213,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "48509",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530485,
            orderId: 8509,
            lineItemId: 663683,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 16.25,
            shippedCube: 1.828,
            customerItemId: "10793",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530487,
            orderId: 8509,
            lineItemId: 403432,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 170,
            shippedCube: 18.38,
            customerItemId: "10401",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530488,
            orderId: 8509,
            lineItemId: 468402,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "59638",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530489,
            orderId: 8509,
            lineItemId: 557603,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 61.47,
            shippedCube: 4.248,
            customerItemId: "27073",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530500,
            orderId: 8509,
            lineItemId: 702837,
            customerPoNumber: "168290",
            orderedQuantity: 7,
            shippedQuantity: 7,
            countedQuantity: 7,
            shippedWeight: 131.6,
            shippedCube: 12.67,
            customerItemId: "76168",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530502,
            orderId: 8509,
            lineItemId: 565601,
            customerPoNumber: "168290",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 477.02,
            shippedCube: 20.672,
            customerItemId: "18968",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530503,
            orderId: 8509,
            lineItemId: 695992,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "51166",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530504,
            orderId: 8509,
            lineItemId: 536074,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 67.2,
            shippedCube: 3.27,
            customerItemId: "27134",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530505,
            orderId: 8509,
            lineItemId: 642288,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 17.8,
            shippedCube: 1.171,
            customerItemId: "12635",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530506,
            orderId: 8509,
            lineItemId: 364345,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 81.75,
            shippedCube: 2.82,
            customerItemId: "18029",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530507,
            orderId: 8509,
            lineItemId: 640267,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 36.8,
            shippedCube: 2.934,
            customerItemId: "39199",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530510,
            orderId: 8509,
            lineItemId: 592840,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 57.66,
            shippedCube: 2.36,
            customerItemId: "42691",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530515,
            orderId: 8509,
            lineItemId: 383357,
            customerPoNumber: "SAMPLE",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 10.714,
            shippedCube: 0.54,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530516,
            orderId: 8509,
            lineItemId: 448676,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 39.766,
            shippedCube: 3.9,
            customerItemId: "10314",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530521,
            orderId: 8509,
            lineItemId: 470952,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 264.75,
            shippedCube: 8.59,
            customerItemId: "48014",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530522,
            orderId: 8509,
            lineItemId: 506604,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 65,
            shippedCube: 3.25,
            customerItemId: "12000",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530523,
            orderId: 8509,
            lineItemId: 608611,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 3,
            countedQuantity: 3,
            shippedWeight: 38.067,
            shippedCube: 7.029,
            customerItemId: "10206",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530524,
            orderId: 8509,
            lineItemId: 518898,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 51.9,
            shippedCube: 2.962,
            customerItemId: "27018",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530525,
            orderId: 8509,
            lineItemId: 684813,
            customerPoNumber: "168290",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 204.49,
            shippedCube: 10.452,
            customerItemId: "16214",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530526,
            orderId: 8509,
            lineItemId: 481845,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 12,
            shippedCube: 2.143,
            customerItemId: "10264",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530538,
            orderId: 8509,
            lineItemId: 560631,
            customerPoNumber: "167883L",
            orderedQuantity: 2,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: null,
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530541,
            orderId: 8509,
            lineItemId: 671802,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "30005",
            isSpecialOrder: true,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530545,
            orderId: 8509,
            lineItemId: 526505,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 45,
            shippedCube: 2.45,
            customerItemId: "48161",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530553,
            orderId: 8509,
            lineItemId: 385481,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "17629",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530569,
            orderId: 8509,
            lineItemId: 431531,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 9.8,
            shippedCube: 0.529,
            customerItemId: "27029",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530575,
            orderId: 8509,
            lineItemId: 541698,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 16.5,
            shippedCube: 1.47,
            customerItemId: "10829",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530580,
            orderId: 8509,
            lineItemId: 633149,
            customerPoNumber: "168290",
            orderedQuantity: 5,
            shippedQuantity: 5,
            countedQuantity: 5,
            shippedWeight: 85.87,
            shippedCube: 4.535,
            customerItemId: "48163",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530583,
            orderId: 8509,
            lineItemId: 539663,
            customerPoNumber: "168290",
            orderedQuantity: 27,
            shippedQuantity: 27,
            countedQuantity: 27,
            shippedWeight: 594,
            shippedCube: 15.822,
            customerItemId: "21207",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530593,
            orderId: 8509,
            lineItemId: 477003,
            customerPoNumber: "SAMPLES FOR FRANK",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 11.65,
            shippedCube: 0.86,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530597,
            orderId: 8509,
            lineItemId: 608323,
            customerPoNumber: "168290",
            orderedQuantity: 8,
            shippedQuantity: 8,
            countedQuantity: 8,
            shippedWeight: 149.84,
            shippedCube: 16.56,
            customerItemId: "10404",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530598,
            orderId: 8509,
            lineItemId: 710047,
            customerPoNumber: "168290",
            orderedQuantity: 4,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 62.528,
            shippedCube: 2.036,
            customerItemId: "56042",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530600,
            orderId: 8509,
            lineItemId: 609890,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 7.15,
            shippedCube: 0.32,
            customerItemId: "69619",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530604,
            orderId: 8509,
            lineItemId: 516039,
            customerPoNumber: "168290",
            orderedQuantity: 6,
            shippedQuantity: 6,
            countedQuantity: 6,
            shippedWeight: 61.29,
            shippedCube: 8.1,
            customerItemId: "10397",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530605,
            orderId: 8509,
            lineItemId: 467853,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 16.5,
            shippedCube: 1.688,
            customerItemId: "46432",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530607,
            orderId: 8509,
            lineItemId: 560671,
            customerPoNumber: "168290",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 130,
            shippedCube: 5.804,
            customerItemId: "73284",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530608,
            orderId: 8509,
            lineItemId: 613855,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 9.8,
            shippedCube: 0.819,
            customerItemId: "11197",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530611,
            orderId: 8509,
            lineItemId: 699902,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 16.08,
            shippedCube: 0.775,
            customerItemId: "40362",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.093"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530617,
            orderId: 8509,
            lineItemId: 377917,
            customerPoNumber: "168290",
            orderedQuantity: 2,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "30930",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530619,
            orderId: 8509,
            lineItemId: 639958,
            customerPoNumber: "168290",
            orderedQuantity: 15,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "35037",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530624,
            orderId: 8509,
            lineItemId: 454953,
            customerPoNumber: "168290",
            orderedQuantity: 3,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "27952",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 530628,
            orderId: 8509,
            lineItemId: 505217,
            customerPoNumber: "168290",
            orderedQuantity: 1,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "48511",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2021-03-16T16:19:56.123"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374098,
            orderId: 2266252,
            lineItemId: 640070,
            customerPoNumber: "90964",
            orderedQuantity: 126,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "876598",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374099,
            orderId: 2266252,
            lineItemId: 643255,
            customerPoNumber: "90964",
            orderedQuantity: 30,
            shippedQuantity: 30,
            countedQuantity: 30,
            shippedWeight: 408,
            shippedCube: 24.96,
            customerItemId: "521049",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374100,
            orderId: 2266252,
            lineItemId: 643259,
            customerPoNumber: "90964",
            orderedQuantity: 27,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "865475",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374101,
            orderId: 2266252,
            lineItemId: 643264,
            customerPoNumber: "90964",
            orderedQuantity: 56,
            shippedQuantity: 56,
            countedQuantity: 56,
            shippedWeight: 378,
            shippedCube: 12.88,
            customerItemId: "495948",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374102,
            orderId: 2266252,
            lineItemId: 643658,
            customerPoNumber: "90964",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 270,
            shippedCube: 15.28,
            customerItemId: "602423",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374103,
            orderId: 2266252,
            lineItemId: 658749,
            customerPoNumber: "90964",
            orderedQuantity: 14,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "876600",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374104,
            orderId: 2266252,
            lineItemId: 660139,
            customerPoNumber: "90964",
            orderedQuantity: 63,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "392843",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374105,
            orderId: 2266253,
            lineItemId: 552414,
            customerPoNumber: "76136",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 87.89,
            shippedCube: 6.0656,
            customerItemId: "584788",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374106,
            orderId: 2266253,
            lineItemId: 581940,
            customerPoNumber: "76136",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 114.72,
            shippedCube: 10.32,
            customerItemId: "523268",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 12,
            hi: 7,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374107,
            orderId: 2266253,
            lineItemId: 615577,
            customerPoNumber: "76136",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 90.44,
            shippedCube: 6.052,
            customerItemId: "584775",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374108,
            orderId: 2266253,
            lineItemId: 696350,
            customerPoNumber: "76136",
            orderedQuantity: 8,
            shippedQuantity: 8,
            countedQuantity: 8,
            shippedWeight: 103.2,
            shippedCube: 5.84,
            customerItemId: "780996",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374109,
            orderId: 2266254,
            lineItemId: 610775,
            customerPoNumber: "66003",
            orderedQuantity: 34,
            shippedQuantity: 34,
            countedQuantity: 34,
            shippedWeight: 104.38,
            shippedCube: 7.99,
            customerItemId: "743291",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374110,
            orderId: 2266254,
            lineItemId: 628831,
            customerPoNumber: "66003",
            orderedQuantity: 34,
            shippedQuantity: 34,
            countedQuantity: 34,
            shippedWeight: 104.38,
            shippedCube: 7.9934,
            customerItemId: "743292",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374111,
            orderId: 2266254,
            lineItemId: 665772,
            customerPoNumber: "66003",
            orderedQuantity: 17,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "743294",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374112,
            orderId: 2266254,
            lineItemId: 719736,
            customerPoNumber: "66003",
            orderedQuantity: 34,
            shippedQuantity: 34,
            countedQuantity: 34,
            shippedWeight: 105.74,
            shippedCube: 7.9934,
            customerItemId: "406940",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374113,
            orderId: 2266255,
            lineItemId: 377321,
            customerPoNumber: "76156",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 58.99,
            shippedCube: 5.2071,
            customerItemId: "523269",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 17,
            hi: 8,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374114,
            orderId: 2266255,
            lineItemId: 377323,
            customerPoNumber: "76156",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 58.48,
            shippedCube: 5.202,
            customerItemId: "523265",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 17,
            hi: 4,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374115,
            orderId: 2266255,
            lineItemId: 387365,
            customerPoNumber: "76156",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 370,
            shippedCube: 14.806,
            customerItemId: "397856",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 10,
            hi: 4,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374116,
            orderId: 2266255,
            lineItemId: 400221,
            customerPoNumber: "76156",
            orderedQuantity: 40,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "497864",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 10,
            hi: 4,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374117,
            orderId: 2266255,
            lineItemId: 454603,
            customerPoNumber: "76156",
            orderedQuantity: 1,
            shippedQuantity: 1,
            countedQuantity: 1,
            shippedWeight: 11.8,
            shippedCube: 0.921,
            customerItemId: "780994",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374118,
            orderId: 2266255,
            lineItemId: 462542,
            customerPoNumber: "76156",
            orderedQuantity: 52,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "895821",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 6,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374119,
            orderId: 2266255,
            lineItemId: 624089,
            customerPoNumber: "76156",
            orderedQuantity: 216,
            shippedQuantity: 216,
            countedQuantity: 216,
            shippedWeight: 4752,
            shippedCube: 284.904,
            customerItemId: "019814",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374120,
            orderId: 2266255,
            lineItemId: 636721,
            customerPoNumber: "76156",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 83.47,
            shippedCube: 6.0656,
            customerItemId: "345786",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374121,
            orderId: 2266255,
            lineItemId: 658185,
            customerPoNumber: "76156",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 86.87,
            shippedCube: 6.0656,
            customerItemId: "430694",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374122,
            orderId: 2266255,
            lineItemId: 658207,
            customerPoNumber: "76156",
            orderedQuantity: 9,
            shippedQuantity: 9,
            countedQuantity: 9,
            shippedWeight: 66.339,
            shippedCube: 3.9393,
            customerItemId: "886331",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374123,
            orderId: 2266255,
            lineItemId: 659905,
            customerPoNumber: "76156",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 684,
            shippedCube: 47.484,
            customerItemId: "684158",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374124,
            orderId: 2266255,
            lineItemId: 676186,
            customerPoNumber: "76156",
            orderedQuantity: 34,
            shippedQuantity: 34,
            countedQuantity: 34,
            shippedWeight: 343.4,
            shippedCube: 15.2762,
            customerItemId: "721652",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374125,
            orderId: 2266255,
            lineItemId: 765198,
            customerPoNumber: "76156",
            orderedQuantity: 11,
            shippedQuantity: 11,
            countedQuantity: 11,
            shippedWeight: 58.3,
            shippedCube: 4.4517,
            customerItemId: "826001",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374126,
            orderId: 2266256,
            lineItemId: 54601,
            customerPoNumber: "76154",
            orderedQuantity: 2,
            shippedQuantity: 2,
            countedQuantity: 2,
            shippedWeight: 38.6,
            shippedCube: 1.054,
            customerItemId: "945625",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374127,
            orderId: 2266256,
            lineItemId: 386761,
            customerPoNumber: "76154",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 646,
            shippedCube: 21.44,
            customerItemId: "343657",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374128,
            orderId: 2266256,
            lineItemId: 400779,
            customerPoNumber: "76154",
            orderedQuantity: 40,
            shippedQuantity: 40,
            countedQuantity: 40,
            shippedWeight: 1368,
            shippedCube: 48.4,
            customerItemId: "343707",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374129,
            orderId: 2266256,
            lineItemId: 402639,
            customerPoNumber: "76154",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 538.8,
            shippedCube: 15.336,
            customerItemId: "732671",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374130,
            orderId: 2266256,
            lineItemId: 423806,
            customerPoNumber: "76154",
            orderedQuantity: 18,
            shippedQuantity: 18,
            countedQuantity: 18,
            shippedWeight: 450,
            shippedCube: 11.691,
            customerItemId: "322172",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374131,
            orderId: 2266256,
            lineItemId: 423807,
            customerPoNumber: "76154",
            orderedQuantity: 18,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "322214",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374132,
            orderId: 2266256,
            lineItemId: 441273,
            customerPoNumber: "76154",
            orderedQuantity: 96,
            shippedQuantity: 96,
            countedQuantity: 96,
            shippedWeight: 2284.8,
            shippedCube: 70.2912,
            customerItemId: "870410",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374133,
            orderId: 2266256,
            lineItemId: 481852,
            customerPoNumber: "76154",
            orderedQuantity: 42,
            shippedQuantity: 42,
            countedQuantity: 42,
            shippedWeight: 957.6,
            shippedCube: 41.79,
            customerItemId: "312082",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374134,
            orderId: 2266256,
            lineItemId: 502010,
            customerPoNumber: "76154",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 571.2,
            shippedCube: 17.568,
            customerItemId: "153999",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374135,
            orderId: 2266256,
            lineItemId: 562544,
            customerPoNumber: "76154",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 571.2,
            shippedCube: 17.568,
            customerItemId: "870758",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374136,
            orderId: 2266256,
            lineItemId: 711452,
            customerPoNumber: "76154",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 458.352,
            shippedCube: 19.116,
            customerItemId: "413081",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374137,
            orderId: 2266256,
            lineItemId: 750734,
            customerPoNumber: "76154",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 244.6,
            shippedCube: 25.332,
            customerItemId: "945630",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374138,
            orderId: 2266257,
            lineItemId: 41874,
            customerPoNumber: "76155",
            orderedQuantity: 22,
            shippedQuantity: 22,
            countedQuantity: 22,
            shippedWeight: 242,
            shippedCube: 10.4676,
            customerItemId: "308392",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374139,
            orderId: 2266257,
            lineItemId: 41881,
            customerPoNumber: "76155",
            orderedQuantity: 55,
            shippedQuantity: 55,
            countedQuantity: 55,
            shippedWeight: 605,
            shippedCube: 26.169,
            customerItemId: "308391",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374140,
            orderId: 2266257,
            lineItemId: 41899,
            customerPoNumber: "76155",
            orderedQuantity: 88,
            shippedQuantity: 88,
            countedQuantity: 88,
            shippedWeight: 968,
            shippedCube: 41.8704,
            customerItemId: "308394",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374141,
            orderId: 2266257,
            lineItemId: 41917,
            customerPoNumber: "76155",
            orderedQuantity: 55,
            shippedQuantity: 55,
            countedQuantity: 55,
            shippedWeight: 605,
            shippedCube: 26.169,
            customerItemId: "308393",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374142,
            orderId: 2266257,
            lineItemId: 502120,
            customerPoNumber: "76155",
            orderedQuantity: 14,
            shippedQuantity: 14,
            countedQuantity: 14,
            shippedWeight: 224,
            shippedCube: 10.528,
            customerItemId: "753610",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374143,
            orderId: 2266257,
            lineItemId: 535522,
            customerPoNumber: "76155",
            orderedQuantity: 50,
            shippedQuantity: 50,
            countedQuantity: 50,
            shippedWeight: 555,
            shippedCube: 21.05,
            customerItemId: "211136",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 10,
            hi: 6,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374144,
            orderId: 2266257,
            lineItemId: 677289,
            customerPoNumber: "76155",
            orderedQuantity: 49,
            shippedQuantity: 49,
            countedQuantity: 49,
            shippedWeight: 932.96,
            shippedCube: 70.5992,
            customerItemId: "730242",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374145,
            orderId: 2266257,
            lineItemId: 731143,
            customerPoNumber: "76155",
            orderedQuantity: 63,
            shippedQuantity: 63,
            countedQuantity: 63,
            shippedWeight: 941.85,
            shippedCube: 92.7171,
            customerItemId: "875105",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374146,
            orderId: 2266257,
            lineItemId: 731145,
            customerPoNumber: "76155",
            orderedQuantity: 63,
            shippedQuantity: 63,
            countedQuantity: 63,
            shippedWeight: 850.5,
            shippedCube: 92.4651,
            customerItemId: "875103",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374147,
            orderId: 2266258,
            lineItemId: 470094,
            customerPoNumber: "66005",
            orderedQuantity: 15,
            shippedQuantity: 15,
            countedQuantity: 15,
            shippedWeight: 142.5,
            shippedCube: 6.933,
            customerItemId: "791760",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374148,
            orderId: 2266258,
            lineItemId: 625897,
            customerPoNumber: "66005",
            orderedQuantity: 10,
            shippedQuantity: 10,
            countedQuantity: 10,
            shippedWeight: 328.46,
            shippedCube: 7.6,
            customerItemId: "746026",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374149,
            orderId: 2266258,
            lineItemId: 756206,
            customerPoNumber: "66005",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 91,
            shippedCube: 3.9884,
            customerItemId: "718993",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374150,
            orderId: 2266258,
            lineItemId: 756261,
            customerPoNumber: "66005",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 91,
            shippedCube: 3.9884,
            customerItemId: "718990",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374151,
            orderId: 2266258,
            lineItemId: 760264,
            customerPoNumber: "66005",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 78,
            shippedCube: 3.9884,
            customerItemId: "718994",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374152,
            orderId: 2266258,
            lineItemId: 762943,
            customerPoNumber: "66005",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 84.5,
            shippedCube: 2.3777,
            customerItemId: "475022",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374153,
            orderId: 2266258,
            lineItemId: 762945,
            customerPoNumber: "66005",
            orderedQuantity: 28,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "188642",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.93"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374154,
            orderId: 2266258,
            lineItemId: 762950,
            customerPoNumber: "66005",
            orderedQuantity: 26,
            shippedQuantity: 26,
            countedQuantity: 26,
            shippedWeight: 169,
            shippedCube: 4.7554,
            customerItemId: "475021",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374155,
            orderId: 2266258,
            lineItemId: 768465,
            customerPoNumber: "66005",
            orderedQuantity: 39,
            shippedQuantity: 39,
            countedQuantity: 39,
            shippedWeight: 507,
            shippedCube: 11.7078,
            customerItemId: "298547",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374156,
            orderId: 2266259,
            lineItemId: 646966,
            customerPoNumber: "66097",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 88.4,
            shippedCube: 3.549,
            customerItemId: "488231",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 10,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374157,
            orderId: 2266259,
            lineItemId: 646979,
            customerPoNumber: "66097",
            orderedQuantity: 13,
            shippedQuantity: 4,
            countedQuantity: 4,
            shippedWeight: 27.2,
            shippedCube: 1.0944,
            customerItemId: "232314",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 3,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374158,
            orderId: 2266259,
            lineItemId: 646980,
            customerPoNumber: "66097",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 88.4,
            shippedCube: 3.5568,
            customerItemId: "488226",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 4,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374159,
            orderId: 2266259,
            lineItemId: 646984,
            customerPoNumber: "66097",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 88.4,
            shippedCube: 3.5568,
            customerItemId: "488229",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 10,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374160,
            orderId: 2266259,
            lineItemId: 646992,
            customerPoNumber: "66097",
            orderedQuantity: 26,
            shippedQuantity: 26,
            countedQuantity: 26,
            shippedWeight: 176.8,
            shippedCube: 7.098,
            customerItemId: "488222",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 10,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374161,
            orderId: 2266259,
            lineItemId: 647004,
            customerPoNumber: "66097",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 88.4,
            shippedCube: 3.5568,
            customerItemId: "488224",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 3,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374162,
            orderId: 2266259,
            lineItemId: 647005,
            customerPoNumber: "66097",
            orderedQuantity: 26,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 81.6,
            shippedCube: 3.2832,
            customerItemId: "488227",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 13,
            hi: 4,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374163,
            orderId: 2266259,
            lineItemId: 682785,
            customerPoNumber: "66097",
            orderedQuantity: 13,
            shippedQuantity: 13,
            countedQuantity: 13,
            shippedWeight: 88.4,
            shippedCube: 3.5568,
            customerItemId: "488225",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374164,
            orderId: 2266259,
            lineItemId: 734280,
            customerPoNumber: "66097",
            orderedQuantity: 28,
            shippedQuantity: 28,
            countedQuantity: 28,
            shippedWeight: 56,
            shippedCube: 2.8,
            customerItemId: "488047",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374165,
            orderId: 2266259,
            lineItemId: 734287,
            customerPoNumber: "66097",
            orderedQuantity: 28,
            shippedQuantity: 28,
            countedQuantity: 28,
            shippedWeight: 56,
            shippedCube: 2.8,
            customerItemId: "488044",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374166,
            orderId: 2266259,
            lineItemId: 734288,
            customerPoNumber: "66097",
            orderedQuantity: 28,
            shippedQuantity: 28,
            countedQuantity: 28,
            shippedWeight: 56,
            shippedCube: 2.8,
            customerItemId: "488045",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374167,
            orderId: 2266259,
            lineItemId: 734289,
            customerPoNumber: "66097",
            orderedQuantity: 28,
            shippedQuantity: 28,
            countedQuantity: 28,
            shippedWeight: 56,
            shippedCube: 2.8,
            customerItemId: "488048",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374168,
            orderId: 2266259,
            lineItemId: 734290,
            customerPoNumber: "66097",
            orderedQuantity: 28,
            shippedQuantity: 28,
            countedQuantity: 28,
            shippedWeight: 56,
            shippedCube: 2.8,
            customerItemId: "488046",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374169,
            orderId: 2266260,
            lineItemId: 644490,
            customerPoNumber: "66096",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 242.25,
            shippedCube: 5.984,
            customerItemId: "369302",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 17,
            hi: 3,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374170,
            orderId: 2266260,
            lineItemId: 644492,
            customerPoNumber: "66096",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 476,
            shippedCube: 9.962,
            customerItemId: "369303",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 17,
            hi: 7,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374171,
            orderId: 2266260,
            lineItemId: 644510,
            customerPoNumber: "66096",
            orderedQuantity: 34,
            shippedQuantity: 34,
            countedQuantity: 34,
            shippedWeight: 484.5,
            shippedCube: 11.9714,
            customerItemId: "369301",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: 17,
            hi: 2,
            slot: "0",
            palletSize: ""
        },
        {
            id: 66374172,
            orderId: 2266261,
            lineItemId: 767978,
            customerPoNumber: "93000",
            orderedQuantity: 72,
            shippedQuantity: 72,
            countedQuantity: 72,
            shippedWeight: 252,
            shippedCube: 13.6728,
            customerItemId: "476921",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374173,
            orderId: 2266261,
            lineItemId: 767979,
            customerPoNumber: "93000",
            orderedQuantity: 108,
            shippedQuantity: 108,
            countedQuantity: 108,
            shippedWeight: 486,
            shippedCube: 33.6528,
            customerItemId: "476922",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374174,
            orderId: 2266261,
            lineItemId: 767980,
            customerPoNumber: "93000",
            orderedQuantity: 72,
            shippedQuantity: 72,
            countedQuantity: 72,
            shippedWeight: 252,
            shippedCube: 13.6728,
            customerItemId: "476923",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374175,
            orderId: 2266261,
            lineItemId: 767983,
            customerPoNumber: "93000",
            orderedQuantity: 108,
            shippedQuantity: 108,
            countedQuantity: 108,
            shippedWeight: 378,
            shippedCube: 20.5092,
            customerItemId: "191061",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374176,
            orderId: 2266262,
            lineItemId: 756194,
            customerPoNumber: "66213",
            orderedQuantity: 170,
            shippedQuantity: 170,
            countedQuantity: 170,
            shippedWeight: 1105,
            shippedCube: 51.408,
            customerItemId: "746200",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374177,
            orderId: 2266262,
            lineItemId: 756195,
            customerPoNumber: "66213",
            orderedQuantity: 119,
            shippedQuantity: 119,
            countedQuantity: 119,
            shippedWeight: 773.5,
            shippedCube: 35.9856,
            customerItemId: "746201",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374178,
            orderId: 2266262,
            lineItemId: 756196,
            customerPoNumber: "66213",
            orderedQuantity: 64,
            shippedQuantity: 64,
            countedQuantity: 64,
            shippedWeight: 832,
            shippedCube: 41.2096,
            customerItemId: "474544",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66374179,
            orderId: 2266262,
            lineItemId: 762779,
            customerPoNumber: "66213",
            orderedQuantity: 84,
            shippedQuantity: 84,
            countedQuantity: 84,
            shippedWeight: 588,
            shippedCube: 20.5548,
            customerItemId: "799998",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-25T15:46:32.643"),
            verifiedMethod: VerifiedMethod.SubjectToCount,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468979,
            orderId: 2270590,
            lineItemId: 766135,
            customerPoNumber: "0800706228",
            orderedQuantity: 48,
            shippedQuantity: 48,
            countedQuantity: 48,
            shippedWeight: 312,
            shippedCube: 18.2928,
            customerItemId: "661748869",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468980,
            orderId: 2270590,
            lineItemId: 766139,
            customerPoNumber: "0800706228",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 156,
            shippedCube: 10.7088,
            customerItemId: "661748872",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468981,
            orderId: 2270591,
            lineItemId: 745029,
            customerPoNumber: "0800705958",
            orderedQuantity: 105,
            shippedQuantity: 105,
            countedQuantity: 105,
            shippedWeight: 740.25,
            shippedCube: 38.01,
            customerItemId: "650328204",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468982,
            orderId: 2270591,
            lineItemId: 766347,
            customerPoNumber: "0800705958",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 141,
            shippedCube: 7.24,
            customerItemId: "659177626",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468983,
            orderId: 2270591,
            lineItemId: 766464,
            customerPoNumber: "0800705958",
            orderedQuantity: 31,
            shippedQuantity: 31,
            countedQuantity: 31,
            shippedWeight: 99.2,
            shippedCube: 6.9967,
            customerItemId: "659176723",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468984,
            orderId: 2270592,
            lineItemId: 757040,
            customerPoNumber: "0800706527",
            orderedQuantity: 40,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "581384286",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-27T11:30:15.52"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468985,
            orderId: 2270592,
            lineItemId: 757045,
            customerPoNumber: "0800706527",
            orderedQuantity: 26,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "575775855",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-27T11:30:15.52"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468986,
            orderId: 2270592,
            lineItemId: 757046,
            customerPoNumber: "0800706527",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 124,
            shippedCube: 8.14,
            customerItemId: "581384284",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468987,
            orderId: 2270592,
            lineItemId: 757067,
            customerPoNumber: "0800706527",
            orderedQuantity: 192,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "650708318",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-27T11:30:15.52"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468988,
            orderId: 2270592,
            lineItemId: 757069,
            customerPoNumber: "0800706527",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 66.3,
            shippedCube: 9.9212,
            customerItemId: "653399295",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468989,
            orderId: 2270592,
            lineItemId: 757071,
            customerPoNumber: "0800706527",
            orderedQuantity: 17,
            shippedQuantity: 17,
            countedQuantity: 17,
            shippedWeight: 66.3,
            shippedCube: 7.9849,
            customerItemId: "653399296",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468990,
            orderId: 2270592,
            lineItemId: 761909,
            customerPoNumber: "0800706527",
            orderedQuantity: 96,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "650708320",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-27T11:30:15.52"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468991,
            orderId: 2270593,
            lineItemId: 770637,
            customerPoNumber: "0800706561",
            orderedQuantity: 22,
            shippedQuantity: 22,
            countedQuantity: 22,
            shippedWeight: 136.18,
            shippedCube: 9.4886,
            customerItemId: "662851518",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468992,
            orderId: 2270593,
            lineItemId: 770638,
            customerPoNumber: "0800706561",
            orderedQuantity: 22,
            shippedQuantity: 22,
            countedQuantity: 22,
            shippedWeight: 123.86,
            shippedCube: 9.4886,
            customerItemId: "662851516",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468993,
            orderId: 2270594,
            lineItemId: 748687,
            customerPoNumber: "0800706111",
            orderedQuantity: 144,
            shippedQuantity: 144,
            countedQuantity: 144,
            shippedWeight: 383.04,
            shippedCube: 18.72,
            customerItemId: "552265389",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468994,
            orderId: 2270594,
            lineItemId: 752305,
            customerPoNumber: "0800706111",
            orderedQuantity: 48,
            shippedQuantity: 48,
            countedQuantity: 48,
            shippedWeight: 127.68,
            shippedCube: 6.24,
            customerItemId: "584637448",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468995,
            orderId: 2270595,
            lineItemId: 756172,
            customerPoNumber: "0800705719",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 118.8,
            shippedCube: 11.1324,
            customerItemId: "653579465",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468996,
            orderId: 2270596,
            lineItemId: 743934,
            customerPoNumber: "0800706449",
            orderedQuantity: 84,
            shippedQuantity: 84,
            countedQuantity: 84,
            shippedWeight: 211.68,
            shippedCube: 19.992,
            customerItemId: "810031590001",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468997,
            orderId: 2270597,
            lineItemId: 756515,
            customerPoNumber: "0800706398",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 86.4,
            shippedCube: 5.6196,
            customerItemId: "653191483",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468998,
            orderId: 2270598,
            lineItemId: 740422,
            customerPoNumber: "0800705805",
            orderedQuantity: 20,
            shippedQuantity: 20,
            countedQuantity: 20,
            shippedWeight: 121.26,
            shippedCube: 6.18,
            customerItemId: "50021-US -",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66468999,
            orderId: 2270599,
            lineItemId: 755536,
            customerPoNumber: "0800706351",
            orderedQuantity: 14,
            shippedQuantity: 14,
            countedQuantity: 14,
            shippedWeight: 89.32,
            shippedCube: 8.3944,
            customerItemId: "300008052",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469000,
            orderId: 2270600,
            lineItemId: 753262,
            customerPoNumber: "0800720847",
            orderedQuantity: 54,
            shippedQuantity: 54,
            countedQuantity: 54,
            shippedWeight: 243,
            shippedCube: 19.0242,
            customerItemId: "651711940",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469001,
            orderId: 2270601,
            lineItemId: 721199,
            customerPoNumber: "0800705746",
            orderedQuantity: 84,
            shippedQuantity: 84,
            countedQuantity: 84,
            shippedWeight: 378,
            shippedCube: 26.5272,
            customerItemId: "584846669",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469002,
            orderId: 2270602,
            lineItemId: 755555,
            customerPoNumber: "0800706367",
            orderedQuantity: 16,
            shippedQuantity: 16,
            countedQuantity: 16,
            shippedWeight: 140.8,
            shippedCube: 6.8496,
            customerItemId: "300004695",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469003,
            orderId: 2270603,
            lineItemId: 735405,
            customerPoNumber: "0800706036",
            orderedQuantity: 40,
            shippedQuantity: 40,
            countedQuantity: 40,
            shippedWeight: 1123.2,
            shippedCube: 29.42,
            customerItemId: "073608007566",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469004,
            orderId: 2270603,
            lineItemId: 735407,
            customerPoNumber: "0800706036",
            orderedQuantity: 40,
            shippedQuantity: 40,
            countedQuantity: 40,
            shippedWeight: 1408,
            shippedCube: 33.588,
            customerItemId: "073608007573",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469005,
            orderId: 2270603,
            lineItemId: 735412,
            customerPoNumber: "0800706036",
            orderedQuantity: 25,
            shippedQuantity: 25,
            countedQuantity: 25,
            shippedWeight: 325,
            shippedCube: 8.025,
            customerItemId: "073608038195",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469006,
            orderId: 2270603,
            lineItemId: 735415,
            customerPoNumber: "0800706036",
            orderedQuantity: 25,
            shippedQuantity: 25,
            countedQuantity: 25,
            shippedWeight: 325,
            shippedCube: 8.025,
            customerItemId: "073608038300",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469007,
            orderId: 2270603,
            lineItemId: 768403,
            customerPoNumber: "0800706036",
            orderedQuantity: 30,
            shippedQuantity: 30,
            countedQuantity: 30,
            shippedWeight: 178.5,
            shippedCube: 7.53,
            customerItemId: "073608034104",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469008,
            orderId: 2270603,
            lineItemId: 768404,
            customerPoNumber: "0800706036",
            orderedQuantity: 30,
            shippedQuantity: 30,
            countedQuantity: 30,
            shippedWeight: 178.5,
            shippedCube: 7.53,
            customerItemId: "073608034111",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469009,
            orderId: 2270604,
            lineItemId: 760206,
            customerPoNumber: "0800706067",
            orderedQuantity: 75,
            shippedQuantity: 75,
            countedQuantity: 75,
            shippedWeight: 337.5,
            shippedCube: 23.19,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469010,
            orderId: 2270604,
            lineItemId: 766484,
            customerPoNumber: "0800706067",
            orderedQuantity: 50,
            shippedQuantity: 50,
            countedQuantity: 50,
            shippedWeight: 225,
            shippedCube: 15.46,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469011,
            orderId: 2270605,
            lineItemId: 765146,
            customerPoNumber: "0800706426",
            orderedQuantity: 46,
            shippedQuantity: 46,
            countedQuantity: 46,
            shippedWeight: 87.4,
            shippedCube: 9.3334,
            customerItemId: "661361331",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469012,
            orderId: 2270606,
            lineItemId: 764538,
            customerPoNumber: "0800705628",
            orderedQuantity: 60,
            shippedQuantity: 60,
            countedQuantity: 60,
            shippedWeight: 583.2,
            shippedCube: 52.584,
            customerItemId: "574915210",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469013,
            orderId: 2270606,
            lineItemId: 764540,
            customerPoNumber: "0800705628",
            orderedQuantity: 48,
            shippedQuantity: 48,
            countedQuantity: 48,
            shippedWeight: 556.32,
            shippedCube: 42.0672,
            customerItemId: "574915238",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469014,
            orderId: 2270606,
            lineItemId: 764541,
            customerPoNumber: "0800705628",
            orderedQuantity: 24,
            shippedQuantity: 24,
            countedQuantity: 24,
            shippedWeight: 245.28,
            shippedCube: 21.0336,
            customerItemId: "574915235",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469015,
            orderId: 2270606,
            lineItemId: 764542,
            customerPoNumber: "0800705628",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 412.2,
            shippedCube: 31.536,
            customerItemId: "574915233",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469016,
            orderId: 2270607,
            lineItemId: 767789,
            customerPoNumber: "0800706314",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 108,
            shippedCube: 9.3396,
            customerItemId: "599805543",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469017,
            orderId: 2270608,
            lineItemId: 738463,
            customerPoNumber: "0800705558",
            orderedQuantity: 93,
            shippedQuantity: 93,
            countedQuantity: 93,
            shippedWeight: 278.07,
            shippedCube: 22.9989,
            customerItemId: "2841100431",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469018,
            orderId: 2270609,
            lineItemId: 752881,
            customerPoNumber: "0800705692",
            orderedQuantity: 100,
            shippedQuantity: 100,
            countedQuantity: 100,
            shippedWeight: 350,
            shippedCube: 40.67,
            customerItemId: "652102426",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469019,
            orderId: 2270609,
            lineItemId: 752882,
            customerPoNumber: "0800705692",
            orderedQuantity: 80,
            shippedQuantity: 80,
            countedQuantity: 80,
            shippedWeight: 280,
            shippedCube: 32.48,
            customerItemId: "652102461",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469020,
            orderId: 2270609,
            lineItemId: 752884,
            customerPoNumber: "0800705692",
            orderedQuantity: 100,
            shippedQuantity: 100,
            countedQuantity: 100,
            shippedWeight: 350,
            shippedCube: 40.67,
            customerItemId: "652102428",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469021,
            orderId: 2270609,
            lineItemId: 767361,
            customerPoNumber: "0800705692",
            orderedQuantity: 126,
            shippedQuantity: 126,
            countedQuantity: 126,
            shippedWeight: 567,
            shippedCube: 42.7014,
            customerItemId: "659303756",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469022,
            orderId: 2270609,
            lineItemId: 767362,
            customerPoNumber: "0800705692",
            orderedQuantity: 126,
            shippedQuantity: 0,
            countedQuantity: 0,
            shippedWeight: 0,
            shippedCube: 0,
            customerItemId: "659304858",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: new Date("2023-11-27T11:30:15.52"),
            verifiedMethod: VerifiedMethod.ZeroShipped,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469023,
            orderId: 2270610,
            lineItemId: 769453,
            customerPoNumber: "0800706255",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 125.4,
            shippedCube: 11.5812,
            customerItemId: "661929346",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469024,
            orderId: 2270611,
            lineItemId: 740599,
            customerPoNumber: "0800706295",
            orderedQuantity: 32,
            shippedQuantity: 32,
            countedQuantity: 32,
            shippedWeight: 240,
            shippedCube: 15.3472,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469025,
            orderId: 2270611,
            lineItemId: 740602,
            customerPoNumber: "0800706295",
            orderedQuantity: 48,
            shippedQuantity: 48,
            countedQuantity: 48,
            shippedWeight: 360,
            shippedCube: 22.992,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469026,
            orderId: 2270611,
            lineItemId: 740609,
            customerPoNumber: "0800706295",
            orderedQuantity: 96,
            shippedQuantity: 96,
            countedQuantity: 96,
            shippedWeight: 691.2,
            shippedCube: 46.0416,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469027,
            orderId: 2270612,
            lineItemId: 764319,
            customerPoNumber: "0800706193",
            orderedQuantity: 32,
            shippedQuantity: 32,
            countedQuantity: 32,
            shippedWeight: 255.36,
            shippedCube: 13.0432,
            customerItemId: "659586925",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469028,
            orderId: 2270612,
            lineItemId: 764320,
            customerPoNumber: "0800706193",
            orderedQuantity: 32,
            shippedQuantity: 32,
            countedQuantity: 32,
            shippedWeight: 236.8,
            shippedCube: 13.0432,
            customerItemId: "659586924",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469029,
            orderId: 2270612,
            lineItemId: 764321,
            customerPoNumber: "0800706193",
            orderedQuantity: 32,
            shippedQuantity: 32,
            countedQuantity: 32,
            shippedWeight: 230.4,
            shippedCube: 13.0432,
            customerItemId: "659586923",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469030,
            orderId: 2270612,
            lineItemId: 767389,
            customerPoNumber: "0800706193",
            orderedQuantity: 60,
            shippedQuantity: 60,
            countedQuantity: 60,
            shippedWeight: 870,
            shippedCube: 40.59,
            customerItemId: "662633982",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469031,
            orderId: 2270612,
            lineItemId: 767391,
            customerPoNumber: "0800706193",
            orderedQuantity: 60,
            shippedQuantity: 60,
            countedQuantity: 60,
            shippedWeight: 870,
            shippedCube: 43.314,
            customerItemId: "662633983",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469032,
            orderId: 2270613,
            lineItemId: 769083,
            customerPoNumber: "0800720679",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 270,
            shippedCube: 23.7708,
            customerItemId: "652102572",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469033,
            orderId: 2270613,
            lineItemId: 769084,
            customerPoNumber: "0800720679",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 270,
            shippedCube: 23.7708,
            customerItemId: "652102574",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469034,
            orderId: 2270613,
            lineItemId: 769085,
            customerPoNumber: "0800720679",
            orderedQuantity: 36,
            shippedQuantity: 36,
            countedQuantity: 36,
            shippedWeight: 270,
            shippedCube: 23.7708,
            customerItemId: "661150590",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469035,
            orderId: 2270614,
            lineItemId: 754568,
            customerPoNumber: "0800705899",
            orderedQuantity: 100,
            shippedQuantity: 100,
            countedQuantity: 100,
            shippedWeight: 2084,
            shippedCube: 51.2,
            customerItemId: "653398144",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469036,
            orderId: 2270614,
            lineItemId: 754569,
            customerPoNumber: "0800705899",
            orderedQuantity: 100,
            shippedQuantity: 100,
            countedQuantity: 100,
            shippedWeight: 2084,
            shippedCube: 51.2,
            customerItemId: "653398142",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469037,
            orderId: 2270614,
            lineItemId: 768952,
            customerPoNumber: "0800705899",
            orderedQuantity: 200,
            shippedQuantity: 200,
            countedQuantity: 200,
            shippedWeight: 2050,
            shippedCube: 50.16,
            customerItemId: "662828930",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469038,
            orderId: 2270614,
            lineItemId: 770060,
            customerPoNumber: "0800705899",
            orderedQuantity: 200,
            shippedQuantity: 200,
            countedQuantity: 200,
            shippedWeight: 2050,
            shippedCube: 50.16,
            customerItemId: "662828933",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469039,
            orderId: 2270614,
            lineItemId: 770062,
            customerPoNumber: "0800705899",
            orderedQuantity: 200,
            shippedQuantity: 200,
            countedQuantity: 200,
            shippedWeight: 2050,
            shippedCube: 50.16,
            customerItemId: "662804795",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469040,
            orderId: 2270614,
            lineItemId: 770064,
            customerPoNumber: "0800705899",
            orderedQuantity: 200,
            shippedQuantity: 200,
            countedQuantity: 200,
            shippedWeight: 2050,
            shippedCube: 50.16,
            customerItemId: "66828937",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469041,
            orderId: 2270615,
            lineItemId: 753274,
            customerPoNumber: "0800705580",
            orderedQuantity: 12,
            shippedQuantity: 12,
            countedQuantity: 12,
            shippedWeight: 93.468,
            shippedCube: 8.7276,
            customerItemId: "595351958",
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469042,
            orderId: 2270616,
            lineItemId: 767123,
            customerPoNumber: "0800705780",
            orderedQuantity: 22,
            shippedQuantity: 22,
            countedQuantity: 22,
            shippedWeight: 116.6,
            shippedCube: 8.9034,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        },
        {
            id: 66469043,
            orderId: 2270616,
            lineItemId: 767124,
            customerPoNumber: "0800705780",
            orderedQuantity: 22,
            shippedQuantity: 22,
            countedQuantity: 22,
            shippedWeight: 116.6,
            shippedCube: 8.9034,
            customerItemId: null,
            isSpecialOrder: false,
            isTtr: null,
            verifiedTime: null,
            verifiedMethod: null,
            refusedQuantity: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            ti: null,
            hi: null,
            slot: null,
            palletSize: null
        }
    ],
    lineItems: [
        {
            id: 404199,
            manufacturerItemId: "96152",
            universalProductCode: "00075278961520",
            description: "FFF CH & JAL CORN DOG 1-36 EA",
            unitOfMeasure: "CA",
            unitHeight: 4.875,
            unitWidth: 11.063,
            unitWeight: 11,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FF  FZ 36/4Z CHS/JAL C/DG W/BAG",
            isControlledSubstance: false
        },
        {
            id: 565418,
            manufacturerItemId: "9899780620",
            universalProductCode: "10698997806209",
            description: "BLB BUN HDG CLC GLF IW 24-2.4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.6400,
            unitWidth: 7.6950,
            unitWeight: 4.2000,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "UDIS Classic Hotdog Bun Individually Wrapped  2.4 OZ",
            isControlledSubstance: false
        },
        {
            id: 377917,
            manufacturerItemId: "10000015960",
            universalProductCode: "00880760159602",
            description: "APF TPS BGR HMSL CHK 27-6.6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.625,
            unitWidth: 9.812,
            unitWeight: 11.001,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "The Pub(R) Flame Grilled USDA Choice Beef Chuck Steak Burger  6 oz  Approx. 27 Pieces Per Case  10.13 Lbs",
            isControlledSubstance: false
        },
        {
            id: 639958,
            manufacturerItemId: "3800014688",
            universalProductCode: "00038000146886",
            description: "KFF BMKPAN 4\" 144-1.36 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.875,
            unitWidth: 9.688,
            unitWeight: 13.452,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Kellogg's Eggo Pancakes Buttermilk 1.36oz 144ct",
            isControlledSubstance: false
        },
        {
            id: 699902,
            manufacturerItemId: "65115",
            universalProductCode: "10037638148450",
            description: "PIL PCN 8PCS FRD SR729225 1-15 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.5,
            unitWidth: 9.438,
            unitWeight: 16.08,
            shelfLife: 545,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " PIERCE CHICKEN 8PC FRIED SR729225 1-15 POUND",
            isControlledSubstance: false
        },
        {
            id: 613855,
            manufacturerItemId: "30001",
            universalProductCode: "10823056300019",
            description: "TBF BUY ENMUF PL TNS FRKS 72-2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 11.25,
            unitWeight: 9.8,
            shelfLife: 456,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "English Muffin Plain  Clean  Forksplit  12/6 Packs  72/2 oz",
            isControlledSubstance: false
        },
        {
            id: 560671,
            manufacturerItemId: "O64",
            universalProductCode: "00086289408966",
            description: "CP JAL STW/ CDCH BD 4-3 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.5354,
            unitWidth: 9.8425,
            unitWeight: 13,
            shelfLife: 547,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "JALAPENO STUFFED WITH CHEDDAR CHEESE BREADED 4-3 POUND",
            isControlledSubstance: false
        },
        {
            id: 467853,
            manufacturerItemId: "08432",
            universalProductCode: "10049800084329",
            description: "RPF NYS-CHID ELCS 4-1.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9,
            unitWidth: 11.375,
            unitWeight: 8.25,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "NEW YORK STYLE CHOCOLATE ICED ECLAIRS WITH BAVARIAN MOUSSE FILLING 4-1.5 POUND",
            isControlledSubstance: false
        },
        {
            id: 516039,
            manufacturerItemId: "00766",
            universalProductCode: "10075192017669",
            description: "ROT BRD CIAB BUN SLICED 8-6 CNT",
            unitOfMeasure: "CA",
            unitHeight: 9.25,
            unitWidth: 13.75,
            unitWeight: 10.215,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD CIABATTA BUN SLICED 8-6 COUNT",
            isControlledSubstance: false
        },
        {
            id: 609890,
            manufacturerItemId: "40175",
            universalProductCode: "30616112420301",
            description: "MMF WHOLLY AVOC HLV IW 1-64 CNT",
            unitOfMeasure: "CA",
            unitHeight: 4.75,
            unitWidth: 7.12,
            unitWeight: 7.15,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Avocado Halves 64/1.5 oz-FZN",
            isControlledSubstance: false
        },
        {
            id: 710047,
            manufacturerItemId: "4130824001",
            universalProductCode: "10041308240016",
            description: "PTC RIP PC LAS SHTS 1-48 CNT",
            unitOfMeasure: "CA",
            unitHeight: 11.125,
            unitWidth: 8.062,
            unitWeight: 15.632,
            shelfLife: 450,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Marzetti Frozen Pasta Rippled Precooked Lasagna Sheets",
            isControlledSubstance: false
        },
        {
            id: 608323,
            manufacturerItemId: "10588960",
            universalProductCode: "00075361014706",
            description: "FLB BRIO BUN 6-42 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.25,
            unitWidth: 14.125,
            unitWeight: 18.73,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "EUROP BRIOCHE BUN SL 6/12PK",
            isControlledSubstance: false
        },
        {
            id: 477003,
            manufacturerItemId: "40010667",
            universalProductCode: "10072714106672",
            description: "MCN MOR-3/8\" BD/ VID ONR 4-2.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.75,
            unitWidth: 12,
            unitWeight: 11.65,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "3/8\" BATTERED VIDALIA ONION RINGS",
            isControlledSubstance: false
        },
        {
            id: 539663,
            manufacturerItemId: "65009",
            universalProductCode: "10072745650090",
            description: "PEF SHNDH TKY MECH SEPRD 4-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 4.813,
            unitWidth: 8.813,
            unitWeight: 22,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SHEN MECH SEPARATED TURKEY 15% FAT FRZ",
            isControlledSubstance: false
        },
        {
            id: 454953,
            manufacturerItemId: "54008",
            universalProductCode: "30076366540086",
            description: "WSB PSTK GLTG PRK .7 OZ 200-.7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.375,
            unitWidth: 10,
            unitWeight: 9.44,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "GOLDEN TIGER - PORK POTSTICKER 0.7 OZ - 4/50ct Bags",
            isControlledSubstance: false
        },
        {
            id: 505217,
            manufacturerItemId: "55678",
            universalProductCode: "10013087556787",
            description: "OSI CRNV CKY DG 384-1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.188,
            unitWidth: 10.813,
            unitWeight: 25.25,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FCD CARNIVAL COLORED CHOCOLATE CANDY MADE W/51% WHOLE GRAIN LAYER PACK 8/48/1 OZ",
            isControlledSubstance: false
        },
        {
            id: 633149,
            manufacturerItemId: "2981",
            universalProductCode: "10749017029815",
            description: "SSD MFCP LMBLU 7-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 8.315,
            unitWidth: 11.75,
            unitWeight: 17.17,
            shelfLife: 900,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Cookie Puck  Lemon Blueberry Manifesto 2.8 oz FZN",
            isControlledSubstance: false
        },
        {
            id: 541698,
            manufacturerItemId: "117697 - 36802",
            universalProductCode: "10039677368028",
            description: "BBH PRETZ DEMI 1-60 CNT",
            unitOfMeasure: "CA",
            unitHeight: 10.75,
            unitWidth: 15,
            unitWeight: 16.1,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "7\" PRETZEL ROLL  60CT",
            isControlledSubstance: false
        },
        {
            id: 431531,
            manufacturerItemId: "4497930512",
            universalProductCode: "00044979305124",
            description: "JJF EN PZA STX PPR TPKS 48-3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.3,
            unitWidth: 8.2,
            unitWeight: 9.8,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "STUFFED PEP PIZZA STICK 3oz/48ct",
            isControlledSubstance: false
        },
        {
            id: 385481,
            manufacturerItemId: "474789",
            universalProductCode: "00028029747898",
            description: "TRI SAM-KETA SPBO VP 8OZ 1-10 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.12,
            unitWidth: 9.72,
            unitWeight: 11.2,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SALMON  KETA 8 OZ FILLET SKIN ON PINBONE-OUT VACUUM-",
            isControlledSubstance: false
        },
        {
            id: 526505,
            manufacturerItemId: "40402",
            universalProductCode: "10073321404021",
            description: "JJF READ BK BFST BAR BNCC 48-2.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.125,
            unitWidth: 7.312,
            unitWeight: 9,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "RB BeneFit Bars BAN CHC CK 2.5/48",
            isControlledSubstance: false
        },
        {
            id: 462080,
            manufacturerItemId: "00114",
            universalProductCode: "30046100001142",
            description: "SCS CH MDCHD SLC YL 12-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.198,
            unitWidth: 8.974,
            unitWeight: 6.73,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SARGENTO12/8 OZ SLICED MEDIUM CHEDDAR CHEESE",
            isControlledSubstance: false
        },
        {
            id: 671802,
            manufacturerItemId: "357802",
            universalProductCode: "10012724578021",
            description: "RMC XST BFP 8-1 RN 120-2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.88,
            unitWidth: 11.25,
            unitWeight: 15.9,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " STRATOS BEEF PATTY 8 1 ROUND 120-2 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 560631,
            manufacturerItemId: "10030",
            universalProductCode: "90002444100301",
            description: "STS LAMB RACK FRENCHED 16-19 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7,
            unitWidth: 13,
            unitWeight: 21,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "LAMB RACKS  FRENCHED  18 TO 20OZ  NEW ZEALAND",
            isControlledSubstance: false
        },
        {
            id: 481845,
            manufacturerItemId: "94562-32106",
            universalProductCode: "10094562321069",
            description: "GMF CROI-BTR CRV 64-2.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11.31,
            unitWidth: 16.17,
            unitWeight: 12,
            shelfLife: 372,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Baked Croissant Butter Curved 2.5 oz",
            isControlledSubstance: false
        },
        {
            id: 684813,
            manufacturerItemId: "10383180928",
            universalProductCode: "00023700049551",
            description: "TYS RDL CKWG FC CTD SCTN 1-15 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 9.5,
            unitWeight: 15.744,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Tyson Red Label(R) NAE Frozen Fully Cooked Oven Roasted Starch Coated Jumbo Bone-In Chicken Wings  Approx. 90-165 Pieces  3/5 Lbs",
            isControlledSubstance: false
        },
        {
            id: 518898,
            manufacturerItemId: "22553",
            universalProductCode: "10814598010009",
            description: "BEL PZA 5CS RICT 12\" FDSV 12-1.843",
            unitOfMeasure: "CA",
            unitHeight: 7.874,
            unitWidth: 13.0007,
            unitWeight: 25.95,
            shelfLife: 240,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PIZZA 5 CHEESE RISING CRUST 12 INCH FOOD SERVICE 12-1.843 POUND",
            isControlledSubstance: false
        },
        {
            id: 608611,
            manufacturerItemId: "4601216319",
            universalProductCode: "10046012163194",
            description: "FSF LAF CROI MARG SDW CDSL 84-1.75",
            unitOfMeasure: "CA",
            unitHeight: 19,
            unitWidth: 12.313,
            unitWeight: 12.689,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " LA FRANCAISE CROISSANT MARGARINE SANDWICH CLOSED SLICED 84-1.75 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 506604,
            manufacturerItemId: "2265530302",
            universalProductCode: "90022655303025",
            description: "BLF BTRB TURKEY BACON RTC 2-6 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 10.75,
            unitWeight: 13,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BACON  TURKEY RANDOM COUNT SLICED UNSMOKED RAW BAG FROZEN",
            isControlledSubstance: false
        },
        {
            id: 470952,
            manufacturerItemId: "05419",
            universalProductCode: "00049800054196",
            description: "RPF DGH CRAN ORG SCON 40-10 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.125,
            unitWidth: 11.563,
            unitWeight: 26.475,
            shelfLife: 210,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DOUGH CRANBERRY ORANGE SCONE 40-10 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 448676,
            manufacturerItemId: "00212",
            universalProductCode: "10075192002122",
            description: "ROT BRD SR LG OVL 8-1 CNT",
            unitOfMeasure: "CA",
            unitHeight: 10.75,
            unitWidth: 13.625,
            unitWeight: 19.883,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD SOUR LARGE OVAL 8-1 COUNT",
            isControlledSubstance: false
        },
        {
            id: 383357,
            manufacturerItemId: "10000016641",
            universalProductCode: "00880760008078",
            description: "APF AVC PRK FRIT DELUXE 40-4.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.312,
            unitWidth: 12.562,
            unitWeight: 10.714,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "AdvancePierre(TM) Gold Label Excluxive Cut(R) Deluxe Whole Muscle Raw Breaded Pork Loin Fritters  4 oz  Approx. 40 Pieces  10 Lbs",
            isControlledSubstance: false
        },
        {
            id: 592840,
            manufacturerItemId: "23060030",
            universalProductCode: "10072586600308",
            description: "JJF JC C/ PRE MANG SWB PMG 96-4.5 F",
            unitOfMeasure: "CA",
            unitHeight: 10,
            unitWidth: 12,
            unitWeight: 28.83,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "WF-CUP-MAN/STR/POM-4.4OZ/96CT",
            isControlledSubstance: false
        },
        {
            id: 640267,
            manufacturerItemId: "18000-37732",
            universalProductCode: "10018000377326",
            description: "GMF PANC MIN M/ BUST 72-3.17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11,
            unitWidth: 11.75,
            unitWeight: 18.4,
            shelfLife: 279,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Frozen Mini Pancakes Maple Burst'n(TM) 3.17 oz",
            isControlledSubstance: false
        },
        {
            id: 364345,
            manufacturerItemId: "10013800300338",
            universalProductCode: "10013800300338",
            description: "NFS ENTR-STOUF-MTLF W/G 4-58 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.55,
            unitWidth: 13.2,
            unitWeight: 16.35,
            shelfLife: 300,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Stouffer's Meatloaf with Gravy 4 x 58 ounces",
            isControlledSubstance: false
        },
        {
            id: 642288,
            manufacturerItemId: "12258",
            universalProductCode: "10033547122581",
            description: "MUF SUW SAND SNBT STBRY 96-2.8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.75,
            unitWidth: 16,
            unitWeight: 17.8,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Sunbutter Strawberry Sandwich.CA",
            isControlledSubstance: false
        },
        {
            id: 536074,
            manufacturerItemId: "1PK03482020",
            universalProductCode: "10025753031054",
            description: "TMS HVC PCHP BD ORNT 4-2.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.813,
            unitWidth: 12.125,
            unitWeight: 11.2,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Panko Breaded Pickle Chips 4/2.5 LB",
            isControlledSubstance: false
        },
        {
            id: 695992,
            manufacturerItemId: "100620",
            universalProductCode: "10042636021568",
            description: "ACE MEH UNFLD BAR DONU 78-2.1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.69,
            unitWidth: 13.25,
            unitWeight: 10.8,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Unfilled Bar Donut",
            isControlledSubstance: false
        },
        {
            id: 565601,
            manufacturerItemId: "78372",
            universalProductCode: "10072180783728",
            description: "LCF CGL QUE CH WGRA LVSM 1-96 EA",
            unitOfMeasure: "CA",
            unitHeight: 10.875,
            unitWidth: 11.625,
            unitWeight: 28.06,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "COYOTE GRILL(R) Quesadilla Cheese",
            isControlledSubstance: false
        },
        {
            id: 702837,
            manufacturerItemId: "800053",
            universalProductCode: "10073435070273",
            description: "KHB KNG SWTRL OG L& 10-24 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11.88,
            unitWidth: 13.5,
            unitWeight: 18.8,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "King's Hawaiian Sweet Rolls   24 Pack Original Rolls - Sliced",
            isControlledSubstance: false
        },
        {
            id: 557603,
            manufacturerItemId: "74797",
            universalProductCode: "10072180747973",
            description: "LCF VPA SCRY CH 12\" 1-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 8.75,
            unitWidth: 11.625,
            unitWeight: 20.49,
            shelfLife: 300,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "VILLA PRIMA(R) SCRATCH READY(R) Pizza Cheese",
            isControlledSubstance: false
        },
        {
            id: 468402,
            manufacturerItemId: "16416",
            universalProductCode: "00049800164161",
            description: "RPF DG PZA PRSHT THK 14\" 24-26 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.125,
            unitWidth: 14.25,
            unitWeight: 40.79,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DOUGH PIZZA PRE-SHEET THICK 14 INCH 24-26 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 403432,
            manufacturerItemId: "40010122",
            universalProductCode: "10075361021534",
            description: "FLB BRD TXTST 17S 10-24 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.25,
            unitWidth: 14.5,
            unitWeight: 17,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD  WHITE 17 SLICE TEXAS TOAST FROZEN",
            isControlledSubstance: false
        },
        {
            id: 663683,
            manufacturerItemId: "10599110",
            universalProductCode: "00075361089148",
            description: "FLB 6\" PRMR NE HDGB 8-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 9.97,
            unitWidth: 13.5,
            unitWeight: 16.25,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "EUROP 6\" PREM NEW ENGL HOT 8/12PK",
            isControlledSubstance: false
        },
        {
            id: 505213,
            manufacturerItemId: "55674",
            universalProductCode: "10013087556749",
            description: "OSI RF BTR SUG CKY DG 384-1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.188,
            unitWidth: 10.813,
            unitWeight: 25.25,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FROZEN COOKIE DOUGH SUGAR MADE W/ 51% WHOLE GRAIN LAYER PACK 1/384/1 OZ",
            isControlledSubstance: false
        },
        {
            id: 682140,
            manufacturerItemId: "22610",
            universalProductCode: "00049578226108",
            description: "DCC DAS CCH BROW 32 CT 1-2 CNT",
            unitOfMeasure: "CA",
            unitHeight: 5.2756,
            unitWidth: 13.8583,
            unitWeight: 14.1,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " DAVID'S CHOCOLATE CHIP BROWNIE 32 CUT 1-2 COUNT",
            isControlledSubstance: false
        },
        {
            id: 411184,
            manufacturerItemId: "10772140928",
            universalProductCode: "00023700601896",
            description: "TPF TYS FNK-ABF 6\" 5/1 RTO 2-3.3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.125,
            unitWidth: 10.812,
            unitWeight: 10.644,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Tyson(R) Beef Franks  5:1 Links Per Lb  6.5 Inch  2/5 Lbs  Frozen",
            isControlledSubstance: false
        },
        {
            id: 683636,
            manufacturerItemId: "101832",
            universalProductCode: "10042636043478",
            description: "ACE MEH CH'C DHL 600-.6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.69,
            unitWidth: 13.25,
            unitWeight: 20.29,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Chocolate Cake Hole",
            isControlledSubstance: false
        },
        {
            id: 671499,
            manufacturerItemId: "63813",
            universalProductCode: "10072745638135",
            description: "PEF C/BM SHRD FC 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.125,
            unitWidth: 10.563,
            unitWeight: 10.8,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PERDUE FC IQF 3/4\" PULLED CHICKEN BREAST",
            isControlledSubstance: false
        },
        {
            id: 11991,
            manufacturerItemId: "07156",
            universalProductCode: "10032100071564",
            description: "SLF CHF PIE-BSCR PBK 10\" 6-2.062 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.8,
            unitWidth: 10.3,
            unitWeight: 14.897,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " CHEF PIERRE PIE BOSTON CREME PRE-BAKED 10 INCH 6-2.062 POUND",
            isControlledSubstance: false
        },
        {
            id: 349041,
            manufacturerItemId: "69100",
            universalProductCode: "00035367691004",
            description: "LCF MHR EGGR-PRK & VG 3Z 6-12-3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.625,
            unitWidth: 9.25,
            unitWeight: 15,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MINH(R) Egg Roll Pork & Vegetable",
            isControlledSubstance: false
        },
        {
            id: 467849,
            manufacturerItemId: "12300",
            universalProductCode: "00049800123007",
            description: "RPF DGH GMT CINN ROLL LOG. 9-3 LB",
            unitOfMeasure: "CA",
            unitHeight: 8.75,
            unitWidth: 9.125,
            unitWeight: 28.64,
            shelfLife: 210,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DOUGH GOURMET CINNAMON ROLL LOG. 9-3 POUND",
            isControlledSubstance: false
        },
        {
            id: 44144,
            manufacturerItemId: "332160",
            universalProductCode: "10077589371606",
            description: "KRF SPANAKOPITA-3 OZ 3-24 EA",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 13.125,
            unitWeight: 15,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SPANAKOPITA 3 OZ -72 PC KRONOS",
            isControlledSubstance: false
        },
        {
            id: 468585,
            manufacturerItemId: "88313",
            universalProductCode: "10016362883134",
            description: "RPF BYR BF-CHPD W/ BBQ CBW 4-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 13.375,
            unitWeight: 21.651,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BYRON'S BEEF CHOPPED WITH BARBECUE COWBOY SAUCE 4-5 POUND",
            isControlledSubstance: false
        },
        {
            id: 520437,
            manufacturerItemId: "10383200928",
            universalProductCode: "00023700026132",
            description: "TYS RDL PRE TNL BD HOM 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 9.188,
            unitWeight: 10.636,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Tyson Red Label(R) NAE Frozen Fully Cooked Homestyle Breaded Chicken Tenderloins  Approx. 64-94 Pieces  2/5 Lbs",
            isControlledSubstance: false
        },
        {
            id: 448679,
            manufacturerItemId: "00216",
            universalProductCode: "10075192002160",
            description: "ROT BRD OPTP DIN L SLC 6-1 CNT",
            unitOfMeasure: "CA",
            unitHeight: 5.875,
            unitWidth: 19.375,
            unitWeight: 12.571,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD OPEN TOP DINNER LOAF SLICED 6-1 COUNT",
            isControlledSubstance: false
        },
        {
            id: 685179,
            manufacturerItemId: "1000005935",
            universalProductCode: "10072714004619",
            description: "MCN ORNGS BBAT 4-2.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.75,
            unitWidth: 12,
            unitWeight: 11.06,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "IPA BEER BATTERED ONION RINGS",
            isControlledSubstance: false
        },
        {
            id: 364430,
            manufacturerItemId: "10013800305081",
            universalProductCode: "10013800305081",
            description: "NFS SPIN-STOUF-ARTI DIP 4-4 LB",
            unitOfMeasure: "CA",
            unitHeight: 3.8,
            unitWidth: 11.1,
            unitWeight: 17.1,
            shelfLife: 600,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Stouffer's Spinach Artichoke Dip Pouch 4 x 64 ounces  pouch",
            isControlledSubstance: false
        },
        {
            id: 633145,
            manufacturerItemId: "3129",
            universalProductCode: "10749017031290",
            description: "SSD MFCP STCML CRNC 7-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 8.35,
            unitWidth: 11.75,
            unitWeight: 17.17,
            shelfLife: 900,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Cookie Puck  Salted Caramel Crunch Manifesto 3 oz FZN",
            isControlledSubstance: false
        },
        {
            id: 677326,
            manufacturerItemId: "70800801",
            universalProductCode: "10012724008016",
            description: "RMC XRP GBY 80/20 2-1 20-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.38,
            unitWidth: 11.44,
            unitWeight: 10.9,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " DOUBLE RED PROVISIONS GROUND BEEF PATTY 80/20 TWO 1 20-8 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 532423,
            manufacturerItemId: "7703008",
            universalProductCode: "10074624014986",
            description: "CVM TNT/SSO BRPT OV 75/25 40-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 13,
            unitWeight: 21,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TNT Beef Patties with Seasoning  8 oz.",
            isControlledSubstance: false
        },
        {
            id: 688827,
            manufacturerItemId: "13026",
            universalProductCode: "00076598315673",
            description: "RPF PCPBKD 11.75\" 24-12.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.13,
            unitWidth: 13.25,
            unitWeight: 20.738,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PIZZA CRUST PAR BAKED 11.75 INCH 24-12.5 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 358311,
            manufacturerItemId: "10000028017",
            universalProductCode: "00080939928019",
            description: "APF TPS BGR-CHUCK PUB 40-4.4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 9.812,
            unitWeight: 10.834,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "The Pub(R) Flame Grilled USDA Choice Beef Chuck Steak Burger  4 oz  Approx. 40 Pieces Per Case  10 Lbs",
            isControlledSubstance: false
        },
        {
            id: 441281,
            manufacturerItemId: "10042060928",
            universalProductCode: "00023700548344",
            description: "TYS CKNTF HOM BD 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 9.5,
            unitWeight: 10.738,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Tyson(R) Uncooked  Homestyle Chicken Breast Tenderloin Fritters  3 oz  50 Pieces  2/5 Lb",
            isControlledSubstance: false
        },
        {
            id: 354329,
            manufacturerItemId: "10000097203",
            universalProductCode: "00080939961030",
            description: "APF QTF STK-SW STY CFS 30-5.53 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.812,
            unitWidth: 12.562,
            unitWeight: 10.747,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Quik-To-Fix(R) Platinum Label USDA Choice Raw Homestyle Breaded Cubed Country Fried Beef Steak Fritters  5.33 Servings Per Case  Approx. 30 Pieces  10 Lbs",
            isControlledSubstance: false
        },
        {
            id: 388251,
            manufacturerItemId: "1CR01845030",
            universalProductCode: "10025753014880",
            description: "TMS CPJ CRAB-TRPK STFD 2Z 72-2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.938,
            unitWidth: 11.625,
            unitWeight: 11.45,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CAP'N JOE  STUFFED CRAB SHELLS  TRAY-PACKED  6/12/2 OZ",
            isControlledSubstance: false
        },
        {
            id: 409525,
            manufacturerItemId: "50010156",
            universalProductCode: "10072714101561",
            description: "MCN APP-GARL BD MUSH 4-4 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.25,
            unitWidth: 12,
            unitWeight: 17.25,
            shelfLife: 240,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "GARLIC BREADED MUSHROOMS",
            isControlledSubstance: false
        },
        {
            id: 633143,
            manufacturerItemId: "3025",
            universalProductCode: "10749017030255",
            description: "SSD SDY'S MFCP CCK 7-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 8.315,
            unitWidth: 11.75,
            unitWeight: 17.09,
            shelfLife: 900,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Cookie Puck  Sandys Chocolate Chunk Manifesto 3 oz FZN",
            isControlledSubstance: false
        },
        {
            id: 366066,
            manufacturerItemId: "10000001365",
            universalProductCode: "10071068013650",
            description: "SLM STF CDOG-CLSC AL MEAT 36-2.81 O",
            unitOfMeasure: "CA",
            unitHeight: 3.688,
            unitWidth: 11.25,
            unitWeight: 6.696,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " STATE FAIR CORN DOGS CLASSIC ALL MEAT 36-2.81 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 535170,
            manufacturerItemId: "84003",
            universalProductCode: "00049578840038",
            description: "DCC DAS MUF BNNT TR 1-6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4,
            unitWidth: 12.9,
            unitWeight: 5.5,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " DAVID'S MUFFIN BANANA NUT TRAY 1-6 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 664120,
            manufacturerItemId: "357825",
            universalProductCode: "10012724578250",
            description: "RMC XST BFP 2:1 30-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.88,
            unitWidth: 11.25,
            unitWeight: 15.9,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " STRATOS BEEF PATTY TWO 1 30-8 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 560672,
            manufacturerItemId: "335",
            universalProductCode: "00086289408973",
            description: "CP MOZZ CHSST ITA BD 4-3 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.6929,
            unitWidth: 9.9213,
            unitWeight: 13,
            shelfLife: 547,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MOZZARELLA CHEESE STICKS ITALIAN BREADED 4-3 POUND",
            isControlledSubstance: false
        },
        {
            id: 406103,
            manufacturerItemId: "70010010",
            universalProductCode: "10072714100106",
            description: "MCN ONR-BCI BBAT TNCT 3/8\" 6-2.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 11,
            unitWidth: 12,
            unitWeight: 16.3,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BEER BATTERED THIN CUT ONION RINGS",
            isControlledSubstance: false
        },
        {
            id: 726300,
            manufacturerItemId: "1086X",
            universalProductCode: "00833282006510",
            description: "SSB S-M ICD LEM PNDCK 1/4. 4-1 EA",
            unitOfMeasure: "CA",
            unitHeight: 5.13,
            unitWidth: 4.56,
            unitWeight: 5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " SWEET SAM'S ICED LEMON POUND CAKE 1/4. 4-1 EACH",
            isControlledSubstance: false
        },
        {
            id: 639152,
            manufacturerItemId: "3800014689",
            universalProductCode: "00038000146893",
            description: "KFF WFFLS WGA WHE 144-1.23 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11.125,
            unitWidth: 9.688,
            unitWeight: 12.864,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Kellogg's Eggo Nutri-Grain Waffles Wheat 1.23oz 144ct",
            isControlledSubstance: false
        },
        {
            id: 344467,
            manufacturerItemId: "4497902051",
            universalProductCode: "20044979020519",
            description: "JJF PIE-APPLE SRVG SVE {NR 90-3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 10.9,
            unitWeight: 21.95,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FRYABLE APPLE TRNOVR BUBBLY CRUST 3OZ",
            isControlledSubstance: false
        },
        {
            id: 654706,
            manufacturerItemId: "SH2125PDROF52",
            universalProductCode: "10748734008219",
            description: "MZC WSHM R/ PDTF 21/25 5-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 7,
            unitWidth: 10.25,
            unitWeight: 13,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "21/25 RAW T/OFF W  SHRIMP (5x2)",
            isControlledSubstance: false
        },
        {
            id: 517208,
            manufacturerItemId: "10070247192124",
            universalProductCode: "10070247192124",
            description: "STH  WLD WGS FC PRK WGS 3-3.02 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.438,
            unitWidth: 9.75,
            unitWeight: 9.624,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "WILD WINGS FULLY COOKED PORK WINGS 3-3.02 POUND",
            isControlledSubstance: false
        },
        {
            id: 400591,
            manufacturerItemId: "400591",
            universalProductCode: "10684476012124",
            description: "VGF A.C PS&CRTS 12-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 9,
            unitWidth: 11.5,
            unitWeight: 27.2,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "A.C PEAS AND CARROTS 12-2 POUND",
            isControlledSubstance: false
        },
        {
            id: 601351,
            manufacturerItemId: "2001010",
            universalProductCode: "10073994001961",
            description: "HIN HDY CR' SFTSH WHALE SZ 36-9 CNT",
            unitOfMeasure: "CA",
            unitHeight: 6.8,
            unitWidth: 10.1,
            unitWeight: 11.24,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Crab  Soft Shell  Whale  Avg 3.9 oz  Frozen  Imported  Wild Caught",
            isControlledSubstance: false
        },
        {
            id: 1794,
            manufacturerItemId: "1902545569",
            universalProductCode: "10019025455693",
            description: "FSF PNN PSPD 10X15X1/8\" 20-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.5,
            unitWidth: 11.75,
            unitWeight: 16.5,
            shelfLife: 360,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " PENNANT PASTRY PUFF DOUGH 10X15X1/8\" 20-12 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 487173,
            manufacturerItemId: "1801F",
            universalProductCode: "10041622018018",
            description: "AFD AMN PES-BSL 3-30 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.1,
            unitWidth: 5.1,
            unitWeight: 6.27,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SAUCE PESTO BASIL",
            isControlledSubstance: false
        },
        {
            id: 505216,
            manufacturerItemId: "55670",
            universalProductCode: "10013087556701",
            description: "OSI RF CHO CHP CKY DG WGRA 384-1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.188,
            unitWidth: 10.813,
            unitWeight: 25.25,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FROZEN COOKIE DOUGH CHOCOLATE CHIP MADE W/ 51% WHOLE GRAIN LAYER PACK 8/48/1 OZ",
            isControlledSubstance: false
        },
        {
            id: 710497,
            manufacturerItemId: "4816270500",
            universalProductCode: "10748162705001",
            description: "PTC DIN YRLS 1-120 CNT",
            unitOfMeasure: "CA",
            unitHeight: 11.562,
            unitWidth: 11.938,
            unitWeight: 12.429,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Sister Schubert's Dinner Yeast Rolls",
            isControlledSubstance: false
        },
        {
            id: 478360,
            manufacturerItemId: "70010677",
            universalProductCode: "10072714106771",
            description: "MCN BCI-BL&TN ORNGS 5/8\" 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.25,
            unitWidth: 12,
            unitWeight: 13.28,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BLACK & TAN ONION RINGS",
            isControlledSubstance: false
        },
        {
            id: 639179,
            manufacturerItemId: "4062",
            universalProductCode: "10749017040629",
            description: "SSD CHY MAR MANIFESTO IW 40-1 EA",
            unitOfMeasure: "CA",
            unitHeight: 6.437,
            unitWidth: 9.125,
            unitWeight: 6.21,
            shelfLife: 900,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CHEWY MARSHMALLOW MANIFESTO BAR CGF IW 2.1 OZ",
            isControlledSubstance: false
        },
        {
            id: 664121,
            manufacturerItemId: "357845",
            universalProductCode: "10012724578458",
            description: "RMC XST BFP DSY 4:1 60-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.88,
            unitWidth: 11.25,
            unitWeight: 15.9,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " STRATOS BEEF PATTY DAISY 4 1 60-4 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 623334,
            manufacturerItemId: "74367200259",
            universalProductCode: "00743672002599",
            description: "JBM BGLS ASCH L& 8-6 EA",
            unitOfMeasure: "CA",
            unitHeight: 9,
            unitWidth: 9.5,
            unitWeight: 13,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "ASIAGO CHEESE BAGEL 4oz SLICED",
            isControlledSubstance: false
        },
        {
            id: 556132,
            manufacturerItemId: "MCX05156",
            universalProductCode: "10072714051569",
            description: "MCN F. FRH STY 5/16\" SKON 6-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 10.25,
            unitWidth: 12,
            unitWeight: 31.65,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MCCAIN FRESH-STYLE FRIES 5/16\" SKIN ON 6X5 LBS",
            isControlledSubstance: false
        },
        {
            id: 539767,
            manufacturerItemId: "7388",
            universalProductCode: "10072745073882",
            description: "PEF CBFL ITAS 3.9 SR555145 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.125,
            unitWidth: 10.563,
            unitWeight: 11,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PRD FC CAPRI ITALIAN CKN FILET 3.88 OZ",
            isControlledSubstance: false
        },
        {
            id: 683637,
            manufacturerItemId: "101831",
            universalProductCode: "10042636043355",
            description: "ACE MEH PLN CK DHL 600-.6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.69,
            unitWidth: 13.25,
            unitWeight: 20.29,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Plain Cake Hole",
            isControlledSubstance: false
        },
        {
            id: 523794,
            manufacturerItemId: "23060010",
            universalProductCode: "10072586600100",
            description: "JJF JCP WFT PRE ORG-PN 1P 96-4.4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10,
            unitWidth: 11.8,
            unitWeight: 29,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "WF-JUICE CUP-ORG PNAPPL-4.4OZ/96",
            isControlledSubstance: false
        },
        {
            id: 518519,
            manufacturerItemId: "518519",
            universalProductCode: "10684476027319",
            description: "FS CRAB CNSNCL 5T8 GULF 1-30 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.5637,
            unitWidth: 16.9291,
            unitWeight: 37.05,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CRAB CANADIAN SNOW CLUSTERS 5 TO 8 OUNCE GULF 1-30 POUND",
            isControlledSubstance: false
        },
        {
            id: 528835,
            manufacturerItemId: "10500160",
            universalProductCode: "00075361014072",
            description: "FLB DIR GLN PRTD BG .75Z 6-24 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.75,
            unitWidth: 12.375,
            unitWeight: 11.5,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "GOLDEN DINNER ROLL .75 OZ",
            isControlledSubstance: false
        },
        {
            id: 446432,
            manufacturerItemId: "86268",
            universalProductCode: "10071007862684",
            description: "RUZ TNDOS BFST FTST SAU 3Z 3-8-.187",
            unitOfMeasure: "CA",
            unitHeight: 5.25,
            unitWidth: 7.562,
            unitWeight: 5.03,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TORNADOS BREAKFAST FRENCH TOAST SAUSAGE 3 OUNCE 3-8-.187 POUND",
            isControlledSubstance: false
        },
        {
            id: 673296,
            manufacturerItemId: "19091",
            universalProductCode: "00810818021254",
            description: "VNB 11.75\" SSO CAUL PCRS 24-7.3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 12.25,
            unitWeight: 12.15,
            shelfLife: 240,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "GLUTEN FREE 11.75\" SEASONED CAULIFLOWER PIZZA CRUST (GF-0211175-24)",
            isControlledSubstance: false
        },
        {
            id: 539576,
            manufacturerItemId: "82036",
            universalProductCode: "10072745820363",
            description: "PEF FC KICKN WGS SPBRCKN 3-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.5,
            unitWidth: 9.375,
            unitWeight: 17,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PERD FC BRD KICK-N-WING SPICY CKN PORT",
            isControlledSubstance: false
        },
        {
            id: 567683,
            manufacturerItemId: "71064",
            universalProductCode: "00086478710641",
            description: "BMC CKDG SWB SHCK 200-1.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 11.812,
            unitWeight: 20.25,
            shelfLife: 547,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Cookie Dough Strawberry Shortcake 1.5 oz",
            isControlledSubstance: false
        },
        {
            id: 564243,
            manufacturerItemId: "70748",
            universalProductCode: "00086478707481",
            description: "BMC CKDG PB W/RSPC 200-1.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 11.812,
            unitWeight: 20.25,
            shelfLife: 547,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Cookie Dough Peanut Butter w/reeses peices 1.5 oz",
            isControlledSubstance: false
        },
        {
            id: 341786,
            manufacturerItemId: "341786",
            universalProductCode: "10684476003757",
            description: "FF PCH-SLC IQF FRESTN 1-30 LB",
            unitOfMeasure: "CA",
            unitHeight: 10.6,
            unitWidth: 12.3,
            unitWeight: 31.75,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PEACH SLICED INDIVIDUAL QUICK FROZEN FREESTONE 1-30 POUND",
            isControlledSubstance: false
        },
        {
            id: 532420,
            manufacturerItemId: "7703004",
            universalProductCode: "10074624014900",
            description: "CVM TNT/SSO BRPT HOM 75/25 80-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 13,
            unitWeight: 21,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TNT Beef Patties with Seasoning 4 oz.",
            isControlledSubstance: false
        },
        {
            id: 365935,
            manufacturerItemId: "365935",
            universalProductCode: "10684476003962",
            description: "FF CHRY IQF RDTP 1-40 LB",
            unitOfMeasure: "CA",
            unitHeight: 11.4,
            unitWidth: 12.2,
            unitWeight: 42,
            shelfLife: 1095,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CHERRY INDIVIDUAL QUICK FROZEN RED TART PITTED 1-40 POUND",
            isControlledSubstance: false
        },
        {
            id: 535692,
            manufacturerItemId: "01120",
            universalProductCode: "00763719011209",
            description: "HLC CATF WHDO IQF 15/17 1-15 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.85,
            unitWidth: 11.5,
            unitWeight: 16.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CATFISH WHOLE HEAD OFF INDIVIDUAL QUICK FROZEN 15/17 1-15 POUND",
            isControlledSubstance: false
        },
        {
            id: 344086,
            manufacturerItemId: "3295",
            universalProductCode: "10073321032958",
            description: "JJF BAV BKY PRET-STX 72-2.4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.709,
            unitWidth: 9.449,
            unitWeight: 12.2,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BAVARIAN SOFT PRETZEL STICK-2.4OZ/72",
            isControlledSubstance: false
        },
        {
            id: 360759,
            manufacturerItemId: "X14",
            universalProductCode: "10044979024145",
            description: "LWF FRY-CONTINA 1/2\" 6-4.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 10.75,
            unitWidth: 13,
            unitWeight: 29,
            shelfLife: 720,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "1/2\" Concertinas(R) Frozen French Fried Potatoes",
            isControlledSubstance: false
        },
        {
            id: 403570,
            manufacturerItemId: "12430880",
            universalProductCode: "00075361014386",
            description: "FLB CANNO SHLS LG 48-1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 11.5,
            unitWeight: 4,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SHELL  CANNOLI PASTRY LARGE 1 OZ FROZEN",
            isControlledSubstance: false
        },
        {
            id: 590832,
            manufacturerItemId: "10728400269",
            universalProductCode: "00031400054379",
            description: "TPF BON BFPK MTB OR ITAS 1-10 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.188,
            unitWidth: 11.812,
            unitWeight: 11.058,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Bonici(R) Fully Cooked Oven Roasted Italian Style Pork and Beef Meatballs  .5 oz  Approx. 320 Count  2/5 Lbs",
            isControlledSubstance: false
        },
        {
            id: 562973,
            manufacturerItemId: "562973",
            universalProductCode: "10070041600122",
            description: "FS CKD TOF WSHM 41/50 5-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 11.25,
            unitWeight: 13,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "COOKED TAIL OFF WHITE SHRIMP 41/50 5-2 POUND",
            isControlledSubstance: false
        },
        {
            id: 659758,
            manufacturerItemId: "80036",
            universalProductCode: "00813993000120",
            description: "RPF BL&S VAN SH 12-10 FO",
            unitOfMeasure: "CA",
            unitHeight: 5.6,
            unitWidth: 12,
            unitWeight: 9.4,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BLEND AND SERVE VANILLA SHAKE 12-10 FLUID OUNCE",
            isControlledSubstance: false
        },
        {
            id: 640775,
            manufacturerItemId: "69333",
            universalProductCode: "00048200693332",
            description: "FAB SSON BF PAT 20-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.6,
            unitWidth: 10.63,
            unitWeight: 10.75,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FROSTY ACRES SEASONED BEEF PATTIES 20-8 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 375479,
            manufacturerItemId: "19008",
            universalProductCode: "00079821190085",
            description: "HOL BEEF-CNTR STK 4-1 40-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.08,
            unitWidth: 11.09,
            unitWeight: 10.76,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BEEF COUNTRY STEAK 4 1 40-4 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 589833,
            manufacturerItemId: "16982",
            universalProductCode: "10038483169829",
            description: "WAY DQH CKNBR MT SHRD 'N 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.875,
            unitWidth: 10.375,
            unitWeight: 10.879,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " WAYNE FARMS CHICKEN BREAST MEAT SHREDDED NATURAL 2-5 POUND",
            isControlledSubstance: false
        },
        {
            id: 404205,
            manufacturerItemId: "95026",
            universalProductCode: "00075278950265",
            description: "FFF CHLCHS CORN DOG 1-36 EA",
            unitOfMeasure: "CA",
            unitHeight: 4.875,
            unitWidth: 11.063,
            unitWeight: 10.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CHILI CHS CKN CORN DOG 4.0 - 36 CNT",
            isControlledSubstance: false
        },
        {
            id: 726908,
            manufacturerItemId: "4130827014",
            universalProductCode: "10041308270143",
            description: "PTC PAS FET NSTS 288-1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 12.375,
            unitWidth: 12.312,
            unitWeight: 20.053,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Marzetti Frozen Pasta Fettuccini Nests",
            isControlledSubstance: false
        },
        {
            id: 388181,
            manufacturerItemId: "1SH01305020",
            universalProductCode: "10025753012787",
            description: "TMS TMD SHI-DPDST-POPC 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.438,
            unitWidth: 12.125,
            unitWeight: 13.8,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SHRIMP  BREADED  POPCORN  DIPT'N DUSTED  6-2 LB",
            isControlledSubstance: false
        },
        {
            id: 449152,
            manufacturerItemId: "19798",
            universalProductCode: "10071007197984",
            description: "RUZ BURR EM SDBF STKCS IW 12-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.124,
            unitWidth: 7.571,
            unitWeight: 6.45,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BURRITO EL MONTEREY SHREDDED BEEF STEAK AND CHEESE INDIVIDUALLY WRAPPED 12-8 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 631554,
            manufacturerItemId: "Z041809056",
            universalProductCode: "05410811000246",
            description: "AVI WFFLS PRL SUG 1-40 CNT",
            unitOfMeasure: "CA",
            unitHeight: 6.07,
            unitWidth: 12.06,
            unitWeight: 8.82,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "40ct / 3.17oz Pearl Sugar Waffles",
            isControlledSubstance: false
        },
        {
            id: 50866,
            manufacturerItemId: "100007718",
            universalProductCode: "10038057100258",
            description: "SFF SNF LQ E SCRAM WMK BG 6-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 12.13,
            unitWidth: 8,
            unitWeight: 31.3,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Scrambled Egg Blend - No Salt Added  6/5 lb. Frozen Bag",
            isControlledSubstance: false
        },
        {
            id: 411155,
            manufacturerItemId: "0204320",
            universalProductCode: "10050665020438",
            description: "WSB CHSST FRE JALA HTZRLA 4-3 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.25,
            unitWidth: 9.875,
            unitWeight: 13,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Fred's - Hotzzarella Jalapeno Cheese Stick - 3-1/4in - 4/3# Bags",
            isControlledSubstance: false
        },
        {
            id: 411155,
            manufacturerItemId: "0204320",
            universalProductCode: "10050665020438",
            description: "WSB CHSST FRE JALA HTZRLA 4-3 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.25,
            unitWidth: 9.875,
            unitWeight: 13,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Fred's - Hotzzarella Jalapeno Cheese Stick - 3-1/4in - 4/3# Bags",
            isControlledSubstance: false
        },
        {
            id: 539552,
            manufacturerItemId: "38001",
            universalProductCode: "10072745380010",
            description: "PEF FC H/S FRYB CKWG 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.313,
            unitWidth: 9.375,
            unitWeight: 12,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SHENANDOAH HOT N SPICY CKN KICK N WINGS",
            isControlledSubstance: false
        },
        {
            id: 658633,
            manufacturerItemId: "50348",
            universalProductCode: "10684476050348",
            description: "FS BARMNDI FLT BNLSL IWP 8-10 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.94,
            unitWidth: 10.47,
            unitWeight: 13,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BARRAMUNDI FILLET BONELESS & SKINLESS IWP 8-10 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 446432,
            manufacturerItemId: "86268",
            universalProductCode: "10071007862684",
            description: "RUZ TNDOS BFST FTST SAU 3Z 3-8-.187",
            unitOfMeasure: "CA",
            unitHeight: 5.25,
            unitWidth: 7.562,
            unitWeight: 5.03,
            shelfLife: 455,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TORNADOS BREAKFAST FRENCH TOAST SAUSAGE 3 OUNCE 3-8-.187 POUND",
            isControlledSubstance: false
        },
        {
            id: 699888,
            manufacturerItemId: "60150",
            universalProductCode: "10037638075756",
            description: "PIL W/Z SPY BD 12/J C/K 2-7.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 8.43,
            unitWidth: 9.43,
            unitWeight: 15.91,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " WING ZING SPICY BREADED 1ST & 2ND JOINT CHICKEN WING 2-7.5 POUND",
            isControlledSubstance: false
        },
        {
            id: 349041,
            manufacturerItemId: "69100",
            universalProductCode: "00035367691004",
            description: "LCF MHR EGGR-PRK & VG 3Z 6-12-3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.625,
            unitWidth: 9.25,
            unitWeight: 15,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MINH(R) Egg Roll Pork & Vegetable",
            isControlledSubstance: false
        },
        {
            id: 669250,
            manufacturerItemId: "1000005885",
            universalProductCode: "10072714004602",
            description: "MCN BD WICH CURDS 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 8,
            unitWeight: 10.75,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREADED WISCONSIN WHITE CHEDDAR CHEESE CURDS",
            isControlledSubstance: false
        },
        {
            id: 532418,
            manufacturerItemId: "7700300",
            universalProductCode: "90074624000091",
            description: "CVM CNTR MAG GBF PZA PTY 40-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.5,
            unitWidth: 10.25,
            unitWeight: 10.7,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pizza Seasoned Beef and Pork Patties With Provolone Cheese",
            isControlledSubstance: false
        },
        {
            id: 568341,
            manufacturerItemId: "58003",
            universalProductCode: "10072745580038",
            description: "KDF CLXDLX CHIC CHNK BD 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.813,
            unitWidth: 9.813,
            unitWeight: 12,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CLUX DELUX CHICKEN CHUNKS BREADED 2-5 POUND",
            isControlledSubstance: false
        },
        {
            id: 426864,
            manufacturerItemId: "94562-05261",
            universalProductCode: "10094562052611",
            description: "GMF DG-CKY DGB CCH 1-15 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.72,
            unitWidth: 9.88,
            unitWeight: 16.25,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury Best(TM) Frozen Cookie Dough Pail Chocolate Chip 15 lb",
            isControlledSubstance: false
        },
        {
            id: 473473,
            manufacturerItemId: "100107",
            universalProductCode: "00077782012590",
            description: "JFI JVS BRTW ORI BGS 4/1 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.125,
            unitWidth: 9.562,
            unitWeight: 10.757,
            shelfLife: 200,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Johnsonville Uncooked Natural Casing Original Pork Bratwurst Links 5lb bag/2ct case - Food Service",
            isControlledSubstance: false
        },
        {
            id: 580140,
            manufacturerItemId: "17030721120",
            universalProductCode: "10721931000644",
            description: "BOS BSO 7\" WGA APL BSSTIK 72-.189 L",
            unitOfMeasure: "CA",
            unitHeight: 11.125,
            unitWidth: 7.812,
            unitWeight: 14.605,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " BOSCO 7 INCH WHOLE GRAIN APPLE BOSCO STICK 72-.189 POUND",
            isControlledSubstance: false
        },
        {
            id: 583625,
            manufacturerItemId: "1059776",
            universalProductCode: "10035493597765",
            description: "FPI SHI P&D TOLR 31/40 5-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.75,
            unitWidth: 10.5,
            unitWeight: 11,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "31-40 ct Raw IQF White Shrimp  P&D  Tail-On",
            isControlledSubstance: false
        },
        {
            id: 366240,
            manufacturerItemId: "10076800621",
            universalProductCode: "00023700324320",
            description: "MOO MXO DCUT TORT 6\" 288-9.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.562,
            unitWidth: 7.312,
            unitWeight: 14.133,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Mexican Original(R) 6\" Flour Tortillas  288 count",
            isControlledSubstance: false
        },
        {
            id: 472543,
            manufacturerItemId: "0126120",
            universalProductCode: "30050665012611",
            description: "WSB MUSH FRE PORTB BD FIS 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.875,
            unitWidth: 12,
            unitWeight: 13.1,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FRED'S - BREADED PORTOBELLO MUSHROOM FANCY FRIES - 6/2# Bags",
            isControlledSubstance: false
        },
        {
            id: 344093,
            manufacturerItemId: "344093",
            universalProductCode: "10684476003870",
            description: "FF APL-SLC 7+1 HA VAR 1-30 LB",
            unitOfMeasure: "CA",
            unitHeight: 13.25,
            unitWidth: 10,
            unitWeight: 31,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "APPLE SLICED 7+1 HARD VARIETY 1-30 POUND",
            isControlledSubstance: false
        },
        {
            id: 353834,
            manufacturerItemId: "10033030928",
            universalProductCode: "00023700469755",
            description: "TYS CKN OR WGS UBD FC 3-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 9.5,
            unitWeight: 15.744,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Tyson(R) Oven Roasted Bone-In Chicken Wings",
            isControlledSubstance: false
        },
        {
            id: 341688,
            manufacturerItemId: "1063213",
            universalProductCode: "10035493632138",
            description: "FPI FIS OCPCH FLT IQF 2/3Z 1-10 LB",
            unitOfMeasure: "CA",
            unitHeight: 4.875,
            unitWidth: 9.875,
            unitWeight: 11,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "2-3 oz IQF Ocean Perch Fillets",
            isControlledSubstance: false
        },
        {
            id: 524271,
            manufacturerItemId: "524271",
            universalProductCode: "10748734700021",
            description: "MZC SNCB 8/UP NEWFOUNDLAND 1-30 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.87,
            unitWidth: 16.85,
            unitWeight: 34,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "8/10oz SNOW CRAB CLUSTER (CA) 1X30",
            isControlledSubstance: false
        },
        {
            id: 568357,
            manufacturerItemId: "66123",
            universalProductCode: "10072745661232",
            description: "KDF CLXDLX CHIC FLET BD 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.813,
            unitWidth: 9.813,
            unitWeight: 12,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CLUX DELUX CHICKEN FILET BREADED 2-5 POUND",
            isControlledSubstance: false
        },
        {
            id: 477093,
            manufacturerItemId: "00071398207012",
            universalProductCode: "00071398207012",
            description: "KFF CKN SOU GR CCQ 4-8 LB",
            unitOfMeasure: "CA",
            unitHeight: 10.375,
            unitWidth: 8.688,
            unitWeight: 33,
            shelfLife: 720,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CHICKEN SOUP GREEN CHILI CON QUESO 4-8 POUND",
            isControlledSubstance: false
        },
        {
            id: 569155,
            manufacturerItemId: "11550",
            universalProductCode: "00049800115507",
            description: "RPF EFFORTLESS BKG CIR 90-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.688,
            unitWidth: 15.625,
            unitWeight: 24.025,
            shelfLife: 210,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "EFFORTLESS BAKING CINNAMON ROLL 90-4 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 566573,
            manufacturerItemId: "4608",
            universalProductCode: "10038034460801",
            description: "BB BSK RCKN WG NKD WNGT 2-6 LB",
            unitOfMeasure: "CA",
            unitHeight: 8.81,
            unitWidth: 8.63,
            unitWeight: 12.66,
            shelfLife: 545,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Chicken  FC Ovenable Unbreaded Chicken Wingettes No Gluten added",
            isControlledSubstance: false
        },
        {
            id: 546477,
            manufacturerItemId: "MCF05074",
            universalProductCode: "10072714050746",
            description: "MCN MCA HVSPL SWTP WAF FRY 6-2.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 8,
            unitWidth: 12,
            unitWeight: 16.27,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MCCAIN(R) HARVEST SPLENDOR(R) SWEET POTATO CROSS TRAX 6X2.5 LBS",
            isControlledSubstance: false
        },
        {
            id: 707747,
            manufacturerItemId: "A04264",
            universalProductCode: "00833735002663",
            description: "QUO PTBS MTLS BNLW 2-63.85 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.63,
            unitWidth: 7.81,
            unitWeight: 8.95,
            shelfLife: 639,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " QUORN PLANT BASED MEATLESS BONELESS WINGS 2-63.85 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 491822,
            manufacturerItemId: "4530",
            universalProductCode: "10073321045309",
            description: "JJF FUNNEL CAKE FRIES 600-4 IN",
            unitOfMeasure: "CA",
            unitHeight: 10.63,
            unitWidth: 9.37,
            unitWeight: 8.9,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FUNNEL CAKE FRIES-4\"STIX/600CT",
            isControlledSubstance: false
        },
        {
            id: 703775,
            manufacturerItemId: "1056",
            universalProductCode: "10810020630173",
            description: "OBR OBO PMSM SMK PROV CH 2-6-2.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.94,
            unitWidth: 9.84,
            unitWeight: 2.9,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: " OBERTO PARMA SALAME SMOKED PROVOLONE CHEESE 2-6-2.5 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 161090,
            manufacturerItemId: "00725",
            universalProductCode: "10031200007251",
            description: "OS OCS OJ NO THAW-OL 100% 48-4 FO",
            unitOfMeasure: "CA",
            unitHeight: 5.31,
            unitWidth: 10.875,
            unitWeight: 15,
            shelfLife: 150,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "00725 48/4 oz ORANGE JUICE",
            isControlledSubstance: false
        },
        {
            id: 676596,
            manufacturerItemId: "74963",
            universalProductCode: "50758108749639",
            description: "USF ANTR GMT UNCR BFHM 2-1 CNT",
            unitOfMeasure: "CA",
            unitHeight: 7.19,
            unitWidth: 9.35,
            unitWeight: 12.33,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "US FOODSERVICE ALL NATURAL GOURMET UNCURED BLACK FOREST HAM 2-1 COUNT",
            isControlledSubstance: false
        },
        {
            id: 448874,
            manufacturerItemId: "00694",
            universalProductCode: "10075192006946",
            description: "ROT BRD GMT BUN SPLTP 4\" 6-8 CNT",
            unitOfMeasure: "CA",
            unitHeight: 5.875,
            unitWidth: 19.375,
            unitWeight: 11.907,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD GOURMET BUN SPLIT TOP 4 INCH 6-8 COUNT",
            isControlledSubstance: false
        },
        {
            id: 599476,
            manufacturerItemId: "12228",
            universalProductCode: "10033547122284",
            description: "MUF SUW SUW SAND SNBT GRJ 96-2.8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.75,
            unitWidth: 16,
            unitWeight: 17.8,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Sunbutter GRAPE Sandwich",
            isControlledSubstance: false
        },
        {
            id: 640266,
            manufacturerItemId: "18000-37731",
            universalProductCode: "10018000377319",
            description: "GMF PANC MIN SWB SPL 72-3.17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11,
            unitWidth: 11.75,
            unitWeight: 18.4,
            shelfLife: 279,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Frozen Mini Pancakes Strawberry Splash(TM) 3.17 oz",
            isControlledSubstance: false
        },
        {
            id: 560667,
            manufacturerItemId: "113",
            universalProductCode: "00086289408928",
            description: "CP ORNGS BBAT 5/8\" 4-2.5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.58,
            unitWidth: 12.05,
            unitWeight: 11.2,
            shelfLife: 547,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "ONION RINGS BEER BATTERED 5/8\" 4-2.5 POUND",
            isControlledSubstance: false
        },
        {
            id: 556134,
            manufacturerItemId: "MCX05157",
            universalProductCode: "10072714051576",
            description: "MCN F. STYL 3/8\" SKON NNF 6-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.555,
            unitWidth: 11.864,
            unitWeight: 31.67,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MCCAIN FRESH STYLE FRIES 3/8\" SKIN ON NON-FRIED 6X5 LBS",
            isControlledSubstance: false
        },
        {
            id: 560628,
            manufacturerItemId: "11070",
            universalProductCode: "90002444110706",
            description: "STS LAMB FORESHANKS 30-16 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10,
            unitWidth: 14,
            unitWeight: 32,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "LAMB FORESHANKS  14 TO 18OZ  LAYER PACK  AUSTRALIAN",
            isControlledSubstance: false
        },
        {
            id: 471175,
            manufacturerItemId: "08914",
            universalProductCode: "10032100089149",
            description: "SLF CHF DAN CH BFLY 4.75OZ { 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 12.75,
            unitWidth: 10.31,
            unitWeight: 15.1,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " CHEF PIERRE DANISH CHEESE BUTTERFLY 4.75OZ 6-2 POUND",
            isControlledSubstance: false
        },
        {
            id: 506641,
            manufacturerItemId: "96110724",
            universalProductCode: "10072714107242",
            description: "MCN GRBZR MSH BD 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.75,
            unitWidth: 12,
            unitWeight: 13.2,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREADED MUSHROOMS",
            isControlledSubstance: false
        },
        {
            id: 403604,
            manufacturerItemId: "40028350",
            universalProductCode: "10075361022142",
            description: "FLB BUN-HOTDOG 6\" SLC 8-12 CNT",
            unitOfMeasure: "CA",
            unitHeight: 7.75,
            unitWidth: 12.375,
            unitWeight: 12.3,
            shelfLife: 300,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BUN  SLICED HOT DOG 6'' FROZEN 12",
            isControlledSubstance: false
        },
        {
            id: 532419,
            manufacturerItemId: "7703003",
            universalProductCode: "10074624015143",
            description: "CVM TNT/SSO BRPT 75/25 60-5.3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 13,
            unitWeight: 21,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TNT Beef Patties with Seasoning 5.3 oz.",
            isControlledSubstance: false
        },
        {
            id: 341808,
            manufacturerItemId: "341808",
            universalProductCode: "10684476003825",
            description: "FF STBRY WHL IQF DO 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 9.5,
            unitWeight: 10.6,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "STRAWBERRY WHOLE INDIVIDUAL QUICK FROZEN DOMESTIC 2-5 POUND",
            isControlledSubstance: false
        },
        {
            id: 403421,
            manufacturerItemId: "40016770",
            universalProductCode: "10075361023156",
            description: "FLB BRD PLM SFT W 26 SLCS 1-24 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.25,
            unitWidth: 14.5,
            unitWeight: 17,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD  WHITE PULLMAN LOAF 28 SLICE BULK FROZEN",
            isControlledSubstance: false
        },
        {
            id: 646577,
            manufacturerItemId: "1TM03340020",
            universalProductCode: "10025753036462",
            description: "TMS HVC DPDST FRD G TOM 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 7.438,
            unitWidth: 12.125,
            unitWeight: 13.44,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Dipt'n Dusted(R) Fried Green Tomato Halves 6/2 LB",
            isControlledSubstance: false
        },
        {
            id: 50834,
            manufacturerItemId: "100007730",
            universalProductCode: "10038057100807",
            description: "SFF SNF LQ E WHL W/CTAC 6-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 10.45,
            unitWidth: 8.88,
            unitWeight: 31.6,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Liquid Whole Egg with Citric  6/5 lb. Frozen Carton",
            isControlledSubstance: false
        },
        {
            id: 504927,
            manufacturerItemId: "07816",
            universalProductCode: "00049800078161",
            description: "RPF UBR' THE UBKF RN CINN 140-2.5 O",
            unitOfMeasure: "CA",
            unitHeight: 7.25,
            unitWidth: 11.563,
            unitWeight: 23.094,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "UBR' THE ULTIMATE BREAKFAST ROUND CINNAMON 140-2.5 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 532421,
            manufacturerItemId: "7703006",
            universalProductCode: "10074624015105",
            description: "CVM TNT/ SSO PTY OV 75/25 53-6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 13,
            unitWeight: 21,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TNT Beef Patties with Seasoning 6 oz.",
            isControlledSubstance: false
        },
        {
            id: 505390,
            manufacturerItemId: "19500",
            universalProductCode: "10070057195001",
            description: "PFI TU STK PHLP YF 4Z 40-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.25,
            unitWidth: 9.75,
            unitWeight: 11.55,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Yellowfin Tuna Steaks  4 oz",
            isControlledSubstance: false
        },
        {
            id: 690726,
            manufacturerItemId: "690726",
            universalProductCode: "10684476056180",
            description: "SVF SVP DCD RD PEPP 3/8\" 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.102,
            unitWidth: 9.646,
            unitWeight: 13,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " SAVOR IMPORTS DICED RED PEPPERS 3/8\" 6-2 POUND",
            isControlledSubstance: false
        },
        {
            id: 607807,
            manufacturerItemId: "10000070609",
            universalProductCode: "10071068706095",
            description: "SLM JMD JMD TKY IW {NR 40-.157 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.375,
            unitWidth: 10.938,
            unitWeight: 7.292,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " JIMMY DEAN JMD TURKEY INDIVIDUALLY WRAPPED 40-.157 POUND",
            isControlledSubstance: false
        },
        {
            id: 488126,
            manufacturerItemId: "1780",
            universalProductCode: "10749017017805",
            description: "SSD DES-INDV CLC COF CKE 8-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.125,
            unitWidth: 13.125,
            unitWeight: 15.33,
            shelfLife: 900,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "COFFEECAKE  CINNAMON 4 OZ UNSLICED TRAY FROZEN CAKE",
            isControlledSubstance: false
        },
        {
            id: 32003,
            manufacturerItemId: "2265530773",
            universalProductCode: "90022655307733",
            description: "BLF TKY-1.41Z SGPT CN FC 113-1.41 O",
            unitOfMeasure: "CA",
            unitHeight: 6.4,
            unitWidth: 9.94,
            unitWeight: 11,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FC Turkey Breakfast Sausage Patties - CN",
            isControlledSubstance: false
        },
        {
            id: 548808,
            manufacturerItemId: "63912",
            universalProductCode: "10072180639124",
            description: "LCF TYR PZA WGRA BFST TKSG 1-128 EA",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 13.813,
            unitWeight: 30.32,
            shelfLife: 300,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TONY'S(TM) Breakfast Sausage",
            isControlledSubstance: false
        },
        {
            id: 608389,
            manufacturerItemId: "00258",
            universalProductCode: "10743672002589",
            description: "JBM BGL WWT L& 8-6 EA",
            unitOfMeasure: "CA",
            unitHeight: 9,
            unitWidth: 9.5,
            unitWeight: 13,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Bagel Whole Wheat Sliced 4oz",
            isControlledSubstance: false
        },
        {
            id: 399286,
            manufacturerItemId: "22121",
            universalProductCode: "10886105221215",
            description: "SGN RSM FOCA RND SR382819 1-3.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.5,
            unitWidth: 15.5,
            unitWeight: 14.925,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD  FOCACCIA ROSEMARY ROUND 3.5OZ PARBAKED FROZEN",
            isControlledSubstance: false
        },
        {
            id: 545240,
            manufacturerItemId: "23060025",
            universalProductCode: "10072586600254",
            description: "JJF JCP WFT PRE MBLM SWL 96-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10,
            unitWidth: 11.7,
            unitWeight: 29,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "WF-JUICE CUP-MXBERY/LEM-4OZ/96",
            isControlledSubstance: false
        },
        {
            id: 584446,
            manufacturerItemId: "10143",
            universalProductCode: "10013087101437",
            description: "OSI WLD BLU MFNS 72-2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 11.438,
            unitWeight: 10.75,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MUFFIN WILD BLUEBERRY NATURALLY MADE WITH 51% WHOLE FLAVORED WITH OTHER NATURAL FLAVORS INDIVIDUALLY WRAPPED 72/2 OZ",
            isControlledSubstance: false
        },
        {
            id: 681106,
            manufacturerItemId: "11819",
            universalProductCode: "00049800118195",
            description: "RPF 10\" ZCR SSO CAUL GLF 24-5.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 10.5,
            unitWeight: 8.9,
            shelfLife: 240,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "10 INCH PIZZA CRUST SEASONED CAULIFLOWER GLUTEN-FREE 24-5.2 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 563493,
            manufacturerItemId: "8327",
            universalProductCode: "10078976083270",
            description: "TUR BRD BRIO RL 80-3.43 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.125,
            unitWidth: 19.812,
            unitWeight: 19.15,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "4.5\" Brioche Buns SL 80 CS - 8x10x3.5 oz",
            isControlledSubstance: false
        },
        {
            id: 699386,
            manufacturerItemId: "6080",
            universalProductCode: "10073435060809",
            description: "KHB KNG OG HAW SSLB PSLC 12-10 OZ",
            unitOfMeasure: "CA",
            unitHeight: 13.5,
            unitWidth: 10,
            unitWeight: 10.25,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Original Hawaiian Sweet Pre-Sliced Slider Buns - 9pk",
            isControlledSubstance: false
        },
        {
            id: 366072,
            manufacturerItemId: "10000008481",
            universalProductCode: "10071068084810",
            description: "SLM STF CDOG CN ALMT JM 1-12 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.375,
            unitWidth: 10.812,
            unitWeight: 13.009,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: " STATE FAIR CORN DOGS CHILD NUTRITION ALL MEAT JUMBO 1-12 POUND",
            isControlledSubstance: false
        },
        {
            id: 613441,
            manufacturerItemId: "14839",
            universalProductCode: "00049800148390",
            description: "RPF DONU RNG WGA 84-2.45 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11.375,
            unitWidth: 12.875,
            unitWeight: 14.491,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DONUT RINGS WHOLE GRAIN 84-2.45 OUNCE",
            isControlledSubstance: false
        },
        {
            id: 409554,
            manufacturerItemId: "80008480",
            universalProductCode: "10072714084802",
            description: "MCN APP-FS BATD MZ CH STXS 6-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 12,
            unitWeight: 13.03,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "FRYER SAVER BATTERED MOZZARELLA CHEESE",
            isControlledSubstance: false
        },
        {
            id: 360225,
            manufacturerItemId: "10078880821",
            universalProductCode: "00023700078889",
            description: "TYS STF CRIS CKN & CH F 72-2.75 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.125,
            unitWidth: 9.062,
            unitWeight: 13.125,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "State Fair(R) Crispitos(R) Fully Cooked Chicken and Cheese Flour Tortillas",
            isControlledSubstance: false
        },
        {
            id: 59025,
            manufacturerItemId: "53093",
            universalProductCode: "00072564530934",
            description: "MQF QUAI-WHL MARI 5-6 OZ 6-4 EA",
            unitOfMeasure: "CA",
            unitHeight: 2.68,
            unitWidth: 12.37,
            unitWeight: 8.17,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "QUAIL  WHOLE 5-6 OZ BONE-IN SKIN ON MARINATED RAW FROZEN",
            isControlledSubstance: false
        },
        {
            id: 353266,
            manufacturerItemId: "10000021140",
            universalProductCode: "00793577011400",
            description: "APF SEZ BKWY BSTK 1-12 LB",
            unitOfMeasure: "CA",
            unitHeight: 4.25,
            unitWidth: 10.5,
            unitWeight: 12.638,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Sliced & Shaped Beef Sirloin Steak",
            isControlledSubstance: false
        },
        {
            id: 353266,
            manufacturerItemId: "10000021140",
            universalProductCode: "00793577011400",
            description: "APF SEZ BKWY BSTK 1-12 LB",
            unitOfMeasure: "CA",
            unitHeight: 4.25,
            unitWidth: 10.5,
            unitWeight: 12.638,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Sliced & Shaped Beef Sirloin Steak",
            isControlledSubstance: false
        },
        {
            id: 41874,
            manufacturerItemId: "51025",
            universalProductCode: "10071833054383",
            description: "GLD GO1 2/5 BLACKBERRY COB 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 11.5,
            unitWeight: 11,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "2/5 Blackberry Cobbler",
            isControlledSubstance: false
        },
        {
            id: 41881,
            manufacturerItemId: "51050",
            universalProductCode: "10071833054376",
            description: "GLD GO1 2/5 APPLE COBBLER 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 11.5,
            unitWeight: 11,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "2/5 Apple Cobbler",
            isControlledSubstance: false
        },
        {
            id: 41899,
            manufacturerItemId: "51075",
            universalProductCode: "10071833054475",
            description: "GLD GO1 2/5 PEACH COBBLER 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 11.5,
            unitWeight: 11,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "2/5 Peach Cobbler",
            isControlledSubstance: false
        },
        {
            id: 41917,
            manufacturerItemId: "51100",
            universalProductCode: "10071833054406",
            description: "GLD GO1 2/5 CHERRY COBBLER 2-5 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 11.5,
            unitWeight: 11,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "2/5 Cherry Cobbler",
            isControlledSubstance: false
        },
        {
            id: 54601,
            manufacturerItemId: "108071000",
            universalProductCode: "10094562080713",
            description: "GMF PIL PB CRANBERRY ORANG 1-18 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.54,
            unitWidth: 9.77,
            unitWeight: 19.3,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Frozen Muffin Batter Pail Cranberry Orange 18 lb",
            isControlledSubstance: false
        },
        {
            id: 304058,
            manufacturerItemId: "1000037842     ",
            universalProductCode: "10080378640210",
            description: "PLZ SPRY-VGLN LIQ W/ SPBTL 4-.5 GA ",
            unitOfMeasure: "CA",
            unitHeight: 11.25,
            unitWidth: 9.5,
            unitWeight: 17.47,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "Vegalene Premium 3-Oil Blend Food Release Pan Spray 4  -1/2 Gallons w/sprayer                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 377321,
            manufacturerItemId: "791",
            universalProductCode: "00041433007914",
            description: "DEX DXP DELI EXPRESS CHUCK 10-4.5 O",
            unitOfMeasure: "CA",
            unitHeight: 4.88,
            unitWidth: 9.13,
            unitWeight: 3.47,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Deli Express Chuckwagon",
            isControlledSubstance: false
        },
        {
            id: 377323,
            manufacturerItemId: "792",
            universalProductCode: "00041433007921",
            description: "DEX DXP DELI EXPRESS CHICK 10-4.5 O",
            unitOfMeasure: "CA",
            unitHeight: 4.88,
            unitWidth: 9.13,
            unitWeight: 3.44,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Deli Express Chicken & Swiss",
            isControlledSubstance: false
        },
        {
            id: 386761,
            manufacturerItemId: "102561000",
            universalProductCode: "10094562025615",
            description: "GMF PIL PB BEST CINNAMON R 180-2.5",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 11.93,
            unitWeight: 32.3,
            shelfLife: 93,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Best(TM) Frozen Cinnamon Roll Dough 2.5 oz",
            isControlledSubstance: false
        },
        {
            id: 387365,
            manufacturerItemId: "RSD262392",
            universalProductCode: "20780994982950",
            description: "WLF WFM TEM 1910 ORIGINAL 12-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.375,
            unitWidth: 11.563,
            unitWeight: 18.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Traditional English Muffin 1910 Original 6slv",
            isControlledSubstance: false
        },
        {
            id: 400221,
            manufacturerItemId: "M50577-0000",
            universalProductCode: "20780994982820",
            description: "WLF WFM SEM 1910 ORIGINAL 12-4 EA",
            unitOfMeasure: "CA",
            unitHeight: 7.3,
            unitWidth: 11.5,
            unitWeight: 12,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Signature English Muffin 1910 Original 4slv",
            isControlledSubstance: false
        },
        {
            id: 400779,
            manufacturerItemId: "106226000",
            universalProductCode: "10094562062269",
            description: "GMF PIL PB PLACE&BAKE CINN 100-5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 11,
            unitWidth: 11.93,
            unitWeight: 34.2,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Best(TM) Place & Bake(TM) Twirl Dough Cinnamon 5 oz",
            isControlledSubstance: false
        },
        {
            id: 402639,
            manufacturerItemId: "106667000",
            universalProductCode: "10094562066670",
            description: "GMF PIL PB CHOCCHIP CANDYP 216-216-",
            unitOfMeasure: "CA",
            unitHeight: 6.87,
            unitWidth: 12.31,
            unitWeight: 22.45,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury Best(TM) Frozen Cookie Dough Puck Chocolate Chip with Candy Pieces 1.5 oz",
            isControlledSubstance: false
        },
        {
            id: 403527,
            manufacturerItemId: "06513",
            universalProductCode: "10052500065130",
            description: "CFS GDM G M HD MAYONNAISE  4-1 GA",
            unitOfMeasure: "CA",
            unitHeight: 10.13,
            unitWidth: 12.13,
            unitWeight: 30.81,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "GOLD MEDAL HEAVY DUTY MAYONNAISE BULK  4 - 1 GA",
            isControlledSubstance: false
        },
        {
            id: 423806,
            manufacturerItemId: "108150000",
            universalProductCode: "10094562081505",
            description: "GMF PIL PB BLUEBERRY SCONE 96-3.75",
            unitOfMeasure: "CA",
            unitHeight: 10.87,
            unitWidth: 8.06,
            unitWeight: 25,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Place & Bake(TM) Frozen Scone Dough Blueberry 3.75 oz",
            isControlledSubstance: false
        },
        {
            id: 423807,
            manufacturerItemId: "108151000",
            universalProductCode: "10094562081512",
            description: "GMF PIL PB RASPBERRY WHITE 12-12-3.",
            unitOfMeasure: "CA",
            unitHeight: 12.5,
            unitWidth: 8.75,
            unitWeight: 25,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Place & Bake(TM) Frozen Scone Dough White Chunk Raspberry 3.75 oz",
            isControlledSubstance: false
        },
        {
            id: 441273,
            manufacturerItemId: "106686000",
            universalProductCode: "10094562066861",
            description: "GMF PIL PB BEST CHOCCHIP C 288-288-",
            unitOfMeasure: "CA",
            unitHeight: 7.87,
            unitWidth: 12.31,
            unitWeight: 23.8,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury Best(TM) Frozen Cookie Dough Puck Chocolate Chip 1.2 oz",
            isControlledSubstance: false
        },
        {
            id: 448731,
            manufacturerItemId: "1000004055",
            universalProductCode: "10048200446263",
            description: "PLZ RPR RESTAURANT'S PRIDE 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 730,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Restaurant's Pride Dependable Food Release 6/17 oz. aerosol",
            isControlledSubstance: false
        },
        {
            id: 448736,
            manufacturerItemId: "1000004030",
            universalProductCode: "10048200908051",
            description: "PLZ RPF RESTAURANT'S PRIDE 6-14 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.37,
            unitWidth: 5.47,
            unitWeight: 6.85,
            shelfLife: 730,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Restaurant's Pride Preferred Pan Coating 6/14 oz. aerosol",
            isControlledSubstance: false
        },
        {
            id: 454603,
            manufacturerItemId: "M50602-0000",
            universalProductCode: "20780994983070",
            description: "WLF WFM MINI 1910 ORIGINAL 12-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 8.268,
            unitWidth: 12.284,
            unitWeight: 11.8,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Mini 1910 Original English Muffin 12slv",
            isControlledSubstance: false
        },
        {
            id: 462542,
            manufacturerItemId: "20882",
            universalProductCode: "10014821208825",
            description: "NPI HNV SF CHOCOLATE CHUNK 8-15 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.4,
            unitWidth: 8.7,
            unitWeight: 9.35,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Sugar Free Chocolate Chunkie Cookie",
            isControlledSubstance: false
        },
        {
            id: 470094,
            manufacturerItemId: "4500           ",
            universalProductCode: "10079176004508",
            description: "BTR OMO BTR OMO BTR OMO BT 1-720 EA",
            unitOfMeasure: "CA",
            unitHeight: 6.2205,
            unitWidth: 9.764,
            unitWeight: 9.5,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "COMMODITY SALTED BUTTER  1 - 720 EA                                                                                                                                               ",
            isControlledSubstance: false
        },
        {
            id: 481852,
            manufacturerItemId: "132114000",
            universalProductCode: "10094562321144",
            description: "GMF PIL PB PINCHED ALLBUTT 120-120-",
            unitOfMeasure: "CA",
            unitHeight: 6.92,
            unitWidth: 12.63,
            unitWeight: 22.8,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Frozen Croissant Dough All Butter Pinched 2.75 oz",
            isControlledSubstance: false
        },
        {
            id: 502010,
            manufacturerItemId: "131903000",
            universalProductCode: "10094562319035",
            description: "GMF PIL PB SPCLRCP BROWNIE 288-288-",
            unitOfMeasure: "CA",
            unitHeight: 7.87,
            unitWidth: 12.31,
            unitWeight: 23.8,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Frozen Cookie Dough Puck Special Recipe Brownie 1.2 oz",
            isControlledSubstance: false
        },
        {
            id: 502037,
            manufacturerItemId: "06501          ",
            universalProductCode: "10052500065017",
            description: "CSP SUU SAU MUST 500/5.5GR 1-500-5.",
            unitOfMeasure: "CA",
            unitHeight: 5.9375,
            unitWidth: 7.5,
            unitWeight: 6.83,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "SAUER MUSTARD SINGLE SERVE  1 - 5.5 GR                                                                                                                                            ",
            isControlledSubstance: false
        },
        {
            id: 502040,
            manufacturerItemId: "06506",
            universalProductCode: "10052500065062",
            description: "CSP SUU SAUERS SWEET RELIS 200-9 GR",
            unitOfMeasure: "CA",
            unitHeight: 5.0625,
            unitWidth: 7.25,
            unitWeight: 4.47,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "SAUER SWEET RELISH SINGLE SERVE PACKET  200 - 9 GR",
            isControlledSubstance: false
        },
        {
            id: 502042,
            manufacturerItemId: "05499",
            universalProductCode: "10052500054998",
            description: "CSP DKE DUKE'S MAYONNAISE  1-12 GR",
            unitOfMeasure: "CA",
            unitHeight: 5.25,
            unitWidth: 7.8125,
            unitWeight: 6,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "DUKE'S MAYONNAISE SINGLE SERVE  1 - 12 GR",
            isControlledSubstance: false
        },
        {
            id: 502120,
            manufacturerItemId: "10514100",
            universalProductCode: "00075361012351",
            description: "FLB EUB BREAD, FLAT 12\" PL 1-37.33",
            unitOfMeasure: "CA",
            unitHeight: 5.5,
            unitWidth: 13.5,
            unitWeight: 16,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BREAD  FLAT 12 PLAIN FROZEN",
            isControlledSubstance: false
        },
        {
            id: 507965,
            manufacturerItemId: "1000004066",
            universalProductCode: "10080378222621",
            description: "PLZ VLN VEGALENE PREMIUM O 6-21 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.7,
            unitWidth: 5.85,
            unitWeight: 10.23,
            shelfLife: 365,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Vegalene Premium Olive Mist Seasoning Spray 6/21 oz aerosol",
            isControlledSubstance: false
        },
        {
            id: 511602,
            manufacturerItemId: "06389          ",
            universalProductCode: "10052500063891",
            description: "CSP SUU SAUERS HONEY 200/9 200-9 GR",
            unitOfMeasure: "CA",
            unitHeight: 5.06,
            unitWidth: 7.25,
            unitWeight: 4.42,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "SAUER HONEY SINGLE SERVE  200 - 9 GR                                                                                                                                              ",
            isControlledSubstance: false
        },
        {
            id: 535522,
            manufacturerItemId: "204-6",
            universalProductCode: "20076064020463",
            description: "NMO NMO CARROT CAKE SQUARE 6-6-3.6",
            unitOfMeasure: "CA",
            unitHeight: 4.04,
            unitWidth: 9.52,
            unitWeight: 11.1,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "NEMO'S SQUARE CARROT CAKE WITH CREAM CHEESE ICING  6 - 3.6 OZ",
            isControlledSubstance: false
        },
        {
            id: 540345,
            manufacturerItemId: "06377          ",
            universalProductCode: "10052500063778",
            description: "CSP SUU SAU BMKRANCH CUP 1 100-1.5 ",
            unitOfMeasure: "CA",
            unitHeight: 7.3125,
            unitWidth: 9,
            unitWeight: 10.775,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "SAUER BUTTERMILK RANCH DRESSING SINGLE SERVE  100 - 1.5 OZ                                                                                                                        ",
            isControlledSubstance: false
        },
        {
            id: 540360,
            manufacturerItemId: "05009",
            universalProductCode: "10052500050099",
            description: "CFS DKE DUKES MAYO-SQUEEZE 12-18 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 9.3125,
            unitWeight: 15.26,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "DUKE'S MAYONNAISE BOTTLE  12 - 18 OZ",
            isControlledSubstance: false
        },
        {
            id: 542874,
            manufacturerItemId: "06518",
            universalProductCode: "10052500065185",
            description: "CFS GDM G M EXTRA HD MAYON 1-30 LB",
            unitOfMeasure: "CA",
            unitHeight: 13.75,
            unitWidth: 10,
            unitWeight: 31.74,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "GOLD MEDAL EXTRA HEAVY DUTY MAYONNAISE BULK  1 - 30 LB",
            isControlledSubstance: false
        },
        {
            id: 542993,
            manufacturerItemId: "06502",
            universalProductCode: "10052500065024",
            description: "CSP SUU SAU PICANTE SCE PO 200-0.5",
            unitOfMeasure: "CA",
            unitHeight: 5.25,
            unitWidth: 7.8125,
            unitWeight: 6.83,
            shelfLife: 150,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "SAUER PICANTE HOT SAUCE SINGLE SERVE  200 - 0.5 OZ",
            isControlledSubstance: false
        },
        {
            id: 547290,
            manufacturerItemId: "1000004050",
            universalProductCode: "10080378172605",
            description: "PLZ VLN VEGALENE BUTTERY C 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 365,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Vegalene Buttery Cooking Spray Food Release Spray",
            isControlledSubstance: false
        },
        {
            id: 552414,
            manufacturerItemId: "2417",
            universalProductCode: "00041433124178",
            description: "DEX YFF MARKET SANDWICH IT 8-8.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.31,
            unitWidth: 9.38,
            unitWeight: 5.17,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Market Sandwich Italian Style Wrap",
            isControlledSubstance: false
        },
        {
            id: 562544,
            manufacturerItemId: "106694000",
            universalProductCode: "10094562066946",
            description: "GMF PIL PB BST OATMEALRAIS 288-288-",
            unitOfMeasure: "CA",
            unitHeight: 7.87,
            unitWidth: 12.31,
            unitWeight: 23.8,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury Best(TM) Frozen Cookie Dough Puck Oatmeal Raisin 1.2 oz",
            isControlledSubstance: false
        },
        {
            id: 581940,
            manufacturerItemId: "2411",
            universalProductCode: "00041433124116",
            description: "DEX MKI MARKET ARTISAN ITA 8-7.9 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.69,
            unitWidth: 11.44,
            unitWeight: 4.78,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Market Artisan Style Italian Style Sub",
            isControlledSubstance: false
        },
        {
            id: 610775,
            manufacturerItemId: "358012",
            universalProductCode: "20074329123386",
            description: "GLR OSN OH SNAP! DILLYBITE 12-3.25",
            unitOfMeasure: "CA",
            unitHeight: 7.4,
            unitWidth: 5.91,
            unitWeight: 3.07,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OH SNAP DILL DILLY BITES SNACKING CUTS PICKLE CHIP SINGLE SERVE POUCH  12 - 3.25 FO",
            isControlledSubstance: false
        },
        {
            id: 615577,
            manufacturerItemId: "2538",
            universalProductCode: "00041433125380",
            description: "DEX YFF MARKET SANDWICH CH 8-8.6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.31,
            unitWidth: 9.38,
            unitWeight: 5.32,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Market Sandwich Chicken Caesar Wrap",
            isControlledSubstance: false
        },
        {
            id: 624089,
            manufacturerItemId: "112501",
            universalProductCode: "10014821125016",
            description: "NPI NWD CKY CCK PN 12-22 OZ",
            unitOfMeasure: "CA",
            unitHeight: 12.75,
            unitWidth: 13.25,
            unitWeight: 22,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Full Sugar Chocolate Chunk Pan Cookie",
            isControlledSubstance: false
        },
        {
            id: 625897,
            manufacturerItemId: "46025-84254-00 ",
            universalProductCode: "10746025842542",
            description: "MFR PIS 15/2 LB CTN, ESL S 15-2  LB",
            unitOfMeasure: "CA",
            unitHeight: 9.625,
            unitWidth: 9.063,
            unitWeight: 32.846,
            shelfLife: 98,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "PAPETTI'S EXTENDED SHELF LIFE BREAKFAST BLEND SCRAMBLED EGG MIX  15 - 2  LB                                                                                                       ",
            isControlledSubstance: false
        },
        {
            id: 628831,
            manufacturerItemId: "358014",
            universalProductCode: "20074329123393",
            description: "GLR OSN OHSNAP!HOTTIEBITES 12-3.25",
            unitOfMeasure: "CA",
            unitHeight: 7.4,
            unitWidth: 5.91,
            unitWeight: 3.07,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OH SNAP FAT FREE GLUTEN FREE HOTTIE BITES SNACKING PICKLE CHIP SINGLE SERVE POUCH  12 - 3.5 OZ",
            isControlledSubstance: false
        },
        {
            id: 636721,
            manufacturerItemId: "2576",
            universalProductCode: "00041433125762",
            description: "DEX YFF MARKET SANDWICH TU 8-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.31,
            unitWidth: 9.38,
            unitWeight: 4.91,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Market Sandwich Turkey Club Wrap",
            isControlledSubstance: false
        },
        {
            id: 636759,
            manufacturerItemId: "08121",
            universalProductCode: "10052500081215",
            description: "CSP GDF MARIN C/ 96-2.3 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.125,
            unitWidth: 12.5625,
            unitWeight: 15.93,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "GODFATHER'S GODFATHERS MARINARA CUP  96 - 2.3 OZ",
            isControlledSubstance: false
        },
        {
            id: 640070,
            manufacturerItemId: "501-0020",
            universalProductCode: "10021724602957",
            description: "VVR VPX CHORIZO PORK 12-14 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8,
            unitWidth: 6.5,
            unitWeight: 11.54,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "VV Supremo Foods Pork Chorizo",
            isControlledSubstance: false
        },
        {
            id: 643255,
            manufacturerItemId: "213-0065       ",
            universalProductCode: "10021724601509",
            description: "VVR VPX QUESO CHIHUAHUA SH 6-2 LB  ",
            unitOfMeasure: "CA",
            unitHeight: 8.38,
            unitWidth: 11.25,
            unitWeight: 13.6,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SUPREMO QUESO CHIHUAHUA SHRED                                                                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 643259,
            manufacturerItemId: "501-0082       ",
            universalProductCode: "10021724602629",
            description: "VVR VPX CHORIZO PORK 15-7 OZ       ",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 7.5,
            unitWeight: 7.35,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "VV Supremo Foods Pork Chorizo                                                                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 643264,
            manufacturerItemId: "203-0039       ",
            universalProductCode: "10021724603022",
            description: "VVR VPX QUESO FRESCO 12-8 OZ       ",
            unitOfMeasure: "CA",
            unitHeight: 6,
            unitWidth: 5.75,
            unitWeight: 6.75,
            shelfLife: 100,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SUPREMO QUESO FRESCO FRESH CRUMBLING CHEESE                                                                                                                                       ",
            isControlledSubstance: false
        },
        {
            id: 643658,
            manufacturerItemId: "213-0080       ",
            universalProductCode: "10021724602896",
            description: "VVR VPX QUESO CHIHUAHUA SH 12-1 LB ",
            unitOfMeasure: "CA",
            unitHeight: 7,
            unitWidth: 11.88,
            unitWeight: 13.5,
            shelfLife: 120,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SUPREMO QUESO CHIHUAHUA SHRED                                                                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 644490,
            manufacturerItemId: "20336063",
            universalProductCode: "10093966510529",
            description: "ORV OGV MILK UHT HALF AND  12-16 FO",
            unitOfMeasure: "CA",
            unitHeight: 5.69,
            unitWidth: 9,
            unitWeight: 14.25,
            shelfLife: 70,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "Milk UHT Half and Half 12/16 oz Organic",
            isControlledSubstance: false
        },
        {
            id: 644492,
            manufacturerItemId: "20336064",
            universalProductCode: "10093966000334",
            description: "ORV OGV UHT HALF AND HALF  12-32 FO",
            unitOfMeasure: "CA",
            unitHeight: 9.38,
            unitWidth: 9,
            unitWeight: 28,
            shelfLife: 70,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "Milk UHT Half and Half 12/32 oz Organic",
            isControlledSubstance: false
        },
        {
            id: 644510,
            manufacturerItemId: "20337068",
            universalProductCode: "10093966000280",
            description: "ORV OGV MILK UHT WHIPPING  12-16 FO",
            unitOfMeasure: "CA",
            unitHeight: 5.69,
            unitWidth: 9,
            unitWeight: 14.25,
            shelfLife: 70,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "Organic Valley Ultra Pasteurized Organic Heavy Whipping Cream",
            isControlledSubstance: false
        },
        {
            id: 646966,
            manufacturerItemId: "02008",
            universalProductCode: "00853923002053",
            description: "NOO NSY NOOSA YOGHURT HONE 12-1 EA",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt honey  8oz  12/case",
            isControlledSubstance: false
        },
        {
            id: 646979,
            manufacturerItemId: "02138          ",
            universalProductCode: "00853923002145",
            description: "NOO NSY NOOSA YOGHURT COCO 12-8 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt coconut  8oz  12/case                                                                                                                                               ",
            isControlledSubstance: false
        },
        {
            id: 646980,
            manufacturerItemId: "02107          ",
            universalProductCode: "00853923002152",
            description: "NOO NSY NOOSA YOGHURT LEMO 12-8 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt lemon  8oz  12/case                                                                                                                                                 ",
            isControlledSubstance: false
        },
        {
            id: 646984,
            manufacturerItemId: "02206",
            universalProductCode: "00853923002251",
            description: "NOO NSY NOOSA YOGHURT BLUE 12-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt blueberry  8oz  12/case",
            isControlledSubstance: false
        },
        {
            id: 646992,
            manufacturerItemId: "02404          ",
            universalProductCode: "00853923002459",
            description: "NOO NSY NOOSA RASPBERRY 8O 12-8 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt raspberry  8oz  12/case                                                                                                                                             ",
            isControlledSubstance: false
        },
        {
            id: 647004,
            manufacturerItemId: "02602          ",
            universalProductCode: "00853923002657",
            description: "NOO NSY NOOSA YOGHURT PEAC 12-1 EA ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt peach  8oz  12/case                                                                                                                                                 ",
            isControlledSubstance: false
        },
        {
            id: 647005,
            manufacturerItemId: "02909          ",
            universalProductCode: "00853923002954",
            description: "NOO NSY NOOSA TART CHERRY, 12-8 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt tart cherry  8oz  12/case                                                                                                                                           ",
            isControlledSubstance: false
        },
        {
            id: 658185,
            manufacturerItemId: "2599",
            universalProductCode: "00041433125991",
            description: "DEX MEK MARKET SAND BUFFAL 8-8.6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.31,
            unitWidth: 9.38,
            unitWeight: 5.11,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Market Sandwich Buffalo Style Chicken Wrap",
            isControlledSubstance: false
        },
        {
            id: 658207,
            manufacturerItemId: "08863",
            universalProductCode: "10032100088630",
            description: "SLF CHF FS CP CRNBRD IW MI 48-2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.13,
            unitWidth: 11.06,
            unitWeight: 7.371,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CHEF PIERRE INDIVIDUALLY WRAPPED MINI CORNBREAD LOAVES  48 - 2 OZ",
            isControlledSubstance: false
        },
        {
            id: 658749,
            manufacturerItemId: "505-0010",
            universalProductCode: "10021724602988",
            description: "VVR VPX CHORIZO BEEF 12-13 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.75,
            unitWidth: 6.5,
            unitWeight: 10.85,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "VV Supremo Foods Beef Chorizo",
            isControlledSubstance: false
        },
        {
            id: 659905,
            manufacturerItemId: "58103          ",
            universalProductCode: "10014821581034",
            description: "NPI NWD CKY SUG PN UN 12-22 OZ     ",
            unitOfMeasure: "CA",
            unitHeight: 12.75,
            unitWidth: 13.25,
            unitWeight: 19,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "New Day(R) 12\" Fully Baked Message Pan Cookie - Sugar                                                                                                                             ",
            isControlledSubstance: false
        },
        {
            id: 660139,
            manufacturerItemId: "501-0024",
            universalProductCode: "10021724602964",
            description: "VVR VPX CHORIZO PORK 12-14 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8,
            unitWidth: 6.5,
            unitWeight: 11.54,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "VV Supremo Foods Pork Chorizo Bolita",
            isControlledSubstance: false
        },
        {
            id: 665772,
            manufacturerItemId: "358400",
            universalProductCode: "20074329123430",
            description: "GLR PRETP 12-1.5 FO",
            unitOfMeasure: "CA",
            unitHeight: 7.4,
            unitWidth: 5.91,
            unitWeight: 1.77,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OH SNAP PRETTY PEAS  12 - 1.5 FO",
            isControlledSubstance: false
        },
        {
            id: 667055,
            manufacturerItemId: "08205          ",
            universalProductCode: "10052500082052",
            description: "CSP DKE DUKE'S BBQ SAUCE 120-1.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 5.125,
            unitWidth: 12.5625,
            unitWeight: 13.74,
            shelfLife: 150,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "DUKE'S BBQ SAUCE SINGLE SERVE  120 - 1.5 OZ                                                                                                                                       ",
            isControlledSubstance: false
        },
        {
            id: 676186,
            manufacturerItemId: "110026093",
            universalProductCode: "10038057303499",
            description: "SFF SNF SCR EGG SQ PTY 1-100-1.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7,
            unitWidth: 9.75,
            unitWeight: 10.1,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Scrambled Egg Square  100/1.5 oz.  Frozen  Bulk",
            isControlledSubstance: false
        },
        {
            id: 677289,
            manufacturerItemId: "08101          ",
            universalProductCode: "10770981081011",
            description: "GGO TWB TB CINNAMON ROLLS 24-12 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 10.0625,
            unitWidth: 12.9375,
            unitWeight: 19.04,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "two-bite Cinnamon Rolls Square Tub-12oz                                                                                                                                           ",
            isControlledSubstance: false
        },
        {
            id: 682785,
            manufacturerItemId: "FG1028",
            universalProductCode: "10815909020335",
            description: "NOO NSY NOOSA VANILLA BEAN 12-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.13,
            unitWeight: 6.8,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa vanilla bean  8oz  12/case",
            isControlledSubstance: false
        },
        {
            id: 685734,
            manufacturerItemId: "1000037408     ",
            universalProductCode: "10080378171202",
            description: "PLZ VGLN BTRY DLTE PSPY 6-17 OZ    ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 365,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Vegalene Buttery Delite Seasoning Pan Spray 6/17 oz. aerosol                                                                                                                      ",
            isControlledSubstance: false
        },
        {
            id: 685735,
            manufacturerItemId: "1000037411",
            universalProductCode: "10080378170502",
            description: "PLZ VLN VEGALENE NON-GMO 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.19,
            unitWidth: 5.69,
            unitWeight: 8.1,
            shelfLife: 730,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Vegalene Non-GMO Food Release Spray 17 oz. aerosol",
            isControlledSubstance: false
        },
        {
            id: 688457,
            manufacturerItemId: "1000037410",
            universalProductCode: "10080378171509",
            description: "PLZ VGLN OLIV MS PN SPRY 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.19,
            unitWidth: 5.69,
            unitWeight: 8.1,
            shelfLife: 365,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "Vegalene Olive Mist Seasoning Spray 17 oz. aerosol",
            isControlledSubstance: false
        },
        {
            id: 696350,
            manufacturerItemId: "M51484-0000",
            universalProductCode: "20780994992522",
            description: "WLF WFM SEM  BLUEBERRY 12-4 EA",
            unitOfMeasure: "CA",
            unitHeight: 7.31,
            unitWidth: 11.5,
            unitWeight: 12.9,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Signature English Muffin Blueberry 4slv",
            isControlledSubstance: false
        },
        {
            id: 704065,
            manufacturerItemId: "1000038692",
            universalProductCode: "10018687003150",
            description: "PLZ VSE COOKING SPRAY ALL- 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "Versa Essentials All Purpose Pan Spray (Waterbase)",
            isControlledSubstance: false
        },
        {
            id: 711452,
            manufacturerItemId: "4130830007     ",
            universalProductCode: "10041308300079",
            description: "PTC MRZ MFP LASAGNA CHEESE 1-3 LB  ",
            unitOfMeasure: "CA",
            unitHeight: 6.625,
            unitWidth: 10.812,
            unitWeight: 12.732,
            shelfLife: 450,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Marzetti Frozen Pasta Lasagna Cheese Sandwich                                                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 719736,
            manufacturerItemId: "358052",
            universalProductCode: "20074329123256",
            description: "GLR OSN OH SNAP! SASSY BIT 12-3.25",
            unitOfMeasure: "CA",
            unitHeight: 7.4,
            unitWidth: 5.91,
            unitWeight: 3.11,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OH SNAP! Sassy Bites  12/3.25FL oz",
            isControlledSubstance: false
        },
        {
            id: 720240,
            manufacturerItemId: "06767          ",
            universalProductCode: "10052500067677",
            description: "CFS DKS DUKES MAYO OLIVE O 12-18 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.125,
            unitWidth: 9.3125,
            unitWeight: 15.52,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "DUKES OLIVE OIL MAYONNAISE BOTTLE  12 - 18 OZ                                                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 721199,
            manufacturerItemId: "15492",
            universalProductCode: "20664164154920",
            description: "CS1 PT BLU SNRND DSPC 6-10.6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 5.5,
            unitWeight: 4.5,
            shelfLife: 210,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PITA BREAK BLUEBERRY SNACKING ROUNDS DISPLAY CASE  6 - 10.6 OZ",
            isControlledSubstance: false
        },
        {
            id: 727711,
            manufacturerItemId: "08418          ",
            universalProductCode: "10052500084186",
            description: "CSP DKS DUKE'S SIGNATURE S 120-1.5 ",
            unitOfMeasure: "CA",
            unitHeight: 5.125,
            unitWidth: 12.5625,
            unitWeight: 13.74,
            shelfLife: 150,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "DUKES SIGNATURE SAUCE SINGLE SERVE  120 - 1.5 OZ                                                                                                                                  ",
            isControlledSubstance: false
        },
        {
            id: 731143,
            manufacturerItemId: "5001           ",
            universalProductCode: "10087745050016",
            description: "37T 37T CHEESE DANISH 12-14 OZ     ",
            unitOfMeasure: "CA",
            unitHeight: 9.65,
            unitWidth: 13.2283,
            unitWeight: 14.95,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "37TH STREET BAKERY CHEESE DANISH  12 - 14 OZ                                                                                                                                      ",
            isControlledSubstance: false
        },
        {
            id: 731145,
            manufacturerItemId: "5003",
            universalProductCode: "10087745050030",
            description: "37T 37T CHERRY DANISH 12-14 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.65,
            unitWidth: 13.3071,
            unitWeight: 13.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "37TH STREET BAKERY CHERRY DANISH  12 - 14 OZ",
            isControlledSubstance: false
        },
        {
            id: 734280,
            manufacturerItemId: "01-00139",
            universalProductCode: "20815909020844",
            description: "NOO NSY NOOSA MIXED BERRY  6-4.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 2.6,
            unitWidth: 6.6,
            unitWeight: 2,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt mixed berry blended  4.5oz  6/case",
            isControlledSubstance: false
        },
        {
            id: 734287,
            manufacturerItemId: "01-00134",
            universalProductCode: "30815909020452",
            description: "NOO NSY NOOSA YOGHURT LEMO 6-4.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 2.6,
            unitWidth: 6.6,
            unitWeight: 2,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt lemon  4.5oz  6/case",
            isControlledSubstance: false
        },
        {
            id: 734288,
            manufacturerItemId: "01-00135",
            universalProductCode: "30815909020469",
            description: "NOO NSY NOOSA SALTED CARAM 6-4.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 2.6,
            unitWidth: 6.6,
            unitWeight: 2,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt salted caramel  4.5oz  6/case",
            isControlledSubstance: false
        },
        {
            id: 734289,
            manufacturerItemId: "01-00136",
            universalProductCode: "30815909020476",
            description: "NOO NSY NOOSA STRAWBERRY,  6-4.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 2.6,
            unitWidth: 6.6,
            unitWeight: 2,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt strawberry  4.5oz  6/case",
            isControlledSubstance: false
        },
        {
            id: 734290,
            manufacturerItemId: "01-00137",
            universalProductCode: "30815909020483",
            description: "NOO NSY NOOSA VANILLA BEAN 6-4.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 2.6,
            unitWidth: 6.6,
            unitWeight: 2,
            shelfLife: 55,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "noosa yoghurt vanilla bean  4.5oz  6/case",
            isControlledSubstance: false
        },
        {
            id: 735405,
            manufacturerItemId: "00756",
            universalProductCode: "10073608007563",
            description: "CS1 KMS 2LB BEEF SUMMER 16-32 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10,
            unitWidth: 10.375,
            unitWeight: 28.08,
            shelfLife: 270,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "KLEMENT'S BEEF SUMMER SAUSAGE  16 - 32 OZ",
            isControlledSubstance: false
        },
        {
            id: 735407,
            manufacturerItemId: "00757",
            universalProductCode: "10073608007570",
            description: "CS1 KMS G& SSAU 16-2 LB",
            unitOfMeasure: "CA",
            unitHeight: 9.375,
            unitWidth: 9.75,
            unitWeight: 35.2,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "KLEMENT'S GARLIC SUMMER SAUSAGE  16 - 2 LB",
            isControlledSubstance: false
        },
        {
            id: 735412,
            manufacturerItemId: "03819",
            universalProductCode: "10073608038192",
            description: "CS1 KMS JAL SSAU 16-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.5,
            unitWidth: 7.25,
            unitWeight: 13,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "KLEMENT'S JALAPENO SUMMER SAUSAGE  16 - 12 OZ",
            isControlledSubstance: false
        },
        {
            id: 735415,
            manufacturerItemId: "03830          ",
            universalProductCode: "10073608038307",
            description: "CS1 KMS ORI SSAU 16-12 OZ          ",
            unitOfMeasure: "CA",
            unitHeight: 8.5,
            unitWidth: 7.25,
            unitWeight: 13,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "KLEMENT'S ORIGINAL SUMMER SAUSAGE  16 - 12 OZ                                                                                                                                     ",
            isControlledSubstance: false
        },
        {
            id: 738463,
            manufacturerItemId: "2841100431",
            universalProductCode: "30818411001742",
            description: "CS1 MBZ BRY BLSS BWL 6-6.1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.31,
            unitWidth: 5.5,
            unitWeight: 2.99,
            shelfLife: 545,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SAMBAZON BERRY BLISS BOWL  6 - 6.1 OZ",
            isControlledSubstance: false
        },
        {
            id: 739955,
            manufacturerItemId: "1000045201",
            universalProductCode: "60822486227205",
            description: "PLZ EVT EVERLIGHT ORIGINAL 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "EverLight Originals Foods Release W/ Butter Flavor",
            isControlledSubstance: false
        },
        {
            id: 740422,
            manufacturerItemId: "50021",
            universalProductCode: "10860000899229",
            description: "CS1 OA OA ORIGINAL SANDWI 12-6.75 O",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 9.25,
            unitWeight: 6.063,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "OUTER AISLE ORIGINAL SANDWICH THINS  12 - 6.75 OZ",
            isControlledSubstance: false
        },
        {
            id: 740599,
            manufacturerItemId: "14167412",
            universalProductCode: "00704863928135",
            description: "CS1 VMG BLU OT' MFNS 8-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 8.5,
            unitWeight: 7.5,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "VEGGIE MADE GREAT BLUEBERRY OAT MUFFINS  8 - 12 OZ",
            isControlledSubstance: false
        },
        {
            id: 740602,
            manufacturerItemId: "14167312",
            universalProductCode: "00704863928180",
            description: "CS1 VMG CHO MFNS 8-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 8.5,
            unitWeight: 7.5,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "VEGGIE MADE GREAT CHOCOLATE MUFFINS  8 - 12 OZ",
            isControlledSubstance: false
        },
        {
            id: 740609,
            manufacturerItemId: "14155912",
            universalProductCode: "00704863950051",
            description: "CS1 VMG SPINACH EGG WHITE  8-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.5,
            unitWidth: 8.5,
            unitWeight: 7.2,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "VEGGIES MADE GREAT SPINACH & EGG WHITE FRITTATA  8 - 12 OZ",
            isControlledSubstance: false
        },
        {
            id: 740862,
            manufacturerItemId: "1000044781     ",
            universalProductCode: "10080378170229",
            description: "PLZ AFREE FRSPY AER 6-16.5 OZ      ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "Vegalene(R) Allergen Free Food Release 6/16.5 oz. aerosol cans                                                                                                                    ",
            isControlledSubstance: false
        },
        {
            id: 743934,
            manufacturerItemId: "NSB-PBC-035046",
            universalProductCode: "10810031590008",
            description: "CS1 MP MP NUT SEED BAR PB 6-4.92 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.63,
            unitWidth: 5.5,
            unitWeight: 2.52,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "MUNK PACK NUT & SEED BAR PEANUT BUTTER DARK CHOCOLATE  6 - 4.92 OZ",
            isControlledSubstance: false
        },
        {
            id: 745029,
            manufacturerItemId: "1007",
            universalProductCode: "10853687004055",
            description: "CS1 DGN FRT IQFR 8-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.75,
            unitWidth: 6.75,
            unitWeight: 7.05,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "PITAYA PLUS DRAGON FRUIT IQF RETAIL  8 - 12 OZ",
            isControlledSubstance: false
        },
        {
            id: 748687,
            manufacturerItemId: "10578",
            universalProductCode: "10025583004419",
            description: "CS1 TFK TOFURKY - HICKORY  6-5.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.38,
            unitWidth: 5,
            unitWeight: 2.66,
            shelfLife: 150,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "TOFURKY PLANT BASED DELI HICKORY  6 - 5.5 OZ",
            isControlledSubstance: false
        },
        {
            id: 749396,
            manufacturerItemId: "1000045215",
            universalProductCode: "10806795022299",
            description: "PLZ WSK WEST CREEK BAKING  6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 10.19,
            unitWidth: 5.69,
            unitWeight: 8.1,
            shelfLife: 730,
            isHazMat: true,
            temperature: Temperature.Dry,
            hazMatClass: 2,
            longDescription: "West Creek Baking Spray",
            isControlledSubstance: false
        },
        {
            id: 749398,
            manufacturerItemId: "1000045290",
            universalProductCode: "10806795435815",
            description: "PLZ RIL BRILLIANCE PAN & G 6-17 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.98,
            unitWidth: 5.51,
            unitWeight: 7.98,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: "Brilliance Premium Oil High Heat Pan & Grill Spray",
            isControlledSubstance: false
        },
        {
            id: 750734,
            manufacturerItemId: "113229000      ",
            universalProductCode: "10094562132290",
            description: "GMF GML PB BAKED CINNAMON  12-14 OZ",
            unitOfMeasure: "CA",
            unitHeight: 14,
            unitWidth: 9,
            unitWeight: 12.23,
            shelfLife: 186,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "Pillsbury(TM) Retail Bakery Thaw & Sell Baked Cinnamon Rolls Vanilla Icing Naturally Flavored (4ct) 14oz                                                                          ",
            isControlledSubstance: false
        },
        {
            id: 752305,
            manufacturerItemId: "10001",
            universalProductCode: "10025583004495",
            description: "CS1 TFK TOFURKY - SMOKED H 6-5.5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 5,
            unitWeight: 2.66,
            shelfLife: 150,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "TOFURKY PLANT BASED DELI SMOKED HAM  6 - 5.5 OZ",
            isControlledSubstance: false
        },
        {
            id: 752881,
            manufacturerItemId: "877F",
            universalProductCode: "10850012117169",
            description: "CS1 TF1 FRZN WHL STRAW IN  6-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8,
            unitWidth: 7.2,
            unitWeight: 3.5,
            shelfLife: 912,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TRU FRU HYPER-CHILLED GRAB & SHARE WHOLE STRAWBERRIES IN WHITE & MILK CHOCOLATE  6 - 8 OZ",
            isControlledSubstance: false
        },
        {
            id: 752882,
            manufacturerItemId: "876F",
            universalProductCode: "10850012117176",
            description: "CS1 TF1 FRZN BANANA IN PEA 6-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8,
            unitWidth: 7.2,
            unitWeight: 3.5,
            shelfLife: 912,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TRU FRU HYPER-CHILLED GRAB & SHARE BANANAS IN PEANUT BUTTER  6 - 8 OZ",
            isControlledSubstance: false
        },
        {
            id: 752884,
            manufacturerItemId: "880F",
            universalProductCode: "10850241008832",
            description: "CS1 TF1 FRZN WHL RASP IN D 6-8 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8,
            unitWidth: 7.2,
            unitWeight: 3.5,
            shelfLife: 912,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "TRU FRU HYPER-CHILLED GRAB & SHARE WHOLE RASPBERRIES IN WHITE & MILK CHOCOLATE  6 - 8 OZ",
            isControlledSubstance: false
        },
        {
            id: 753262,
            manufacturerItemId: "TPC00002",
            universalProductCode: "20860005208436",
            description: "CS1 PZK THE PIZZA CUPCAKE, 5-11.2 O",
            unitOfMeasure: "CA",
            unitHeight: 9.75,
            unitWidth: 6.75,
            unitWeight: 4.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "THE PIZZA CUPCAKE MARGHERITA  5 - 11.2 OZ",
            isControlledSubstance: false
        },
        {
            id: 753274,
            manufacturerItemId: "8CASPIZ102",
            universalProductCode: "00850011443262",
            description: "CS1 ANZ BANZA CHICKPEA PIZ 8-10.9 O",
            unitOfMeasure: "CA",
            unitHeight: 10.875,
            unitWidth: 10.6875,
            unitWeight: 7.789,
            shelfLife: 489,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "BANZA FOUR CHEESE CHICKPEA PIZZA  8 - 10.9 OZ",
            isControlledSubstance: false
        },
        {
            id: 754568,
            manufacturerItemId: "3373",
            universalProductCode: "10860003223373",
            description: "CS1 OLP OLIPOP STRAWBERRY  6-3.4 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.125,
            unitWidth: 10.875,
            unitWeight: 20.84,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OLIPOP STRAWBERRY VANILLA 6X4PK  6 - 3.4 LB",
            isControlledSubstance: false
        },
        {
            id: 754569,
            manufacturerItemId: "3383           ",
            universalProductCode: "10860003223380",
            description: "CS1 OLP OLIPOP CLASSIC ROO 6-3.4 LB",
            unitOfMeasure: "CA",
            unitHeight: 5.125,
            unitWidth: 10.875,
            unitWeight: 20.84,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OLIPOP CLASSIC ROOT BEER 6X4PK  6 - 3.4 LB                                                                                                                                        ",
            isControlledSubstance: false
        },
        {
            id: 755536,
            manufacturerItemId: "300008052",
            universalProductCode: "10843237005526",
            description: "CS1 EBR CHEDDAR BAY BISCUI 8-11.6 O",
            unitOfMeasure: "CA",
            unitHeight: 8.3,
            unitWidth: 17.1,
            unitWeight: 6.38,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "RED LOBSTER CHEDDAR BAY BISCUIT COD  8 - 11.6 OZ",
            isControlledSubstance: false
        },
        {
            id: 755555,
            manufacturerItemId: "300004695",
            universalProductCode: "20843237008159",
            description: "CS1 CZX PAST CRB BL CLAW 8 8-16 OZ",
            unitOfMeasure: "CA",
            unitHeight: 12.81,
            unitWidth: 3.5,
            unitWeight: 8.8,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "COS PAST CRAB BLEND CLAW COS  8 - 16 OZ",
            isControlledSubstance: false
        },
        {
            id: 756172,
            manufacturerItemId: "881",
            universalProductCode: "10830415008813",
            description: "CS1 FBD SONOMA  GF SUPREME 8-8 EA",
            unitOfMeasure: "CA",
            unitHeight: 6.693,
            unitWidth: 11.102,
            unitWeight: 9.9,
            shelfLife: 279,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "SONOMA FLATBREADS BY DONATOS SONOMA FLATBREADS 10\" GF SUPREME PIZZA  8 - 8 EA",
            isControlledSubstance: false
        },
        {
            id: 756194,
            manufacturerItemId: "005612",
            universalProductCode: "10044276056122",
            description: "IRF ENO RICE PUD 15OZ 6-15 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.875,
            unitWidth: 8.75,
            unitWeight: 6.5,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SENOR RICO RICE PUDDING (4PK3.75OZ)  6 - 15 OZ",
            isControlledSubstance: false
        },
        {
            id: 756195,
            manufacturerItemId: "005610; 008023",
            universalProductCode: "10044276056108",
            description: "IRF ENO CAR FLAN 4PK4OZ 6-16 OZ",
            unitOfMeasure: "CA",
            unitHeight: 4.875,
            unitWidth: 8.75,
            unitWeight: 6.5,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SENOR RICO CARAMEL FLAN  6 - 16 OZ",
            isControlledSubstance: false
        },
        {
            id: 756196,
            manufacturerItemId: "005555         ",
            universalProductCode: "10044276055552",
            description: "IRF ENO GELATIN 12PK3.5OZ 4-42 OZ  ",
            unitOfMeasure: "CA",
            unitHeight: 9.188,
            unitWidth: 9.688,
            unitWeight: 13,
            shelfLife: 180,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "SENOR RICO SENOR RICO GELATIN 4-12PK3.5OZ  4 - 42 OZ                                                                                                                              ",
            isControlledSubstance: false
        },
        {
            id: 756206,
            manufacturerItemId: "005100",
            universalProductCode: "10077718997905",
            description: "IRF TBF TF FS MEDIUM SALSA 6-16 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.75,
            unitWeight: 7,
            shelfLife: 104,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 756261,
            manufacturerItemId: "005103",
            universalProductCode: "10077718998933",
            description: "IRF TBF TF FS MILD SALSA 6 6-16 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.75,
            unitWeight: 7,
            shelfLife: 104,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "TABLA FRESCA FARMSTAND MILD SALSA  6 - 16 OZ",
            isControlledSubstance: false
        },
        {
            id: 756515,
            manufacturerItemId: "263",
            universalProductCode: "10899039002638",
            description: "CS1 FEG BUTTERMILK PANCAKE 8-12.7 O",
            unitOfMeasure: "CA",
            unitHeight: 5.82,
            unitWidth: 9,
            unitWeight: 7.2,
            shelfLife: 547,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 757040,
            manufacturerItemId: "RGFBSS",
            universalProductCode: "20858324006680",
            description: "CS1 RGF REAL GOOD FOODS LO 5-20 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 7.93,
            unitWeight: 7.75,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "THE REAL GOOD FOOD COMPANY SAUSAGE  EGG & CHEDDAR SANDWICH  5 - 20 OZ",
            isControlledSubstance: false
        },
        {
            id: 757045,
            manufacturerItemId: "RGFSCCB        ",
            universalProductCode: "10858324006676",
            description: "CS1 RGF REAL GOOD FOODS LO 6-10 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 6.75,
            unitWidth: 6.5,
            unitWeight: 5.25,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "THE REAL GOOD FOOD COMPANY STUFFED CHICKEN CORDON BLEU  6 - 10 OZ                                                                                                                 ",
            isControlledSubstance: false
        },
        {
            id: 757046,
            manufacturerItemId: "RGFBSB",
            universalProductCode: "20858324006697",
            description: "CS1 RGF REAL GOOD FOODS LO 5-15 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 7.93,
            unitWeight: 6.2,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "THE REAL GOOD FOOD COMPANY BACON  EGG & CHEDDAR SANDWICH  5 - 15 OZ",
            isControlledSubstance: false
        },
        {
            id: 757067,
            manufacturerItemId: "69005",
            universalProductCode: "20850036168038",
            description: "CS1 RGF RGF-CHICKEN NUGGET 6-20 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.88,
            unitWidth: 9.69,
            unitWeight: 8.3,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 757069,
            manufacturerItemId: "75002",
            universalProductCode: "10850017315942",
            description: "CS1 RGF REAL GOOD FOODS BR 8-7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.5,
            unitWidth: 7.19,
            unitWeight: 3.9,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "THE REAL GOOD FOOD COMPANY SAUSAGE  EGG & CHEESE BREAKFAST BOWLS  8 - 7 OZ",
            isControlledSubstance: false
        },
        {
            id: 757071,
            manufacturerItemId: "75003",
            universalProductCode: "10850017315959",
            description: "CS1 RGF REAL GOOD FOODS BR 8-7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.75,
            unitWidth: 7,
            unitWeight: 3.9,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "THE REAL GOOD FOOD COMPANY MEAT LOVERS  EGG & CHEESE BREAKFAST BOWLS  8 - 7 OZ",
            isControlledSubstance: false
        },
        {
            id: 760206,
            manufacturerItemId: "28703          ",
            universalProductCode: "10079900007539",
            description: "CS1 JUR JUST FRUIT-STRAWBE 4-9.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.31,
            unitWidth: 7.31,
            unitWeight: 4.5,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 760264,
            manufacturerItemId: "005428/005151  ",
            universalProductCode: "06077718998008",
            description: "IRF ILR IR FRSH BRUSCHETTA 6-14 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 3.75,
            unitWidth: 9.75,
            unitWeight: 6,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 761909,
            manufacturerItemId: "69007          ",
            universalProductCode: "20850036168052",
            description: "CS1 RGF RGF-CHICKEN TENDER 6-20 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 9.88,
            unitWidth: 9.69,
            unitWeight: 8.3,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 762779,
            manufacturerItemId: "005546         ",
            universalProductCode: "10044276055460",
            description: "IRF ENO RICE PUD 8OZ 12-8 OZ       ",
            unitOfMeasure: "CA",
            unitHeight: 3,
            unitWidth: 10.25,
            unitWeight: 7,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 762943,
            manufacturerItemId: "001835         ",
            universalProductCode: "10047502480517",
            description: "IRF ROJ SALSA CON QUESO 12 6-12 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 2.465,
            unitWidth: 9,
            unitWeight: 6.5,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 762945,
            manufacturerItemId: "001886         ",
            universalProductCode: "10044276018861",
            description: "IRF ROJ LAY DIP - MILD 17O 6-16 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 5.375,
            unitWidth: 6.375,
            unitWeight: 7,
            shelfLife: 50,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 762950,
            manufacturerItemId: "001836         ",
            universalProductCode: "10047502480531",
            description: "IRF ROJ QUESO BLANCO W/ GR 6-12 OZ ",
            unitOfMeasure: "CA",
            unitHeight: 2.465,
            unitWidth: 9,
            unitWeight: 6.5,
            shelfLife: 90,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 764319,
            manufacturerItemId: "300597",
            universalProductCode: "00850048532106",
            description: "CS1 OKI CARROT CAKE 8\" SLI 12-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 3.5,
            unitWidth: 11.5,
            unitWeight: 7.98,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CARLO'S BAKERY INC. 8 INCH CARROT CAKE SLICE  12 - 12 EA",
            isControlledSubstance: false
        },
        {
            id: 764320,
            manufacturerItemId: "300596",
            universalProductCode: "00850048532113",
            description: "CS1 OKI CHOCOLATE FUDGE 8\" 12-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 3.5,
            unitWidth: 11.5,
            unitWeight: 7.4,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CARLO'S BAKERY INC. 8 INCH INDIVIDUALLY PACKAGED CHOCOLATE FUDGE CAKE SLICE  12 - 12 EA",
            isControlledSubstance: false
        },
        {
            id: 764321,
            manufacturerItemId: "300594",
            universalProductCode: "00850048532120",
            description: "CS1 OKI VANILLA RAINBOW 8\" 12-12 EA",
            unitOfMeasure: "CA",
            unitHeight: 3.5,
            unitWidth: 11.5,
            unitWeight: 7.2,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CARLO'S BAKERY INC. 8 INCH INDIVIDUALLY PACKAGED VANILLA RAINBOW CAKE SLICE  12 - 12 EA",
            isControlledSubstance: false
        },
        {
            id: 764538,
            manufacturerItemId: "3DFU29-207121",
            universalProductCode: "10871459001323",
            description: "CS1 DYA DAIYA CHEEZE LOVER 8-15.7 O",
            unitOfMeasure: "CA",
            unitHeight: 13.13,
            unitWidth: 10.85,
            unitWeight: 9.72,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DAIYA CHEESE LOVERS PIZZA  8 - 15.7 OZ",
            isControlledSubstance: false
        },
        {
            id: 764540,
            manufacturerItemId: "3DFU29-215171",
            universalProductCode: "10871459001828",
            description: "CS1 DYA DAIYA SUPREME PIZZ 8-19.4 O",
            unitOfMeasure: "CA",
            unitHeight: 13.13,
            unitWidth: 10.85,
            unitWeight: 11.59,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DAIYA SUPREME PIZZA  8 - 19.4 OZ",
            isControlledSubstance: false
        },
        {
            id: 764541,
            manufacturerItemId: "3DFU29-225311",
            universalProductCode: "10871459001989",
            description: "CS1 MEATLESS PEPPERONI 8-16.7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 13.13,
            unitWidth: 10.85,
            unitWeight: 10.22,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DAIYA MEATLESS PEPPERONI STYLE PIZZA  8 - 16.7 OZ",
            isControlledSubstance: false
        },
        {
            id: 764542,
            manufacturerItemId: "3DFU29-229371",
            universalProductCode: "10871459001996",
            description: "CS1 MEATLESS MEAT LOVE 8-19.1 OZ",
            unitOfMeasure: "CA",
            unitHeight: 13.13,
            unitWidth: 10.85,
            unitWeight: 11.45,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "DAIYA MEATLESS MEAT LOVERS PIZZA  8 - 19.1 OZ",
            isControlledSubstance: false
        },
        {
            id: 765146,
            manufacturerItemId: "72992-35592-000",
            universalProductCode: "10072992355922",
            description: "CS1 AUO 6/4 OZ. DARK CHOC  6-4 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 5,
            unitWeight: 1.9,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Dry,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 765198,
            manufacturerItemId: "26001",
            universalProductCode: "10091428260012",
            description: "CKM OKE EDIBLE COOKIE DOUG 12-170 G",
            unitOfMeasure: "CA",
            unitHeight: 9.25,
            unitWidth: 10.25,
            unitWeight: 5.3,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 766135,
            manufacturerItemId: "988500706000",
            universalProductCode: "10850712007067",
            description: "CS1 WBO BAO, BBQ PORK CPG 8-1 CNT",
            unitOfMeasure: "CA",
            unitHeight: 4.75,
            unitWidth: 11.8,
            unitWeight: 6.5,
            shelfLife: 395,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 766139,
            manufacturerItemId: "988500759600",
            universalProductCode: "10850712007593",
            description: "CS1 WBO BAO, COCONUT CUSTA 8-1 CNT",
            unitOfMeasure: "CA",
            unitHeight: 5.25,
            unitWidth: 12.5,
            unitWeight: 6.5,
            shelfLife: 395,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "WOW BAO COCONUT CUSTARD  8 - 1 CNT",
            isControlledSubstance: false
        },
        {
            id: 766347,
            manufacturerItemId: "7007",
            universalProductCode: "10853687004307",
            description: "CS1 YOF SEEDLESS WATERMELO 8-12 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.75,
            unitWidth: 6.75,
            unitWeight: 7.05,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 766464,
            manufacturerItemId: "4673",
            universalProductCode: "10853687004673",
            description: "CS1 YOF ORGANIC DRAGON FRU 6-6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.75,
            unitWidth: 5.438,
            unitWeight: 3.2,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 766484,
            manufacturerItemId: "28699",
            universalProductCode: "10079900007584",
            description: "CS1 JUR 4/4 PACK JUST FRUI 4-9.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.31,
            unitWidth: 7.31,
            unitWeight: 4.5,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 767123,
            manufacturerItemId: "63528",
            universalProductCode: "10681131403846",
            description: "CS1 QTC EDIBLE COOKIE DOUG 12-6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.25,
            unitWidth: 10.25,
            unitWeight: 5.3,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MARKETSIDE CHOCOLATE CHIP EDIBLE COOKIE DOUGH CUPS  12 - 6 OZ",
            isControlledSubstance: false
        },
        {
            id: 767124,
            manufacturerItemId: "43782",
            universalProductCode: "10681131437827",
            description: "CS1 QTC MARKETSIDE EDBLE C 12-6 OZ",
            unitOfMeasure: "CA",
            unitHeight: 9.25,
            unitWidth: 10.25,
            unitWeight: 5.3,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MARKETSIDE SPRINKLE EDIBLE COOKIE DOUGH CUPS  12 - 6 OZ",
            isControlledSubstance: false
        },
        {
            id: 767361,
            manufacturerItemId: "502F",
            universalProductCode: "10850012117817",
            description: "CS1 YAF FRZN RASPBERRY IN  12-5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.875,
            unitWidth: 7,
            unitWeight: 4.5,
            shelfLife: 912,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 767362,
            manufacturerItemId: "503F",
            universalProductCode: "10850012117800",
            description: "CS1 YAF FRZN STRAWBERRY IN 12-5 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.875,
            unitWidth: 7,
            unitWeight: 4.5,
            shelfLife: 912,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 767389,
            manufacturerItemId: "300601",
            universalProductCode: "10850048532196",
            description: "CS1 OKI EVERY BUDDY'S CHOC 4-4 EA",
            unitOfMeasure: "CA",
            unitHeight: 10.75,
            unitWidth: 7.5,
            unitWeight: 14.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CARLO'S BAKERY INC. 6 INCH EVERY BUDDY'S CHOCOLATE CAKE  4 - 4 EA",
            isControlledSubstance: false
        },
        {
            id: 767391,
            manufacturerItemId: "300600",
            universalProductCode: "10850048532189",
            description: "CS1 OKI EVERY BUDDY'S BIRT 4-4 EA",
            unitOfMeasure: "CA",
            unitHeight: 10.8,
            unitWidth: 7.7,
            unitWeight: 14.5,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CARLO'S BAKERY INC. 6 INCH EVERY BUDDY'S BIRTHDAY CAKE  4 - 4 EA",
            isControlledSubstance: false
        },
        {
            id: 767789,
            manufacturerItemId: "10606541601279",
            universalProductCode: "10606541601279",
            description: "CS1 ML' CAULIFCRSTPIZZA PE 8-10 OZ",
            unitOfMeasure: "CA",
            unitHeight: 12.2,
            unitWidth: 10.4,
            unitWeight: 9,
            shelfLife: 365,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "MILTON'S CRAFT BAKERS UNCURED PEPPERONI PIZZA WITH CAULIFLOWER CRUST  8 - 10 OZ",
            isControlledSubstance: false
        },
        {
            id: 767978,
            manufacturerItemId: "007259",
            universalProductCode: "10044276072597",
            description: "IRF AOH SMKY BACON CRAB DI 6-7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 5.25,
            unitWeight: 3.5,
            shelfLife: 56,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 767979,
            manufacturerItemId: "007264",
            universalProductCode: "10044276072641",
            description: "IRF AOH SEAFOOD SALAD 10OZ 6-10 OZ",
            unitOfMeasure: "CA",
            unitHeight: 3.875,
            unitWidth: 9.75,
            unitWeight: 4.5,
            shelfLife: 50,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 767980,
            manufacturerItemId: "007271",
            universalProductCode: "10044276072719",
            description: "IRF AOH SMKD SALMON DIP 7O 6-7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 5.25,
            unitWeight: 3.5,
            shelfLife: 56,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 767983,
            manufacturerItemId: "007229",
            universalProductCode: "10044276072290",
            description: "IRF AOH CAJUN CRAB DIP 7OZ 6-7 OZ",
            unitOfMeasure: "CA",
            unitHeight: 6.25,
            unitWidth: 5.25,
            unitWeight: 3.5,
            shelfLife: 56,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 768403,
            manufacturerItemId: "03410",
            universalProductCode: "10073608034101",
            description: "CS1 KMS KLEMENT'S SAUSAGE 12-7.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.625,
            unitWidth: 6.5,
            unitWeight: 5.95,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 768404,
            manufacturerItemId: "03411",
            universalProductCode: "10073608034118",
            description: "CS1 KMS KLEMENT'S SAUSAGE 12-7.2 OZ",
            unitOfMeasure: "CA",
            unitHeight: 7.625,
            unitWidth: 6.5,
            unitWeight: 5.95,
            shelfLife: 540,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 768465,
            manufacturerItemId: "002028",
            universalProductCode: "10044276020284",
            description: "IRF LKE TAP PUD 4 LBS 3-4 LB",
            unitOfMeasure: "CA",
            unitHeight: 4.25,
            unitWidth: 9.125,
            unitWeight: 13,
            shelfLife: 60,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 768952,
            manufacturerItemId: "1012",
            universalProductCode: "10860439001019",
            description: "CS1 OLP OLIPOP STRWBRY VAN 12-12 FO",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 8.0625,
            unitWeight: 10.25,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OLIPOP STRAWBERRY VANILLA  12 - 12 FO",
            isControlledSubstance: false
        },
        {
            id: 769083,
            manufacturerItemId: "882193",
            universalProductCode: "10882193014746",
            description: "CS1 CI, NATURE'S PREMIUM F 8-9.2 CN",
            unitOfMeasure: "CA",
            unitHeight: 7.3,
            unitWidth: 7.625,
            unitWeight: 7.5,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CITRAPAC  INC. WILDBERRY FRUIT PEARLS  8 - 9.2 CNT",
            isControlledSubstance: false
        },
        {
            id: 769084,
            manufacturerItemId: "882193",
            universalProductCode: "10882193014760",
            description: "CS1 CI, NATURE'S PREMIUM F 8-9.2 CN",
            unitOfMeasure: "CA",
            unitHeight: 7.3,
            unitWidth: 7.625,
            unitWeight: 7.5,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CITRAPAC  INC. STRAWBERRY BANANA FRUIT PEARLS  8 - 9.2 CNT",
            isControlledSubstance: false
        },
        {
            id: 769085,
            manufacturerItemId: "882193",
            universalProductCode: "10882193014784",
            description: "CS1 CI, NATURE'S PREMIUM F 8-9.2 CN",
            unitOfMeasure: "CA",
            unitHeight: 7.3,
            unitWidth: 7.625,
            unitWeight: 7.5,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "CITRAPAC  INC. STRAWBERRY & CREAM FRUIT PEARLS  8 - 9.2 CNT",
            isControlledSubstance: false
        },
        {
            id: 769453,
            manufacturerItemId: "002006",
            universalProductCode: "10855971002006",
            description: "CS1 JR JR TRADITIONAL BAG 24-1 EA",
            unitOfMeasure: "CA",
            unitHeight: 12.48,
            unitWidth: 13.23,
            unitWeight: 10.45,
            shelfLife: 545,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: "JULIAN'S RECIPE TRADITIONAL BAGUETTE  24 - 1 EA",
            isControlledSubstance: false
        },
        {
            id: 770060,
            manufacturerItemId: "1067",
            universalProductCode: "10860439001064",
            description: "CS1 OLP OLIPOP ROOT BEER 1 12-12 FO",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 8.0625,
            unitWeight: 10.25,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OLIPOP ROOT BEER  12 - 12 FO",
            isControlledSubstance: false
        },
        {
            id: 770062,
            manufacturerItemId: "3390",
            universalProductCode: "30860003223391",
            description: "CS1 OLP OLIPOP CLASSIC GRA 12-12 FO",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 8.0625,
            unitWeight: 10.25,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OLIPOP CLASSIC GRAPE  12 - 12 FO",
            isControlledSubstance: false
        },
        {
            id: 770064,
            manufacturerItemId: "2282",
            universalProductCode: "10850027702282",
            description: "CS1 OLP OLIPOP LEMON LIME  12-12 FO",
            unitOfMeasure: "CA",
            unitHeight: 5,
            unitWidth: 8.0625,
            unitWeight: 10.25,
            shelfLife: 548,
            isHazMat: false,
            temperature: Temperature.Refrigerated,
            hazMatClass: null,
            longDescription: "OLIPOP LEMON LIME  12 - 12 FO",
            isControlledSubstance: false
        },
        {
            id: 770637,
            manufacturerItemId: "69400",
            universalProductCode: "10850049384169",
            description: "CS1 RGF REAL GOOD FOODS CH 6-16.5 O",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 5.875,
            unitWeight: 6.19,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        },
        {
            id: 770638,
            manufacturerItemId: "69401",
            universalProductCode: "10850049384176",
            description: "CS1 RGF REAL GOOD FOODS 3  6-15 OZ",
            unitOfMeasure: "CA",
            unitHeight: 8.25,
            unitWidth: 5.875,
            unitWeight: 5.63,
            shelfLife: 730,
            isHazMat: false,
            temperature: Temperature.Frozen,
            hazMatClass: null,
            longDescription: null,
            isControlledSubstance: false
        }
    ],
    lineItemBarcodes: [
        {
            id: 10,
            lineItemId: 377917,
            barcode: "00880760159602",
            priority: 1
        },
        {
            id: 11,
            lineItemId: 639958,
            barcode: "00038000146886",
            priority: 1
        },
        {
            id: 12,
            lineItemId: 699902,
            barcode: "10037638148450",
            priority: 1
        },
        {
            id: 13,
            lineItemId: 613855,
            barcode: "10823056300019",
            priority: 1
        },
        {
            id: 14,
            lineItemId: 560671,
            barcode: "00086289408966",
            priority: 1
        },
        {
            id: 15,
            lineItemId: 467853,
            barcode: "10049800084329",
            priority: 1
        },
        {
            id: 16,
            lineItemId: 516039,
            barcode: "10075192017669",
            priority: 1
        },
        {
            id: 17,
            lineItemId: 609890,
            barcode: "30616112420301",
            priority: 1
        },
        {
            id: 18,
            lineItemId: 710047,
            barcode: "10041308240016",
            priority: 1
        },
        {
            id: 19,
            lineItemId: 608323,
            barcode: "00075361014706",
            priority: 1
        },
        {
            id: 20,
            lineItemId: 477003,
            barcode: "10072714106672",
            priority: 1
        },
        {
            id: 21,
            lineItemId: 539663,
            barcode: "10072745650090",
            priority: 1
        },
        {
            id: 22,
            lineItemId: 454953,
            barcode: "30076366540086",
            priority: 1
        },
        {
            id: 23,
            lineItemId: 505217,
            barcode: "10013087556787",
            priority: 1
        },
        {
            id: 24,
            lineItemId: 633149,
            barcode: "10749017029815",
            priority: 1
        },
        {
            id: 25,
            lineItemId: 541698,
            barcode: "10039677368028",
            priority: 1
        },
        {
            id: 26,
            lineItemId: 431531,
            barcode: "00044979305124",
            priority: 1
        },
        {
            id: 27,
            lineItemId: 385481,
            barcode: "00028029747898",
            priority: 1
        },
        {
            id: 28,
            lineItemId: 526505,
            barcode: "10073321404021",
            priority: 1
        },
        {
            id: 29,
            lineItemId: 671802,
            barcode: "10012724578021",
            priority: 1
        },
        {
            id: 30,
            lineItemId: 560631,
            barcode: "90002444100301",
            priority: 1
        },
        {
            id: 31,
            lineItemId: 481845,
            barcode: "10094562321069",
            priority: 1
        },
        {
            id: 32,
            lineItemId: 684813,
            barcode: "00023700049551",
            priority: 1
        },
        {
            id: 33,
            lineItemId: 518898,
            barcode: "10814598010009",
            priority: 1
        },
        {
            id: 34,
            lineItemId: 608611,
            barcode: "10046012163194",
            priority: 1
        },
        {
            id: 35,
            lineItemId: 506604,
            barcode: "90022655303025",
            priority: 1
        },
        {
            id: 36,
            lineItemId: 470952,
            barcode: "00049800054196",
            priority: 1
        },
        {
            id: 37,
            lineItemId: 448676,
            barcode: "10075192002122",
            priority: 1
        },
        {
            id: 38,
            lineItemId: 383357,
            barcode: "00880760008078",
            priority: 1
        },
        {
            id: 39,
            lineItemId: 592840,
            barcode: "10072586600308",
            priority: 1
        },
        {
            id: 40,
            lineItemId: 640267,
            barcode: "10018000377326",
            priority: 1
        },
        {
            id: 41,
            lineItemId: 364345,
            barcode: "10013800300338",
            priority: 1
        },
        {
            id: 71159,
            lineItemId: 462080,
            barcode: "30046100001142",
            priority: 1
        },
        {
            id: 248673,
            lineItemId: 462080,
            barcode: "00046100001141",
            priority: 1
        },
        {
            id: 42,
            lineItemId: 642288,
            barcode: "10033547122581",
            priority: 1
        },
        {
            id: 43,
            lineItemId: 536074,
            barcode: "10025753031054",
            priority: 1
        },
        {
            id: 44,
            lineItemId: 695992,
            barcode: "10042636021568",
            priority: 1
        },
        {
            id: 45,
            lineItemId: 565601,
            barcode: "10072180783728",
            priority: 1
        },
        {
            id: 46,
            lineItemId: 702837,
            barcode: "10073435070273",
            priority: 1
        },
        {
            id: 47,
            lineItemId: 557603,
            barcode: "10072180747973",
            priority: 1
        },
        {
            id: 48,
            lineItemId: 468402,
            barcode: "00049800164161",
            priority: 1
        },
        {
            id: 49,
            lineItemId: 403432,
            barcode: "10075361021534",
            priority: 1
        },
        {
            id: 50,
            lineItemId: 663683,
            barcode: "00075361089148",
            priority: 1
        },
        {
            id: 51,
            lineItemId: 505213,
            barcode: "10013087556749",
            priority: 1
        },
        {
            id: 52,
            lineItemId: 682140,
            barcode: "00049578226108",
            priority: 1
        },
        {
            id: 53,
            lineItemId: 411184,
            barcode: "00023700601896",
            priority: 1
        },
        {
            id: 54,
            lineItemId: 683636,
            barcode: "10042636043478",
            priority: 1
        },
        {
            id: 55,
            lineItemId: 671499,
            barcode: "10072745638135",
            priority: 1
        },
        {
            id: 56,
            lineItemId: 11991,
            barcode: "10032100071564",
            priority: 1
        },
        {
            id: 57,
            lineItemId: 349041,
            barcode: "00035367691004",
            priority: 1
        },
        {
            id: 58,
            lineItemId: 467849,
            barcode: "00049800123007",
            priority: 1
        },
        {
            id: 59,
            lineItemId: 44144,
            barcode: "10077589371606",
            priority: 1
        },
        {
            id: 60,
            lineItemId: 468585,
            barcode: "10016362883134",
            priority: 1
        },
        {
            id: 61,
            lineItemId: 520437,
            barcode: "00023700026132",
            priority: 1
        },
        {
            id: 62,
            lineItemId: 448679,
            barcode: "10075192002160",
            priority: 1
        },
        {
            id: 63,
            lineItemId: 685179,
            barcode: "10072714004619",
            priority: 1
        },
        {
            id: 64,
            lineItemId: 364430,
            barcode: "10013800305081",
            priority: 1
        },
        {
            id: 65,
            lineItemId: 633145,
            barcode: "10749017031290",
            priority: 1
        },
        {
            id: 66,
            lineItemId: 677326,
            barcode: "10012724008016",
            priority: 1
        },
        {
            id: 67,
            lineItemId: 532423,
            barcode: "10074624014986",
            priority: 1
        },
        {
            id: 68,
            lineItemId: 688827,
            barcode: "00076598315673",
            priority: 1
        },
        {
            id: 69,
            lineItemId: 358311,
            barcode: "00080939928019",
            priority: 1
        },
        {
            id: 70,
            lineItemId: 441281,
            barcode: "00023700548344",
            priority: 1
        },
        {
            id: 71,
            lineItemId: 354329,
            barcode: "00080939961030",
            priority: 1
        },
        {
            id: 72,
            lineItemId: 388251,
            barcode: "10025753014880",
            priority: 1
        },
        {
            id: 73,
            lineItemId: 409525,
            barcode: "10072714101561",
            priority: 1
        },
        {
            id: 74,
            lineItemId: 633143,
            barcode: "10749017030255",
            priority: 1
        },
        {
            id: 75,
            lineItemId: 366066,
            barcode: "10071068013650",
            priority: 1
        },
        {
            id: 76,
            lineItemId: 535170,
            barcode: "00049578840038",
            priority: 1
        },
        {
            id: 77,
            lineItemId: 664120,
            barcode: "10012724578250",
            priority: 1
        },
        {
            id: 78,
            lineItemId: 560672,
            barcode: "00086289408973",
            priority: 1
        },
        {
            id: 79,
            lineItemId: 406103,
            barcode: "10072714100106",
            priority: 1
        },
        {
            id: 80,
            lineItemId: 726300,
            barcode: "00833282006510",
            priority: 1
        },
        {
            id: 81,
            lineItemId: 639152,
            barcode: "00038000146893",
            priority: 1
        },
        {
            id: 82,
            lineItemId: 344467,
            barcode: "20044979020519",
            priority: 1
        },
        {
            id: 83,
            lineItemId: 654706,
            barcode: "10748734008219",
            priority: 1
        },
        {
            id: 84,
            lineItemId: 517208,
            barcode: "10070247192124",
            priority: 1
        },
        {
            id: 85,
            lineItemId: 400591,
            barcode: "10684476012124",
            priority: 1
        },
        {
            id: 86,
            lineItemId: 601351,
            barcode: "10073994001961",
            priority: 1
        },
        {
            id: 87,
            lineItemId: 1794,
            barcode: "10019025455693",
            priority: 1
        },
        {
            id: 88,
            lineItemId: 487173,
            barcode: "10041622018018",
            priority: 1
        },
        {
            id: 89,
            lineItemId: 505216,
            barcode: "10013087556701",
            priority: 1
        },
        {
            id: 90,
            lineItemId: 710497,
            barcode: "10748162705001",
            priority: 1
        },
        {
            id: 91,
            lineItemId: 478360,
            barcode: "10072714106771",
            priority: 1
        },
        {
            id: 92,
            lineItemId: 639179,
            barcode: "10749017040629",
            priority: 1
        },
        {
            id: 93,
            lineItemId: 664121,
            barcode: "10012724578458",
            priority: 1
        },
        {
            id: 94,
            lineItemId: 623334,
            barcode: "00743672002599",
            priority: 1
        },
        {
            id: 95,
            lineItemId: 556132,
            barcode: "10072714051569",
            priority: 1
        },
        {
            id: 96,
            lineItemId: 539767,
            barcode: "10072745073882",
            priority: 1
        },
        {
            id: 97,
            lineItemId: 683637,
            barcode: "10042636043355",
            priority: 1
        },
        {
            id: 98,
            lineItemId: 523794,
            barcode: "10072586600100",
            priority: 1
        },
        {
            id: 99,
            lineItemId: 518519,
            barcode: "10684476027319",
            priority: 1
        },
        {
            id: 100,
            lineItemId: 528835,
            barcode: "00075361014072",
            priority: 1
        },
        {
            id: 101,
            lineItemId: 446432,
            barcode: "10071007862684",
            priority: 1
        },
        {
            id: 102,
            lineItemId: 673296,
            barcode: "00810818021254",
            priority: 1
        },
        {
            id: 103,
            lineItemId: 539576,
            barcode: "10072745820363",
            priority: 1
        },
        {
            id: 104,
            lineItemId: 567683,
            barcode: "00086478710641",
            priority: 1
        },
        {
            id: 105,
            lineItemId: 564243,
            barcode: "00086478707481",
            priority: 1
        },
        {
            id: 106,
            lineItemId: 341786,
            barcode: "10684476003757",
            priority: 1
        },
        {
            id: 107,
            lineItemId: 532420,
            barcode: "10074624014900",
            priority: 1
        },
        {
            id: 108,
            lineItemId: 365935,
            barcode: "10684476003962",
            priority: 1
        },
        {
            id: 109,
            lineItemId: 535692,
            barcode: "00763719011209",
            priority: 1
        },
        {
            id: 110,
            lineItemId: 344086,
            barcode: "10073321032958",
            priority: 1
        },
        {
            id: 111,
            lineItemId: 360759,
            barcode: "10044979024145",
            priority: 1
        },
        {
            id: 112,
            lineItemId: 403570,
            barcode: "00075361014386",
            priority: 1
        },
        {
            id: 113,
            lineItemId: 590832,
            barcode: "00031400054379",
            priority: 1
        },
        {
            id: 114,
            lineItemId: 562973,
            barcode: "10070041600122",
            priority: 1
        },
        {
            id: 115,
            lineItemId: 659758,
            barcode: "00813993000120",
            priority: 1
        },
        {
            id: 116,
            lineItemId: 640775,
            barcode: "00048200693332",
            priority: 1
        },
        {
            id: 117,
            lineItemId: 375479,
            barcode: "00079821190085",
            priority: 1
        },
        {
            id: 118,
            lineItemId: 589833,
            barcode: "10038483169829",
            priority: 1
        },
        {
            id: 119,
            lineItemId: 404205,
            barcode: "00075278950265",
            priority: 1
        },
        {
            id: 120,
            lineItemId: 726908,
            barcode: "10041308270143",
            priority: 1
        },
        {
            id: 121,
            lineItemId: 388181,
            barcode: "10025753012787",
            priority: 1
        },
        {
            id: 122,
            lineItemId: 449152,
            barcode: "10071007197984",
            priority: 1
        },
        {
            id: 123,
            lineItemId: 631554,
            barcode: "05410811000246",
            priority: 1
        },
        {
            id: 124,
            lineItemId: 50866,
            barcode: "10038057100258",
            priority: 1
        },
        {
            id: 125,
            lineItemId: 411155,
            barcode: "10050665020438",
            priority: 1
        },
        {
            id: 126,
            lineItemId: 411155,
            barcode: "10050665020438",
            priority: 1
        },
        {
            id: 127,
            lineItemId: 539552,
            barcode: "10072745380010",
            priority: 1
        },
        {
            id: 128,
            lineItemId: 658633,
            barcode: "10684476050348",
            priority: 1
        },
        {
            id: 129,
            lineItemId: 446432,
            barcode: "10071007862684",
            priority: 1
        },
        {
            id: 130,
            lineItemId: 699888,
            barcode: "10037638075756",
            priority: 1
        },
        {
            id: 131,
            lineItemId: 349041,
            barcode: "00035367691004",
            priority: 1
        },
        {
            id: 132,
            lineItemId: 669250,
            barcode: "10072714004602",
            priority: 1
        },
        {
            id: 133,
            lineItemId: 532418,
            barcode: "90074624000091",
            priority: 1
        },
        {
            id: 134,
            lineItemId: 568341,
            barcode: "10072745580038",
            priority: 1
        },
        {
            id: 135,
            lineItemId: 426864,
            barcode: "10094562052611",
            priority: 1
        },
        {
            id: 136,
            lineItemId: 473473,
            barcode: "00077782012590",
            priority: 1
        },
        {
            id: 137,
            lineItemId: 580140,
            barcode: "10721931000644",
            priority: 1
        },
        {
            id: 138,
            lineItemId: 583625,
            barcode: "10035493597765",
            priority: 1
        },
        {
            id: 139,
            lineItemId: 366240,
            barcode: "00023700324320",
            priority: 1
        },
        {
            id: 140,
            lineItemId: 472543,
            barcode: "30050665012611",
            priority: 1
        },
        {
            id: 141,
            lineItemId: 344093,
            barcode: "10684476003870",
            priority: 1
        },
        {
            id: 142,
            lineItemId: 353834,
            barcode: "00023700469755",
            priority: 1
        },
        {
            id: 143,
            lineItemId: 341688,
            barcode: "10035493632138",
            priority: 1
        },
        {
            id: 144,
            lineItemId: 524271,
            barcode: "10748734700021",
            priority: 1
        },
        {
            id: 145,
            lineItemId: 568357,
            barcode: "10072745661232",
            priority: 1
        },
        {
            id: 146,
            lineItemId: 477093,
            barcode: "00071398207012",
            priority: 1
        },
        {
            id: 147,
            lineItemId: 569155,
            barcode: "00049800115507",
            priority: 1
        },
        {
            id: 148,
            lineItemId: 566573,
            barcode: "10038034460801",
            priority: 1
        },
        {
            id: 149,
            lineItemId: 546477,
            barcode: "10072714050746",
            priority: 1
        },
        {
            id: 150,
            lineItemId: 707747,
            barcode: "00833735002663",
            priority: 1
        },
        {
            id: 151,
            lineItemId: 491822,
            barcode: "10073321045309",
            priority: 1
        },
        {
            id: 152,
            lineItemId: 703775,
            barcode: "10810020630173",
            priority: 1
        },
        {
            id: 153,
            lineItemId: 161090,
            barcode: "10031200007251",
            priority: 1
        },
        {
            id: 154,
            lineItemId: 676596,
            barcode: "50758108749639",
            priority: 1
        },
        {
            id: 155,
            lineItemId: 448874,
            barcode: "10075192006946",
            priority: 1
        },
        {
            id: 156,
            lineItemId: 599476,
            barcode: "10033547122284",
            priority: 1
        },
        {
            id: 157,
            lineItemId: 640266,
            barcode: "10018000377319",
            priority: 1
        },
        {
            id: 158,
            lineItemId: 560667,
            barcode: "00086289408928",
            priority: 1
        },
        {
            id: 159,
            lineItemId: 556134,
            barcode: "10072714051576",
            priority: 1
        },
        {
            id: 160,
            lineItemId: 560628,
            barcode: "90002444110706",
            priority: 1
        },
        {
            id: 161,
            lineItemId: 471175,
            barcode: "10032100089149",
            priority: 1
        },
        {
            id: 162,
            lineItemId: 506641,
            barcode: "10072714107242",
            priority: 1
        },
        {
            id: 163,
            lineItemId: 403604,
            barcode: "10075361022142",
            priority: 1
        },
        {
            id: 164,
            lineItemId: 532419,
            barcode: "10074624015143",
            priority: 1
        },
        {
            id: 165,
            lineItemId: 341808,
            barcode: "10684476003825",
            priority: 1
        },
        {
            id: 166,
            lineItemId: 403421,
            barcode: "10075361023156",
            priority: 1
        },
        {
            id: 167,
            lineItemId: 646577,
            barcode: "10025753036462",
            priority: 1
        },
        {
            id: 168,
            lineItemId: 50834,
            barcode: "10038057100807",
            priority: 1
        },
        {
            id: 169,
            lineItemId: 504927,
            barcode: "00049800078161",
            priority: 1
        },
        {
            id: 170,
            lineItemId: 532421,
            barcode: "10074624015105",
            priority: 1
        },
        {
            id: 171,
            lineItemId: 505390,
            barcode: "10070057195001",
            priority: 1
        },
        {
            id: 172,
            lineItemId: 690726,
            barcode: "10684476056180",
            priority: 1
        },
        {
            id: 173,
            lineItemId: 607807,
            barcode: "10071068706095",
            priority: 1
        },
        {
            id: 174,
            lineItemId: 488126,
            barcode: "10749017017805",
            priority: 1
        },
        {
            id: 175,
            lineItemId: 32003,
            barcode: "90022655307733",
            priority: 1
        },
        {
            id: 176,
            lineItemId: 548808,
            barcode: "10072180639124",
            priority: 1
        },
        {
            id: 177,
            lineItemId: 608389,
            barcode: "10743672002589",
            priority: 1
        },
        {
            id: 178,
            lineItemId: 399286,
            barcode: "10886105221215",
            priority: 1
        },
        {
            id: 179,
            lineItemId: 545240,
            barcode: "10072586600254",
            priority: 1
        },
        {
            id: 180,
            lineItemId: 584446,
            barcode: "10013087101437",
            priority: 1
        },
        {
            id: 181,
            lineItemId: 681106,
            barcode: "00049800118195",
            priority: 1
        },
        {
            id: 182,
            lineItemId: 563493,
            barcode: "10078976083270",
            priority: 1
        },
        {
            id: 183,
            lineItemId: 699386,
            barcode: "10073435060809",
            priority: 1
        },
        {
            id: 184,
            lineItemId: 366072,
            barcode: "10071068084810",
            priority: 1
        },
        {
            id: 185,
            lineItemId: 613441,
            barcode: "00049800148390",
            priority: 1
        },
        {
            id: 186,
            lineItemId: 409554,
            barcode: "10072714084802",
            priority: 1
        },
        {
            id: 187,
            lineItemId: 360225,
            barcode: "00023700078889",
            priority: 1
        },
        {
            id: 188,
            lineItemId: 59025,
            barcode: "00072564530934",
            priority: 1
        },
        {
            id: 189,
            lineItemId: 353266,
            barcode: "00793577011400",
            priority: 1
        },
        {
            id: 190,
            lineItemId: 353266,
            barcode: "00793577011400",
            priority: 1
        }
    ],
    companies: [
        {
            id: "DC01",
            name: "DOT FOODS - IL",
            address1: "1 Dot Way",
            address2: "",
            city: "Mount Sterling",
            state: "IL",
            zipCode: "62353",
            phone: "8003663687",
            salesContactName: null,
            salesContactPhone: "2177734411",
            salesContactExtension: null,
            isStampedDrRequired: false
        },
        {
            id: "21243901",
            name: "S&L PRODUCE",
            address1: "601 MEDLIN RD                      ",
            address2: "                                   ",
            city: "Walnut Hill",
            state: "IL",
            zipCode: "62893",
            phone: "6185328344",
            salesContactName: "SARAH MARKERT",
            salesContactPhone: "2177734411",
            salesContactExtension: "12691",
            isStampedDrRequired: false
        },
        {
            id: "12592500",
            name: "FARM BOY FOOD SERVICE",
            address1: "2761 N KENTUCKY AVE",
            address2: "PO BOX 996                         ",
            city: "Evansville",
            state: "IN",
            zipCode: "47711",
            phone: "8124255231",
            salesContactName: "HANNAH HOWARD",
            salesContactPhone: "2177734411",
            salesContactExtension: "12382",
            isStampedDrRequired: false
        },
        {
            id: "23508301",
            name: "PFS/PACIFIC NW",
            address1: "19606 NE SAN RAFAEL                ",
            address2: "                                   ",
            city: "Portland",
            state: "OR",
            zipCode: "97230",
            phone: "5036668998",
            salesContactName: "RACHEL STALEY",
            salesContactPhone: "2177734411",
            salesContactExtension: "12057",
            isStampedDrRequired: false
        },
        {
            id: "61242301",
            name: "PACIFIC FOODS OF OR",
            address1: "27255 SW 95TH AVE               ",
            address2: "                                   ",
            city: "Wilsonville",
            state: "OR",
            zipCode: "97070",
            phone: "5036929666",
            salesContactName: null,
            salesContactPhone: "2177734411",
            salesContactExtension: null,
            isStampedDrRequired: false
        },
        {
            id: "02024100",
            name: "S & W WHOLESALE MEATS",
            address1: "18096 OLD COVINGTON HWY            ",
            address2: "PO BOX 279                         ",
            city: "Hammond",
            state: "LA",
            zipCode: "70403",
            phone: "9852775131",
            salesContactName: "JESSICA WRIGHT",
            salesContactPhone: "2177734411",
            salesContactExtension: "12584",
            isStampedDrRequired: false
        },
        {
            id: "12064408",
            name: "PAR-WAY/TRYSON",
            address1: "1025 INTEGRAM DR                   ",
            address2: "PLZ CORP                           ",
            city: "Pacific",
            state: "MO",
            zipCode: "63069",
            phone: "6363349100",
            salesContactName: null,
            salesContactPhone: "2177734411",
            salesContactExtension: null,
            isStampedDrRequired: false
        },
        {
            id: "14012100",
            name: "AWG/ASSOC WHLSLE GROCERS",
            address1: "5000 KANSAS AVE.",
            address2: "",
            city: "KANSAS CITY",
            state: "KS",
            zipCode: "66106",
            phone: null,
            salesContactName: "ASHLEY GYLLSTROM",
            salesContactPhone: "2177734411",
            salesContactExtension: "12143",
            isStampedDrRequired: false
        },
        {
            id: "14012101",
            name: "AWG/KANSAS CITY",
            address1: "5000 KANSAS AVE                    ",
            address2: "                                   ",
            city: "Kansas City",
            state: "KS",
            zipCode: "66106",
            phone: "9132881000",
            salesContactName: "ASHLEY GYLLSTROM",
            salesContactPhone: "2177734411",
            salesContactExtension: "12143",
            isStampedDrRequired: true
        },
        {
            id: "14100002",
            name: "C F SAUER CO",
            address1: "101 PRAIRIE VILLAGE DRIVE          ",
            address2: "CRS WEST                           ",
            city: "NEW CENTURY",
            state: "KS",
            zipCode: "66031",
            phone: "9133243715",
            salesContactName: null,
            salesContactPhone: "2177734411",
            salesContactExtension: null,
            isStampedDrRequired: false
        },
        {
            id: "24016400",
            name: "WALMART CONSIGNMENT/GDC",
            address1: "1 DOT WAY",
            address2: "",
            city: "MT. STERLING",
            state: "IL",
            zipCode: "62353",
            phone: null,
            salesContactName: "TINA JOHNSON",
            salesContactPhone: "2177734411",
            salesContactExtension: "12635",
            isStampedDrRequired: false
        },
        {
            id: "24016414",
            name: "WALMART/GDC #6077",
            address1: "2250 E OUTER RD                    ",
            address2: "                                   ",
            city: "Moberly",
            state: "MO",
            zipCode: "65270",
            phone: "6602694300",
            salesContactName: "TINA JOHNSON",
            salesContactPhone: "2177734411",
            salesContactExtension: "12635",
            isStampedDrRequired: true
        },
        {
            id: "DC01",
            name: "DOT FOODS - IL",
            address1: "1 DOT WAY",
            address2: "",
            city: "Mount Sterling",
            state: "IL",
            zipCode: "62353",
            phone: "8003663687",
            salesContactName: null,
            salesContactPhone: "2177734411",
            salesContactExtension: null,
            isStampedDrRequired: false
        }
    ],
    orderItemChanges: [],
    catchWeights: [
        {
            id: 3,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694054,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.85,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 4,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694055,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.84,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 5,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694056,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.18,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 6,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694057,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 9.89,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 7,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694058,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.5,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 8,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694059,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.95,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 9,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694060,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.57,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 10,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694061,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 9.77,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 11,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694062,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.18,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 12,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694063,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.23,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 13,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694064,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 10.27,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 14,
            aS400StopId: 1,
            sequenceNumber: 88,
            relativeRecordNumber: 176694065,
            refSequence: 88,
            orderItemId: 516688,
            shippedWeight: 11.06,
            lotNumber: "05/27/21",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 1211,
            aS400StopId: 2,
            sequenceNumber: 7,
            relativeRecordNumber: 184136708,
            refSequence: 7,
            orderItemId: 530296,
            shippedWeight: 32.8,
            lotNumber: "37771708",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        },
        {
            id: 1225,
            aS400StopId: 2,
            sequenceNumber: 7,
            relativeRecordNumber: 184136709,
            refSequence: 7,
            orderItemId: 530296,
            shippedWeight: 28.55,
            lotNumber: "37771708",
            adjustedWeight: 0,
            reconcileReasonId: null,
            refusalChoiceId: null,
            refusalComment: null,
            returnSticker: 0,
            noReturnStickerReason: null,
            isVerified: false,
            codeDate: null
        }
    ],
    licensePlates: [
        {
            id: 6844763708115800,
            stopId: 3320,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763708124819,
            stopId: 3320,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763708132890,
            stopId: 3320,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763681600607,
            stopId: 9389,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681592643,
            stopId: 9389,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681600485,
            stopId: 9389,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763675402972,
            stopId: 9389,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681602748,
            stopId: 9389,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681592711,
            stopId: 9387,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681600539,
            stopId: 9387,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681601666,
            stopId: 9387,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763675402958,
            stopId: 9387,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681602885,
            stopId: 9387,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681600102,
            stopId: 9387,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763674010130,
            stopId: 3320,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Dry
        },
        {
            id: 6844763679618416,
            stopId: 3320,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763668584258,
            stopId: 3320,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681085350,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681085978,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681073838,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681076037,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681093058,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763411645779,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681087415,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681086555,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681088931,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763411645786,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681086296,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763580671470,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763580923401,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763625912421,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681087712,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763654501726,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763681086296,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763411645793,
            stopId: 8696,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844763815599265,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763818732812,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763820401737,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763830676026,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763830765751,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763907920717,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763907920748,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763907920809,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844763907938484,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764004438341,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764029108991,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764037668852,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764037668876,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764037668883,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764037668906,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764037668937,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764037668944,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764039529076,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764040447895,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764046195271,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764047049375,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764072056959,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764072205463,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764076644466,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081172671,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081172732,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081172961,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081173456,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081173623,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081176563,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081178949,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081178956,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081182007,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081183783,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081190682,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081194277,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081198510,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081198572,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081198893,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081199340,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.047"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081200626,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081200640,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081201104,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081201265,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081202156,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081203191,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081203436,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081203450,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081203849,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081203887,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081205140,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081207113,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081220358,
            stopId: 2307995,
            verifiedTime: new Date("2023-11-27T14:18:04.05"),
            verifiedMethod: VerifiedMethod.VerifiedMultiple,
            verifiedMultipleReasonCode: 1,
            verifiedMultipleReasonComment: "",
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081408985,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081409579,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081419011,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081419486,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081420024,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Refrigerated
        },
        {
            id: 6844764081433130,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Dry
        },
        {
            id: 6844764081433338,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Dry
        },
        {
            id: 6844764081444716,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081444808,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081445096,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081445119,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081445171,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081445324,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081446130,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081446161,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081446826,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081446901,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081447182,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081447571,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081447618,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081447656,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081448080,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081448097,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081448165,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081449827,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081451721,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081452728,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081456146,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081456573,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081457426,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081457716,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081458003,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081458621,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081460075,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081463762,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        },
        {
            id: 6844764081480226,
            stopId: 2310922,
            verifiedTime: null,
            verifiedMethod: null,
            verifiedMultipleReasonCode: null,
            verifiedMultipleReasonComment: null,
            temperature: Temperature.Frozen
        }
    ],
    licensePlateItems: [
        {
            id: 167588,
            licensePlateId: 6844763708115800,
            lineItemId: 462080,
            shippedQuantity: 15
        },
        {
            id: 167259,
            licensePlateId: 6844763708124819,
            lineItemId: 462080,
            shippedQuantity: 16
        },
        {
            id: 167463,
            licensePlateId: 6844763708132890,
            lineItemId: 462080,
            shippedQuantity: 7
        },
        {
            id: 68390,
            licensePlateId: 6844763681600539,
            lineItemId: 446432,
            shippedQuantity: 10
        },
        {
            id: 68376,
            licensePlateId: 6844763681600485,
            lineItemId: 446432,
            shippedQuantity: 14
        },
        {
            id: 68388,
            licensePlateId: 6844763681600485,
            lineItemId: 673296,
            shippedQuantity: 2
        },
        {
            id: 68410,
            licensePlateId: 6844763681600607,
            lineItemId: 539576,
            shippedQuantity: 3
        },
        {
            id: 68562,
            licensePlateId: 6844763681602748,
            lineItemId: 567683,
            shippedQuantity: 1
        },
        {
            id: 68304,
            licensePlateId: 6844763681592643,
            lineItemId: 564243,
            shippedQuantity: 1
        },
        {
            id: 68399,
            licensePlateId: 6844763681600607,
            lineItemId: 341786,
            shippedQuantity: 2
        },
        {
            id: 68409,
            licensePlateId: 6844763681600607,
            lineItemId: 532420,
            shippedQuantity: 8
        },
        {
            id: 68300,
            licensePlateId: 6844763681592643,
            lineItemId: 365935,
            shippedQuantity: 2
        },
        {
            id: 68402,
            licensePlateId: 6844763681600607,
            lineItemId: 375479,
            shippedQuantity: 2
        },
        {
            id: 68400,
            licensePlateId: 6844763681600607,
            lineItemId: 344086,
            shippedQuantity: 1
        },
        {
            id: 68299,
            licensePlateId: 6844763681592643,
            lineItemId: 360759,
            shippedQuantity: 3
        },
        {
            id: 68546,
            licensePlateId: 6844763681602748,
            lineItemId: 403570,
            shippedQuantity: 1
        },
        {
            id: 68384,
            licensePlateId: 6844763681600485,
            lineItemId: 590832,
            shippedQuantity: 5
        },
        {
            id: 68554,
            licensePlateId: 6844763681602748,
            lineItemId: 562973,
            shippedQuantity: 2
        },
        {
            id: 68386,
            licensePlateId: 6844763681600485,
            lineItemId: 659758,
            shippedQuantity: 4
        },
        {
            id: 68271,
            licensePlateId: 6844763675402972,
            lineItemId: 640775,
            shippedQuantity: 8
        },
        {
            id: 68565,
            licensePlateId: 6844763681602748,
            lineItemId: 589833,
            shippedQuantity: 2
        },
        {
            id: 68609,
            licensePlateId: 6844763681602885,
            lineItemId: 388181,
            shippedQuantity: 5
        },
        {
            id: 68611,
            licensePlateId: 6844763681602885,
            lineItemId: 449152,
            shippedQuantity: 1
        },
        {
            id: 68332,
            licensePlateId: 6844763681600102,
            lineItemId: 404205,
            shippedQuantity: 5
        },
        {
            id: 68396,
            licensePlateId: 6844763681600539,
            lineItemId: 631554,
            shippedQuantity: 2
        },
        {
            id: 68601,
            licensePlateId: 6844763681602885,
            lineItemId: 50866,
            shippedQuantity: 7
        },
        {
            id: 68618,
            licensePlateId: 6844763681602885,
            lineItemId: 565418,
            shippedQuantity: 5
        },
        {
            id: 68619,
            licensePlateId: 6844763681602885,
            lineItemId: 669250,
            shippedQuantity: 10
        },
        {
            id: 68339,
            licensePlateId: 6844763681600102,
            lineItemId: 699888,
            shippedQuantity: 10
        },
        {
            id: 68615,
            licensePlateId: 6844763681602885,
            lineItemId: 532418,
            shippedQuantity: 1
        },
        {
            id: 68307,
            licensePlateId: 6844763681592711,
            lineItemId: 426864,
            shippedQuantity: 5
        },
        {
            id: 68335,
            licensePlateId: 6844763681600102,
            lineItemId: 473473,
            shippedQuantity: 10
        },
        {
            id: 68309,
            licensePlateId: 6844763681592711,
            lineItemId: 580140,
            shippedQuantity: 3
        },
        {
            id: 68394,
            licensePlateId: 6844763681600539,
            lineItemId: 583625,
            shippedQuantity: 5
        },
        {
            id: 68603,
            licensePlateId: 6844763681602885,
            lineItemId: 344093,
            shippedQuantity: 10
        },
        {
            id: 68608,
            licensePlateId: 6844763681602885,
            lineItemId: 366240,
            shippedQuantity: 30
        },
        {
            id: 68448,
            licensePlateId: 6844763681601666,
            lineItemId: 353834,
            shippedQuantity: 22
        },
        {
            id: 68329,
            licensePlateId: 6844763681600102,
            lineItemId: 353834,
            shippedQuantity: 17
        },
        {
            id: 68263,
            licensePlateId: 6844763675402958,
            lineItemId: 341688,
            shippedQuantity: 5
        },
        {
            id: 68337,
            licensePlateId: 6844763681600102,
            lineItemId: 568357,
            shippedQuantity: 10
        },
        {
            id: 68338,
            licensePlateId: 6844763681600102,
            lineItemId: 569155,
            shippedQuantity: 2
        },
        {
            id: 68613,
            licensePlateId: 6844763681602885,
            lineItemId: 477093,
            shippedQuantity: 2
        },
        {
            id: 68267,
            licensePlateId: 6844763675402958,
            lineItemId: 566573,
            shippedQuantity: 10
        },
        {
            id: 68617,
            licensePlateId: 6844763681602885,
            lineItemId: 546477,
            shippedQuantity: 4
        },
        {
            id: 68341,
            licensePlateId: 6844763681600102,
            lineItemId: 707747,
            shippedQuantity: 1
        },
        {
            id: 92,
            licensePlateId: 6844763674010130,
            lineItemId: 161090,
            shippedQuantity: 10
        },
        {
            id: 32349,
            licensePlateId: 6844763679618416,
            lineItemId: 676596,
            shippedQuantity: 12
        },
        {
            id: 32116,
            licensePlateId: 6844763668584258,
            lineItemId: 448874,
            shippedQuantity: 36
        },
        {
            id: 45313,
            licensePlateId: 6844763681085978,
            lineItemId: 599476,
            shippedQuantity: 3
        },
        {
            id: 45436,
            licensePlateId: 6844763681087415,
            lineItemId: 556134,
            shippedQuantity: 1
        },
        {
            id: 45299,
            licensePlateId: 6844763681086555,
            lineItemId: 560667,
            shippedQuantity: 40
        },
        {
            id: 45351,
            licensePlateId: 6844763681085978,
            lineItemId: 506641,
            shippedQuantity: 6
        },
        {
            id: 45475,
            licensePlateId: 6844763411645779,
            lineItemId: 403604,
            shippedQuantity: 6
        },
        {
            id: 45360,
            licensePlateId: 6844763681073838,
            lineItemId: 560628,
            shippedQuantity: 2
        },
        {
            id: 45331,
            licensePlateId: 6844763411645786,
            lineItemId: 532419,
            shippedQuantity: 3
        },
        {
            id: 45294,
            licensePlateId: 6844763411645786,
            lineItemId: 341808,
            shippedQuantity: 1
        },
        {
            id: 45453,
            licensePlateId: 6844763411645779,
            lineItemId: 403421,
            shippedQuantity: 5
        },
        {
            id: 45478,
            licensePlateId: 6844763681093058,
            lineItemId: 646577,
            shippedQuantity: 4
        },
        {
            id: 45271,
            licensePlateId: 6844763580671470,
            lineItemId: 50834,
            shippedQuantity: 1
        },
        {
            id: 45237,
            licensePlateId: 6844763681085350,
            lineItemId: 504927,
            shippedQuantity: 2
        },
        {
            id: 45437,
            licensePlateId: 6844763681093058,
            lineItemId: 505390,
            shippedQuantity: 1
        },
        {
            id: 45254,
            licensePlateId: 6844763411645786,
            lineItemId: 532421,
            shippedQuantity: 10
        },
        {
            id: 45421,
            licensePlateId: 6844763411645779,
            lineItemId: 32003,
            shippedQuantity: 37
        },
        {
            id: 45205,
            licensePlateId: 6844763411645793,
            lineItemId: 32003,
            shippedQuantity: 60
        },
        {
            id: 45469,
            licensePlateId: 6844763681093058,
            lineItemId: 488126,
            shippedQuantity: 4
        },
        {
            id: 45473,
            licensePlateId: 6844763681093058,
            lineItemId: 608389,
            shippedQuantity: 5
        },
        {
            id: 45363,
            licensePlateId: 6844763681085350,
            lineItemId: 545240,
            shippedQuantity: 9
        },
        {
            id: 45434,
            licensePlateId: 6844763654501726,
            lineItemId: 584446,
            shippedQuantity: 1
        },
        {
            id: 45463,
            licensePlateId: 6844763681086555,
            lineItemId: 681106,
            shippedQuantity: 4
        },
        {
            id: 45272,
            licensePlateId: 6844763681085978,
            lineItemId: 699386,
            shippedQuantity: 1
        },
        {
            id: 45499,
            licensePlateId: 6844763411645786,
            lineItemId: 366072,
            shippedQuantity: 10
        },
        {
            id: 45255,
            licensePlateId: 6844763580671470,
            lineItemId: 613441,
            shippedQuantity: 7
        },
        {
            id: 45367,
            licensePlateId: 6844763580671470,
            lineItemId: 548808,
            shippedQuantity: 1
        },
        {
            id: 45386,
            licensePlateId: 6844763580923401,
            lineItemId: 491822,
            shippedQuantity: 13
        },
        {
            id: 45298,
            licensePlateId: 6844763681086296,
            lineItemId: 471175,
            shippedQuantity: 20
        },
        {
            id: 45350,
            licensePlateId: 6844763411645786,
            lineItemId: 360225,
            shippedQuantity: 4
        },
        {
            id: 45394,
            licensePlateId: 6844763681088931,
            lineItemId: 59025,
            shippedQuantity: 16
        },
        {
            id: 45269,
            licensePlateId: 6844763411645786,
            lineItemId: 353266,
            shippedQuantity: 5
        },
        {
            id: 45326,
            licensePlateId: 6844763681093058,
            lineItemId: 383997,
            shippedQuantity: 3
        },
        {
            id: 45338,
            licensePlateId: 6844763411645779,
            lineItemId: 528835,
            shippedQuantity: 6
        },
        {
            id: 45246,
            licensePlateId: 6844763681087712,
            lineItemId: 523794,
            shippedQuantity: 18
        },
        {
            id: 45373,
            licensePlateId: 6844763681085350,
            lineItemId: 683637,
            shippedQuantity: 4
        },
        {
            id: 45487,
            licensePlateId: 6844763654501726,
            lineItemId: 539767,
            shippedQuantity: 5
        },
        {
            id: 45494,
            licensePlateId: 6844763681088931,
            lineItemId: 556132,
            shippedQuantity: 1
        },
        {
            id: 45480,
            licensePlateId: 6844763681073838,
            lineItemId: 664121,
            shippedQuantity: 9
        },
        {
            id: 45329,
            licensePlateId: 6844763681093058,
            lineItemId: 639179,
            shippedQuantity: 4
        },
        {
            id: 45413,
            licensePlateId: 6844763681093058,
            lineItemId: 478360,
            shippedQuantity: 1
        },
        {
            id: 45387,
            licensePlateId: 6844763681085978,
            lineItemId: 710497,
            shippedQuantity: 12
        },
        {
            id: 45325,
            licensePlateId: 6844763681087415,
            lineItemId: 505216,
            shippedQuantity: 2
        },
        {
            id: 45377,
            licensePlateId: 6844763681093058,
            lineItemId: 487173,
            shippedQuantity: 1
        },
        {
            id: 45464,
            licensePlateId: 6844763580671470,
            lineItemId: 1794,
            shippedQuantity: 2
        },
        {
            id: 45465,
            licensePlateId: 6844763411645786,
            lineItemId: 601351,
            shippedQuantity: 3
        },
        {
            id: 45365,
            licensePlateId: 6844763681087415,
            lineItemId: 400591,
            shippedQuantity: 5
        },
        {
            id: 45505,
            licensePlateId: 6844763654501726,
            lineItemId: 409554,
            shippedQuantity: 6
        },
        {
            id: 45483,
            licensePlateId: 6844763681087415,
            lineItemId: 517208,
            shippedQuantity: 2
        },
        {
            id: 45370,
            licensePlateId: 6844763625912421,
            lineItemId: 654706,
            shippedQuantity: 6
        },
        {
            id: 45332,
            licensePlateId: 6844763681085350,
            lineItemId: 344467,
            shippedQuantity: 2
        },
        {
            id: 45288,
            licensePlateId: 6844763580671470,
            lineItemId: 639152,
            shippedQuantity: 1
        },
        {
            id: 45276,
            licensePlateId: 6844763681073838,
            lineItemId: 726300,
            shippedQuantity: 1
        },
        {
            id: 45433,
            licensePlateId: 6844763681088931,
            lineItemId: 406103,
            shippedQuantity: 1
        },
        {
            id: 45210,
            licensePlateId: 6844763681085978,
            lineItemId: 560672,
            shippedQuantity: 24
        },
        {
            id: 45340,
            licensePlateId: 6844763625912421,
            lineItemId: 664120,
            shippedQuantity: 3
        },
        {
            id: 45223,
            licensePlateId: 6844763681085978,
            lineItemId: 535170,
            shippedQuantity: 16
        },
        {
            id: 45445,
            licensePlateId: 6844763625912421,
            lineItemId: 727313,
            shippedQuantity: 27
        },
        {
            id: 45504,
            licensePlateId: 6844763411645786,
            lineItemId: 366066,
            shippedQuantity: 18
        },
        {
            id: 45296,
            licensePlateId: 6844763625912421,
            lineItemId: 409525,
            shippedQuantity: 1
        },
        {
            id: 45484,
            licensePlateId: 6844763681093058,
            lineItemId: 633143,
            shippedQuantity: 10
        },
        {
            id: 45500,
            licensePlateId: 6844763580671470,
            lineItemId: 388251,
            shippedQuantity: 5
        },
        {
            id: 45278,
            licensePlateId: 6844763580671470,
            lineItemId: 354329,
            shippedQuantity: 4
        },
        {
            id: 45501,
            licensePlateId: 6844763580671470,
            lineItemId: 441281,
            shippedQuantity: 10
        },
        {
            id: 45239,
            licensePlateId: 6844763681085978,
            lineItemId: 688827,
            shippedQuantity: 9
        },
        {
            id: 45318,
            licensePlateId: 6844763580671470,
            lineItemId: 358311,
            shippedQuantity: 3
        },
        {
            id: 45490,
            licensePlateId: 6844763625912421,
            lineItemId: 677326,
            shippedQuantity: 2
        },
        {
            id: 45282,
            licensePlateId: 6844763681085350,
            lineItemId: 633145,
            shippedQuantity: 10
        },
        {
            id: 45282,
            licensePlateId: 6844763681085350,
            lineItemId: 633145,
            shippedQuantity: 10
        },
        {
            id: 45388,
            licensePlateId: 6844763681073838,
            lineItemId: 685179,
            shippedQuantity: 1
        },
        {
            id: 45327,
            licensePlateId: 6844763580671470,
            lineItemId: 448679,
            shippedQuantity: 2
        },
        {
            id: 45426,
            licensePlateId: 6844763411645786,
            lineItemId: 520437,
            shippedQuantity: 2
        },
        {
            id: 45470,
            licensePlateId: 6844763411645786,
            lineItemId: 468585,
            shippedQuantity: 3
        },
        {
            id: 45267,
            licensePlateId: 6844763411645786,
            lineItemId: 44144,
            shippedQuantity: 7
        },
        {
            id: 45264,
            licensePlateId: 6844763681087415,
            lineItemId: 467849,
            shippedQuantity: 1
        },
        {
            id: 45259,
            licensePlateId: 6844763580671470,
            lineItemId: 11991,
            shippedQuantity: 1
        },
        {
            id: 45489,
            licensePlateId: 6844763411645786,
            lineItemId: 532423,
            shippedQuantity: 6
        },
        {
            id: 45455,
            licensePlateId: 6844763411645786,
            lineItemId: 411184,
            shippedQuantity: 10
        },
        {
            id: 45251,
            licensePlateId: 6844763681093058,
            lineItemId: 683636,
            shippedQuantity: 1
        },
        {
            id: 45252,
            licensePlateId: 6844763681085978,
            lineItemId: 663683,
            shippedQuantity: 1
        },
        {
            id: 45425,
            licensePlateId: 6844763580923401,
            lineItemId: 403432,
            shippedQuantity: 10
        },
        {
            id: 45222,
            licensePlateId: 6844763580671470,
            lineItemId: 557603,
            shippedQuantity: 3
        },
        {
            id: 45215,
            licensePlateId: 6844763411645779,
            lineItemId: 702837,
            shippedQuantity: 7
        },
        {
            id: 45491,
            licensePlateId: 6844763580671470,
            lineItemId: 536074,
            shippedQuantity: 6
        },
        {
            id: 45407,
            licensePlateId: 6844763681085350,
            lineItemId: 565601,
            shippedQuantity: 17
        },
        {
            id: 45287,
            licensePlateId: 6844763681085350,
            lineItemId: 642288,
            shippedQuantity: 1
        },
        {
            id: 45458,
            licensePlateId: 6844763681085978,
            lineItemId: 640267,
            shippedQuantity: 2
        },
        {
            id: 45417,
            licensePlateId: 6844763411645786,
            lineItemId: 364345,
            shippedQuantity: 5
        },
        {
            id: 45376,
            licensePlateId: 6844763681085350,
            lineItemId: 383357,
            shippedQuantity: 1
        },
        {
            id: 45371,
            licensePlateId: 6844763411645786,
            lineItemId: 592840,
            shippedQuantity: 2
        },
        {
            id: 45303,
            licensePlateId: 6844763580671470,
            lineItemId: 448676,
            shippedQuantity: 2
        },
        {
            id: 45281,
            licensePlateId: 6844763681087415,
            lineItemId: 470952,
            shippedQuantity: 10
        },
        {
            id: 45305,
            licensePlateId: 6844763681085978,
            lineItemId: 506604,
            shippedQuantity: 5
        },
        {
            id: 45357,
            licensePlateId: 6844763681086555,
            lineItemId: 608611,
            shippedQuantity: 3
        },
        {
            id: 45304,
            licensePlateId: 6844763681085350,
            lineItemId: 684813,
            shippedQuantity: 13
        },
        {
            id: 45341,
            licensePlateId: 6844763681085350,
            lineItemId: 481845,
            shippedQuantity: 1
        },
        {
            id: 45201,
            licensePlateId: 6844763681087415,
            lineItemId: 518898,
            shippedQuantity: 2
        },
        {
            id: 45314,
            licensePlateId: 6844763681093058,
            lineItemId: 431531,
            shippedQuantity: 1
        },
        {
            id: 45472,
            licensePlateId: 6844763681086296,
            lineItemId: 526505,
            shippedQuantity: 5
        },
        {
            id: 45440,
            licensePlateId: 6844763681085978,
            lineItemId: 541698,
            shippedQuantity: 1
        },
        {
            id: 45212,
            licensePlateId: 6844763411645786,
            lineItemId: 539663,
            shippedQuantity: 27
        },
        {
            id: 45404,
            licensePlateId: 6844763681088931,
            lineItemId: 477003,
            shippedQuantity: 1
        },
        {
            id: 45451,
            licensePlateId: 6844763681086555,
            lineItemId: 608323,
            shippedQuantity: 8
        },
        {
            id: 45262,
            licensePlateId: 6844763681087415,
            lineItemId: 710047,
            shippedQuantity: 4
        },
        {
            id: 45277,
            licensePlateId: 6844763681085350,
            lineItemId: 609890,
            shippedQuantity: 1
        },
        {
            id: 45476,
            licensePlateId: 6844763681093058,
            lineItemId: 633149,
            shippedQuantity: 5
        },
        {
            id: 45242,
            licensePlateId: 6844763411645779,
            lineItemId: 516039,
            shippedQuantity: 6
        },
        {
            id: 45380,
            licensePlateId: 6844763681076037,
            lineItemId: 467853,
            shippedQuantity: 1
        },
        {
            id: 45435,
            licensePlateId: 6844763681073838,
            lineItemId: 467853,
            shippedQuantity: 1
        },
        {
            id: 45333,
            licensePlateId: 6844763681085350,
            lineItemId: 560671,
            shippedQuantity: 10
        },
        {
            id: 45423,
            licensePlateId: 6844763681085978,
            lineItemId: 613855,
            shippedQuantity: 1
        },
        {
            id: 45488,
            licensePlateId: 6844763681085350,
            lineItemId: 699902,
            shippedQuantity: 1
        },
        {
            id: 45234367,
            licensePlateId: 6844763907920717,
            lineItemId: 767979,
            shippedQuantity: 72
        },
        {
            id: 45234368,
            licensePlateId: 6844763907920748,
            lineItemId: 756194,
            shippedQuantity: 153
        },
        {
            id: 45234369,
            licensePlateId: 6844763907920809,
            lineItemId: 767983,
            shippedQuantity: 108
        },
        {
            id: 45234370,
            licensePlateId: 6844764029108991,
            lineItemId: 731145,
            shippedQuantity: 62
        },
        {
            id: 45234371,
            licensePlateId: 6844764037668852,
            lineItemId: 624089,
            shippedQuantity: 36
        },
        {
            id: 45234372,
            licensePlateId: 6844764037668876,
            lineItemId: 624089,
            shippedQuantity: 36
        },
        {
            id: 45234373,
            licensePlateId: 6844764037668883,
            lineItemId: 624089,
            shippedQuantity: 36
        },
        {
            id: 45234374,
            licensePlateId: 6844764037668906,
            lineItemId: 624089,
            shippedQuantity: 36
        },
        {
            id: 45234375,
            licensePlateId: 6844764037668937,
            lineItemId: 624089,
            shippedQuantity: 36
        },
        {
            id: 45234376,
            licensePlateId: 6844764037668944,
            lineItemId: 624089,
            shippedQuantity: 36
        },
        {
            id: 45234377,
            licensePlateId: 6844764040447895,
            lineItemId: 731143,
            shippedQuantity: 63
        },
        {
            id: 45234378,
            licensePlateId: 6844764047049375,
            lineItemId: 659905,
            shippedQuantity: 36
        },
        {
            id: 45234379,
            licensePlateId: 6844764072205463,
            lineItemId: 441273,
            shippedQuantity: 96
        },
        {
            id: 45234380,
            licensePlateId: 6844764076644466,
            lineItemId: 481852,
            shippedQuantity: 28
        },
        {
            id: 45234381,
            licensePlateId: 6844764081172671,
            lineItemId: 610775,
            shippedQuantity: 34
        },
        {
            id: 45234382,
            licensePlateId: 6844764081172671,
            lineItemId: 628831,
            shippedQuantity: 34
        },
        {
            id: 45234383,
            licensePlateId: 6844764081172671,
            lineItemId: 719736,
            shippedQuantity: 34
        },
        {
            id: 45234384,
            licensePlateId: 6844764081172732,
            lineItemId: 762779,
            shippedQuantity: 28
        },
        {
            id: 45234385,
            licensePlateId: 6844764081172961,
            lineItemId: 646966,
            shippedQuantity: 13
        },
        {
            id: 45234386,
            licensePlateId: 6844764081172961,
            lineItemId: 646979,
            shippedQuantity: 4
        },
        {
            id: 45234387,
            licensePlateId: 6844764081172961,
            lineItemId: 646980,
            shippedQuantity: 13
        },
        {
            id: 45234388,
            licensePlateId: 6844764081172961,
            lineItemId: 646984,
            shippedQuantity: 13
        },
        {
            id: 45234389,
            licensePlateId: 6844764081172961,
            lineItemId: 646992,
            shippedQuantity: 16
        },
        {
            id: 45234390,
            licensePlateId: 6844764081172961,
            lineItemId: 647004,
            shippedQuantity: 13
        },
        {
            id: 45234391,
            licensePlateId: 6844764081172961,
            lineItemId: 647005,
            shippedQuantity: 12
        },
        {
            id: 45234392,
            licensePlateId: 6844764081172961,
            lineItemId: 682785,
            shippedQuantity: 13
        },
        {
            id: 45234393,
            licensePlateId: 6844764081172961,
            lineItemId: 734280,
            shippedQuantity: 28
        },
        {
            id: 45234394,
            licensePlateId: 6844764081172961,
            lineItemId: 734287,
            shippedQuantity: 28
        },
        {
            id: 45234395,
            licensePlateId: 6844764081172961,
            lineItemId: 734288,
            shippedQuantity: 28
        },
        {
            id: 45234396,
            licensePlateId: 6844764081172961,
            lineItemId: 734289,
            shippedQuantity: 28
        },
        {
            id: 45234397,
            licensePlateId: 6844764081172961,
            lineItemId: 734290,
            shippedQuantity: 28
        },
        {
            id: 45234398,
            licensePlateId: 6844764081173456,
            lineItemId: 470094,
            shippedQuantity: 15
        },
        {
            id: 45234399,
            licensePlateId: 6844764081173456,
            lineItemId: 625897,
            shippedQuantity: 10
        },
        {
            id: 45234400,
            licensePlateId: 6844764081173456,
            lineItemId: 756206,
            shippedQuantity: 13
        },
        {
            id: 45234401,
            licensePlateId: 6844764081173456,
            lineItemId: 756261,
            shippedQuantity: 13
        },
        {
            id: 45234402,
            licensePlateId: 6844764081173456,
            lineItemId: 760264,
            shippedQuantity: 13
        },
        {
            id: 45234403,
            licensePlateId: 6844764081173456,
            lineItemId: 762943,
            shippedQuantity: 13
        },
        {
            id: 45234404,
            licensePlateId: 6844764081173456,
            lineItemId: 762950,
            shippedQuantity: 26
        },
        {
            id: 45234405,
            licensePlateId: 6844764081173456,
            lineItemId: 768465,
            shippedQuantity: 39
        },
        {
            id: 45234406,
            licensePlateId: 6844764081173623,
            lineItemId: 643255,
            shippedQuantity: 30
        },
        {
            id: 45234407,
            licensePlateId: 6844764081173623,
            lineItemId: 643264,
            shippedQuantity: 56
        },
        {
            id: 45234408,
            licensePlateId: 6844764081173623,
            lineItemId: 643658,
            shippedQuantity: 20
        },
        {
            id: 45234409,
            licensePlateId: 6844764081176563,
            lineItemId: 756194,
            shippedQuantity: 17
        },
        {
            id: 45234410,
            licensePlateId: 6844764081176563,
            lineItemId: 756195,
            shippedQuantity: 94
        },
        {
            id: 45328996,
            licensePlateId: 6844764072056959,
            lineItemId: 767361,
            shippedQuantity: 90
        },
        {
            id: 45328963,
            licensePlateId: 6844764046195271,
            lineItemId: 752881,
            shippedQuantity: 100
        },
        {
            id: 45328962,
            licensePlateId: 6844764039529076,
            lineItemId: 764538,
            shippedQuantity: 60
        },
        {
            id: 45328961,
            licensePlateId: 6844764004438341,
            lineItemId: 752884,
            shippedQuantity: 100
        },
        {
            id: 45328960,
            licensePlateId: 6844763907938484,
            lineItemId: 754569,
            shippedQuantity: 100
        },
        {
            id: 45328959,
            licensePlateId: 6844763830765751,
            lineItemId: 770064,
            shippedQuantity: 200
        },
        {
            id: 45328997,
            licensePlateId: 6844763830676026,
            lineItemId: 754568,
            shippedQuantity: 100
        },
        {
            id: 45328956,
            licensePlateId: 6844763815599265,
            lineItemId: 770062,
            shippedQuantity: 200
        },
        {
            id: 45234411,
            licensePlateId: 6844764081176563,
            lineItemId: 756196,
            shippedQuantity: 48
        },
        {
            id: 45234412,
            licensePlateId: 6844764081178949,
            lineItemId: 767978,
            shippedQuantity: 72
        },
        {
            id: 45234413,
            licensePlateId: 6844764081178949,
            lineItemId: 767979,
            shippedQuantity: 36
        },
        {
            id: 45234414,
            licensePlateId: 6844764081178949,
            lineItemId: 767980,
            shippedQuantity: 72
        },
        {
            id: 45234415,
            licensePlateId: 6844764081178956,
            lineItemId: 644490,
            shippedQuantity: 17
        },
        {
            id: 45234416,
            licensePlateId: 6844764081178956,
            lineItemId: 644492,
            shippedQuantity: 17
        },
        {
            id: 45234417,
            licensePlateId: 6844764081178956,
            lineItemId: 644510,
            shippedQuantity: 34
        },
        {
            id: 45234418,
            licensePlateId: 6844764081182007,
            lineItemId: 646992,
            shippedQuantity: 10
        },
        {
            id: 45234419,
            licensePlateId: 6844764081183783,
            lineItemId: 762779,
            shippedQuantity: 56
        },
        {
            id: 45234420,
            licensePlateId: 6844764081190682,
            lineItemId: 756196,
            shippedQuantity: 16
        },
        {
            id: 45328958,
            licensePlateId: 6844763820401737,
            lineItemId: 768952,
            shippedQuantity: 200
        },
        {
            id: 45328957,
            licensePlateId: 6844763818732812,
            lineItemId: 770060,
            shippedQuantity: 200
        },
        {
            id: 45234421,
            licensePlateId: 6844764081194277,
            lineItemId: 756195,
            shippedQuantity: 25
        },
        {
            id: 45234422,
            licensePlateId: 6844764081198510,
            lineItemId: 54601,
            shippedQuantity: 2
        },
        {
            id: 45234423,
            licensePlateId: 6844764081198510,
            lineItemId: 402639,
            shippedQuantity: 12
        },
        {
            id: 45234424,
            licensePlateId: 6844764081198510,
            lineItemId: 481852,
            shippedQuantity: 4
        },
        {
            id: 45234425,
            licensePlateId: 6844764081198572,
            lineItemId: 41874,
            shippedQuantity: 22
        },
        {
            id: 45234426,
            licensePlateId: 6844764081198572,
            lineItemId: 41899,
            shippedQuantity: 88
        },
        {
            id: 45234427,
            licensePlateId: 6844764081198572,
            lineItemId: 502120,
            shippedQuantity: 14
        },
        {
            id: 45234428,
            licensePlateId: 6844764081198893,
            lineItemId: 750734,
            shippedQuantity: 20
        },
        {
            id: 45234429,
            licensePlateId: 6844764081199340,
            lineItemId: 454603,
            shippedQuantity: 1
        },
        {
            id: 45234430,
            licensePlateId: 6844764081199340,
            lineItemId: 658185,
            shippedQuantity: 17
        },
        {
            id: 45234431,
            licensePlateId: 6844764081199340,
            lineItemId: 658207,
            shippedQuantity: 9
        },
        {
            id: 45234432,
            licensePlateId: 6844764081200626,
            lineItemId: 41881,
            shippedQuantity: 55
        },
        {
            id: 45234433,
            licensePlateId: 6844764081200626,
            lineItemId: 41917,
            shippedQuantity: 34
        },
        {
            id: 45234434,
            licensePlateId: 6844764081200626,
            lineItemId: 535522,
            shippedQuantity: 35
        },
        {
            id: 45234435,
            licensePlateId: 6844764081200626,
            lineItemId: 677289,
            shippedQuantity: 1
        },
        {
            id: 45234436,
            licensePlateId: 6844764081200640,
            lineItemId: 423806,
            shippedQuantity: 18
        },
        {
            id: 45234437,
            licensePlateId: 6844764081200640,
            lineItemId: 502010,
            shippedQuantity: 18
        },
        {
            id: 45234438,
            licensePlateId: 6844764081200640,
            lineItemId: 562544,
            shippedQuantity: 24
        },
        {
            id: 45234439,
            licensePlateId: 6844764081200640,
            lineItemId: 711452,
            shippedQuantity: 36
        },
        {
            id: 45234440,
            licensePlateId: 6844764081201104,
            lineItemId: 377321,
            shippedQuantity: 17
        },
        {
            id: 45234441,
            licensePlateId: 6844764081201104,
            lineItemId: 377323,
            shippedQuantity: 17
        },
        {
            id: 45234442,
            licensePlateId: 6844764081201104,
            lineItemId: 387365,
            shippedQuantity: 20
        },
        {
            id: 45234443,
            licensePlateId: 6844764081201104,
            lineItemId: 636721,
            shippedQuantity: 17
        },
        {
            id: 45234444,
            licensePlateId: 6844764081201104,
            lineItemId: 676186,
            shippedQuantity: 34
        },
        {
            id: 45234445,
            licensePlateId: 6844764081201104,
            lineItemId: 765198,
            shippedQuantity: 11
        },
        {
            id: 45234446,
            licensePlateId: 6844764081201265,
            lineItemId: 677289,
            shippedQuantity: 48
        },
        {
            id: 45234447,
            licensePlateId: 6844764081202156,
            lineItemId: 386761,
            shippedQuantity: 20
        },
        {
            id: 45234448,
            licensePlateId: 6844764081202156,
            lineItemId: 400779,
            shippedQuantity: 40
        },
        {
            id: 45234449,
            licensePlateId: 6844764081203191,
            lineItemId: 402639,
            shippedQuantity: 12
        },
        {
            id: 45234450,
            licensePlateId: 6844764081203436,
            lineItemId: 41917,
            shippedQuantity: 21
        },
        {
            id: 45234451,
            licensePlateId: 6844764081203450,
            lineItemId: 731145,
            shippedQuantity: 1
        },
        {
            id: 45234452,
            licensePlateId: 6844764081203849,
            lineItemId: 481852,
            shippedQuantity: 10
        },
        {
            id: 45234453,
            licensePlateId: 6844764081203887,
            lineItemId: 696350,
            shippedQuantity: 8
        },
        {
            id: 45234454,
            licensePlateId: 6844764081205140,
            lineItemId: 552414,
            shippedQuantity: 17
        },
        {
            id: 45234455,
            licensePlateId: 6844764081205140,
            lineItemId: 581940,
            shippedQuantity: 24
        },
        {
            id: 45234456,
            licensePlateId: 6844764081205140,
            lineItemId: 615577,
            shippedQuantity: 17
        },
        {
            id: 45234457,
            licensePlateId: 6844764081207113,
            lineItemId: 502010,
            shippedQuantity: 6
        },
        {
            id: 45234458,
            licensePlateId: 6844764081220358,
            lineItemId: 535522,
            shippedQuantity: 15
        },
        {
            id: 45328964,
            licensePlateId: 6844764081408985,
            lineItemId: 735405,
            shippedQuantity: 8
        },
        {
            id: 45328965,
            licensePlateId: 6844764081408985,
            lineItemId: 735407,
            shippedQuantity: 40
        },
        {
            id: 45328966,
            licensePlateId: 6844764081408985,
            lineItemId: 735412,
            shippedQuantity: 25
        },
        {
            id: 45328967,
            licensePlateId: 6844764081408985,
            lineItemId: 768403,
            shippedQuantity: 30
        },
        {
            id: 45328968,
            licensePlateId: 6844764081409579,
            lineItemId: 755555,
            shippedQuantity: 10
        },
        {
            id: 45328969,
            licensePlateId: 6844764081419011,
            lineItemId: 735405,
            shippedQuantity: 32
        },
        {
            id: 45328970,
            licensePlateId: 6844764081419011,
            lineItemId: 735415,
            shippedQuantity: 25
        },
        {
            id: 45328971,
            licensePlateId: 6844764081419011,
            lineItemId: 768404,
            shippedQuantity: 30
        },
        {
            id: 45328972,
            licensePlateId: 6844764081419486,
            lineItemId: 748687,
            shippedQuantity: 144
        },
        {
            id: 45328973,
            licensePlateId: 6844764081419486,
            lineItemId: 752305,
            shippedQuantity: 48
        },
        {
            id: 45328974,
            licensePlateId: 6844764081420024,
            lineItemId: 755555,
            shippedQuantity: 6
        },
        {
            id: 45328975,
            licensePlateId: 6844764081433130,
            lineItemId: 765146,
            shippedQuantity: 46
        },
        {
            id: 45328976,
            licensePlateId: 6844764081433338,
            lineItemId: 743934,
            shippedQuantity: 84
        },
        {
            id: 45328977,
            licensePlateId: 6844764081444716,
            lineItemId: 755536,
            shippedQuantity: 14
        },
        {
            id: 45328978,
            licensePlateId: 6844764081444808,
            lineItemId: 756172,
            shippedQuantity: 12
        },
        {
            id: 45328979,
            licensePlateId: 6844764081445096,
            lineItemId: 764540,
            shippedQuantity: 48
        },
        {
            id: 45328980,
            licensePlateId: 6844764081445119,
            lineItemId: 769453,
            shippedQuantity: 12
        },
        {
            id: 45328981,
            licensePlateId: 6844764081445171,
            lineItemId: 740599,
            shippedQuantity: 32
        },
        {
            id: 45328982,
            licensePlateId: 6844764081445324,
            lineItemId: 753274,
            shippedQuantity: 12
        },
        {
            id: 45328983,
            licensePlateId: 6844764081446130,
            lineItemId: 769085,
            shippedQuantity: 36
        },
        {
            id: 45328984,
            licensePlateId: 6844764081446161,
            lineItemId: 769083,
            shippedQuantity: 36
        },
        {
            id: 45328985,
            licensePlateId: 6844764081446161,
            lineItemId: 769084,
            shippedQuantity: 34
        },
        {
            id: 45328986,
            licensePlateId: 6844764081446826,
            lineItemId: 740602,
            shippedQuantity: 48
        },
        {
            id: 45328987,
            licensePlateId: 6844764081446826,
            lineItemId: 740609,
            shippedQuantity: 96
        },
        {
            id: 45328988,
            licensePlateId: 6844764081446901,
            lineItemId: 764541,
            shippedQuantity: 24
        },
        {
            id: 45328989,
            licensePlateId: 6844764081446901,
            lineItemId: 764542,
            shippedQuantity: 36
        },
        {
            id: 45328990,
            licensePlateId: 6844764081447182,
            lineItemId: 757046,
            shippedQuantity: 20
        },
        {
            id: 45328991,
            licensePlateId: 6844764081447182,
            lineItemId: 757069,
            shippedQuantity: 17
        },
        {
            id: 45328992,
            licensePlateId: 6844764081447182,
            lineItemId: 757071,
            shippedQuantity: 17
        },
        {
            id: 45328993,
            licensePlateId: 6844764081447571,
            lineItemId: 764320,
            shippedQuantity: 19
        },
        {
            id: 45328994,
            licensePlateId: 6844764081447571,
            lineItemId: 764321,
            shippedQuantity: 32
        },
        {
            id: 45328995,
            licensePlateId: 6844764081447571,
            lineItemId: 767391,
            shippedQuantity: 60
        },
        {
            id: 45328998,
            licensePlateId: 6844764081447618,
            lineItemId: 764319,
            shippedQuantity: 32
        },
        {
            id: 45328999,
            licensePlateId: 6844764081447618,
            lineItemId: 767389,
            shippedQuantity: 60
        },
        {
            id: 45329000,
            licensePlateId: 6844764081447656,
            lineItemId: 767124,
            shippedQuantity: 22
        },
        {
            id: 45329001,
            licensePlateId: 6844764081448080,
            lineItemId: 752882,
            shippedQuantity: 65
        },
        {
            id: 45329002,
            licensePlateId: 6844764081448080,
            lineItemId: 767361,
            shippedQuantity: 36
        },
        {
            id: 45329003,
            licensePlateId: 6844764081448097,
            lineItemId: 766135,
            shippedQuantity: 48
        },
        {
            id: 45329004,
            licensePlateId: 6844764081448097,
            lineItemId: 766139,
            shippedQuantity: 24
        },
        {
            id: 45329005,
            licensePlateId: 6844764081448165,
            lineItemId: 721199,
            shippedQuantity: 84
        },
        {
            id: 45329006,
            licensePlateId: 6844764081449827,
            lineItemId: 770637,
            shippedQuantity: 22
        },
        {
            id: 45329007,
            licensePlateId: 6844764081449827,
            lineItemId: 770638,
            shippedQuantity: 22
        },
        {
            id: 45329008,
            licensePlateId: 6844764081451721,
            lineItemId: 769084,
            shippedQuantity: 2
        },
        {
            id: 45329009,
            licensePlateId: 6844764081452728,
            lineItemId: 745029,
            shippedQuantity: 105
        },
        {
            id: 45329010,
            licensePlateId: 6844764081452728,
            lineItemId: 766347,
            shippedQuantity: 20
        },
        {
            id: 45329011,
            licensePlateId: 6844764081452728,
            lineItemId: 766464,
            shippedQuantity: 31
        },
        {
            id: 45329012,
            licensePlateId: 6844764081456146,
            lineItemId: 756515,
            shippedQuantity: 12
        },
        {
            id: 45329013,
            licensePlateId: 6844764081456573,
            lineItemId: 752882,
            shippedQuantity: 15
        },
        {
            id: 45329014,
            licensePlateId: 6844764081457426,
            lineItemId: 767789,
            shippedQuantity: 12
        },
        {
            id: 45329015,
            licensePlateId: 6844764081457716,
            lineItemId: 753262,
            shippedQuantity: 54
        },
        {
            id: 45329016,
            licensePlateId: 6844764081458003,
            lineItemId: 738463,
            shippedQuantity: 93
        },
        {
            id: 45329017,
            licensePlateId: 6844764081458621,
            lineItemId: 740422,
            shippedQuantity: 20
        },
        {
            id: 45329018,
            licensePlateId: 6844764081460075,
            lineItemId: 764320,
            shippedQuantity: 13
        },
        {
            id: 45329019,
            licensePlateId: 6844764081463762,
            lineItemId: 760206,
            shippedQuantity: 75
        },
        {
            id: 45329020,
            licensePlateId: 6844764081463762,
            lineItemId: 766484,
            shippedQuantity: 50
        },
        {
            id: 45329021,
            licensePlateId: 6844764081480226,
            lineItemId: 767123,
            shippedQuantity: 22
        }
    ],
    signatures: [
        {
            id: 638778,
            isSigned: false,
            receiverName: "Paperwork",
            signatureImage: "",
            signedTime: new Date("2023-11-27T15:30:39.9"),
            stopId: 2307995,
            temperatures: ["R", "F"]
        }
    ],
    mispicks: [],
    returnItems: [
        {
            id: 216,
            orderId: 3955,
            lineItemId: 404199,
            customerItemId: "147363",
            returnQuantity: 108,
            countedQuantity: 108,
            weight: 1188,
            cube: 56.24,
            casePallet: 108,
            internalSalesRep: "Jenna Butler",
            internalSalesRepExt: 12677,
            internalSalesRepPhone: "2177734411",
            sequenceNumber: 1,
            verifiedTime: null,
            verifiedMethod: null,
            changeReasonCode: null,
            changeReasonComment: null,
            returnSticker: null,
            reasonForNoSticker: null
        }
    ],
    companyEmails: []
}